/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
import { map, tap } from 'rxjs/operators';

import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
} from "rxjs/operators";
import {
  Observable,
  throwError as _observableThrow,
  of as _observableOf,
} from "rxjs";
import { Injectable, Inject, Optional, InjectionToken } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpResponseBase,
} from "@angular/common/http";

import * as moment from "moment";
import { AppConsts } from "@shared/AppConsts";

export const API_BASE_URL = new InjectionToken<string>("API_BASE_URL");

@Injectable()
export class AccountServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  isTenantAvailable(
    body: IsTenantAvailableInput | undefined
  ): Observable<IsTenantAvailableOutput> {
    let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIsTenantAvailable(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIsTenantAvailable(<any>response_);
            } catch (e) {
              return <Observable<IsTenantAvailableOutput>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<IsTenantAvailableOutput>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processIsTenantAvailable(
    response: HttpResponseBase
  ): Observable<IsTenantAvailableOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IsTenantAvailableOutput.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<IsTenantAvailableOutput>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  register(body: RegisterInput | undefined): Observable<RegisterOutput> {
    let url_ = this.baseUrl + "/api/services/app/Account/Register";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRegister(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRegister(<any>response_);
            } catch (e) {
              return <Observable<RegisterOutput>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<RegisterOutput>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processRegister(
    response: HttpResponseBase
  ): Observable<RegisterOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RegisterOutput.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<RegisterOutput>(<any>null);
  }
}

@Injectable()
export class BranchServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createBranch(body: CreateBranchInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Branch/CreateBranch";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateBranch(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateBranch(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateBranch(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @return Success
   */
  getBranchList(): Observable<BranchDTO[]> {
    let url_ = this.baseUrl + "/api/services/app/Branch/GetBranchList";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBranchList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBranchList(<any>response_);
            } catch (e) {
              return <Observable<BranchDTO[]>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<BranchDTO[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetBranchList(
    response: HttpResponseBase
  ): Observable<BranchDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200.push(BranchDTO.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<BranchDTO[]>(<any>null);
  }

  /**
   * @param loungeId (optional)
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getTablesByFilter(
    loungeId: number | null | undefined,
    page: number | null | undefined,
    pagesize: number | undefined
  ): Observable<TableDtoPageResultDTO> {
    let url_ = this.baseUrl + "/api/services/app/Branch/GetTablesByFilter?";
    if (loungeId !== undefined && loungeId !== null)
      url_ += "LoungeId=" + encodeURIComponent("" + loungeId) + "&";
    if (page !== undefined && page !== null)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pagesize === null)
      throw new Error("The parameter 'pagesize' cannot be null.");
    else if (pagesize !== undefined)
      url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTablesByFilter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTablesByFilter(<any>response_);
            } catch (e) {
              return <Observable<TableDtoPageResultDTO>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<TableDtoPageResultDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetTablesByFilter(
    response: HttpResponseBase
  ): Observable<TableDtoPageResultDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TableDtoPageResultDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TableDtoPageResultDTO>(<any>null);
  }

  /**
   * @param iD (optional)
   * @return Success
   */
  deleteTable(iD: number | undefined): Observable<number> {
    let url_ = this.baseUrl + "/api/services/app/Branch/DeleteTable?";
    if (iD === null) throw new Error("The parameter 'iD' cannot be null.");
    else if (iD !== undefined)
      url_ += "ID=" + encodeURIComponent("" + iD) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteTable(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteTable(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteTable(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * @return Success
   */
  getAllLounges(): Observable<LoungeDtoListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Branch/GetAllLounges";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllLounges(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllLounges(<any>response_);
            } catch (e) {
              return <Observable<LoungeDtoListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<LoungeDtoListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAllLounges(
    response: HttpResponseBase
  ): Observable<LoungeDtoListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LoungeDtoListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<LoungeDtoListResultDto>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addEditTable(body: TableDto | undefined): Observable<TableDto> {
    let url_ = this.baseUrl + "/api/services/app/Branch/AddEditTable";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddEditTable(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddEditTable(<any>response_);
            } catch (e) {
              return <Observable<TableDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<TableDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAddEditTable(
    response: HttpResponseBase
  ): Observable<TableDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TableDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TableDto>(<any>null);
  }
}

@Injectable()
export class CategoryServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getCategoriesAndProducts(
    checkProductCredit?: boolean
  ): Observable<MainProductDataDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Category/GetCategoriesAndProducts";
    url_ = url_.replace(/[?&]$/, "");
    if (checkProductCredit == false) {
      url_ += "?checkProductCredit=" + checkProductCredit;
    }
    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCategoriesAndProducts(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCategoriesAndProducts(<any>response_);
            } catch (e) {
              return <Observable<MainProductDataDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<MainProductDataDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetCategoriesAndProducts(
    response: HttpResponseBase
  ): Observable<MainProductDataDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MainProductDataDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<MainProductDataDto>(<any>null);
  }

  /**
   * @return Success
   */
  getAddOnCategoriesAndProducts(): Observable<RootCategoryDTOListResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Category/GetAddOnCategoriesAndProducts";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAddOnCategoriesAndProducts(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAddOnCategoriesAndProducts(<any>response_);
            } catch (e) {
              return <Observable<RootCategoryDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<RootCategoryDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAddOnCategoriesAndProducts(
    response: HttpResponseBase
  ): Observable<RootCategoryDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RootCategoryDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<RootCategoryDTOListResultDto>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  productSearchByNameorBarcode(
    input: string | null | undefined
  ): Observable<V_ProductDataDTOListResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Category/ProductSearchByNameorBarcode?";
    if (input !== undefined && input !== null)
      url_ += "input=" + encodeURIComponent("" + input) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProductSearchByNameorBarcode(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProductSearchByNameorBarcode(<any>response_);
            } catch (e) {
              return <Observable<V_ProductDataDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<V_ProductDataDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processProductSearchByNameorBarcode(
    response: HttpResponseBase
  ): Observable<V_ProductDataDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = V_ProductDataDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<V_ProductDataDTOListResultDto>(<any>null);
  }

  /**
   * @param productId (optional)
   * @return Success
   */
  getMC_BOMByProductId(
    productId: number | undefined
  ): Observable<MC_BOMContentsDTOListResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Category/GetMC_BOMByProductId?";
    if (productId === null)
      throw new Error("The parameter 'productId' cannot be null.");
    else if (productId !== undefined)
      url_ += "productId=" + encodeURIComponent("" + productId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMC_BOMByProductId(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMC_BOMByProductId(<any>response_);
            } catch (e) {
              return <Observable<MC_BOMContentsDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<MC_BOMContentsDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetMC_BOMByProductId(
    response: HttpResponseBase
  ): Observable<MC_BOMContentsDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MC_BOMContentsDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<MC_BOMContentsDTOListResultDto>(<any>null);
  }
}

@Injectable()
export class ConfigurationServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangeUiTheme(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangeUiTheme(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

@Injectable()
export class CustomerServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getCustomerTypes(): Observable<CustomerTypeDTOListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Customer/GetCustomerTypes";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCustomerTypes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCustomerTypes(<any>response_);
            } catch (e) {
              return <Observable<CustomerTypeDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<CustomerTypeDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetCustomerTypes(
    response: HttpResponseBase
  ): Observable<CustomerTypeDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CustomerTypeDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CustomerTypeDTOListResultDto>(<any>null);
  }
}

@Injectable()
export class DeliveryCompanyServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param id (optional)
   * @param name (optional)
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getDeliveryCompaniesByFilter(
    id: number | null | undefined,
    name: string | null | undefined,
    page: number | null | undefined,
    pagesize: number | undefined
  ): Observable<DeliveryCompanyDtoPageResultDTO> {
    let url_ =
      this.baseUrl +
      "/api/services/app/DeliveryCompany/GetDeliveryCompaniesByFilter?";
    if (id !== undefined && id !== null)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    if (name !== undefined && name !== null)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    if (page !== undefined && page !== null)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pagesize === null)
      throw new Error("The parameter 'pagesize' cannot be null.");
    else if (pagesize !== undefined)
      url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDeliveryCompaniesByFilter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDeliveryCompaniesByFilter(<any>response_);
            } catch (e) {
              return <Observable<DeliveryCompanyDtoPageResultDTO>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<DeliveryCompanyDtoPageResultDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetDeliveryCompaniesByFilter(
    response: HttpResponseBase
  ): Observable<DeliveryCompanyDtoPageResultDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = DeliveryCompanyDtoPageResultDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<DeliveryCompanyDtoPageResultDTO>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addEditDeliveryCompany(
    body: DeliveryCompanyDto | undefined
  ): Observable<DeliveryCompanyDto> {
    let url_ =
      this.baseUrl + "/api/services/app/DeliveryCompany/AddEditDeliveryCompany";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddEditDeliveryCompany(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddEditDeliveryCompany(<any>response_);
            } catch (e) {
              return <Observable<DeliveryCompanyDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<DeliveryCompanyDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processAddEditDeliveryCompany(
    response: HttpResponseBase
  ): Observable<DeliveryCompanyDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = DeliveryCompanyDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<DeliveryCompanyDto>(<any>null);
  }

  /**
   * @param iD (optional)
   * @return Success
   */
  deleteDeliveryCompany(iD: number | undefined): Observable<number> {
    let url_ =
      this.baseUrl + "/api/services/app/DeliveryCompany/DeleteDeliveryCompany?";
    if (iD === null) throw new Error("The parameter 'iD' cannot be null.");
    else if (iD !== undefined)
      url_ += "ID=" + encodeURIComponent("" + iD) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteDeliveryCompany(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteDeliveryCompany(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteDeliveryCompany(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }
}

@Injectable()
export class InvoiceServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createInvoice(body: SalesInvoiceDTO | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateInvoice(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateInvoice(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateInvoice(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

@Injectable()
export class PaymentRevenueServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getpaymentRevenuesDDl(): Observable<PaymentRevenuesTypeDto[]> {
    let url_ =
      this.baseUrl + "/api/services/app/PaymentRevenue/GetpaymentRevenuesDDl";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetpaymentRevenuesDDl(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetpaymentRevenuesDDl(<any>response_);
            } catch (e) {
              return <Observable<PaymentRevenuesTypeDto[]>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PaymentRevenuesTypeDto[]>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetpaymentRevenuesDDl(
    response: HttpResponseBase
  ): Observable<PaymentRevenuesTypeDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200.push(PaymentRevenuesTypeDto.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PaymentRevenuesTypeDto[]>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addEditPaymentRevenue(
    body: PaymentRevenueDto | undefined
  ): Observable<PaymentRevenueDto> {
    let url_ =
      this.baseUrl + "/api/services/app/PaymentRevenue/AddEditPaymentRevenue";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddEditPaymentRevenue(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddEditPaymentRevenue(<any>response_);
            } catch (e) {
              return <Observable<PaymentRevenueDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<PaymentRevenueDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processAddEditPaymentRevenue(
    response: HttpResponseBase
  ): Observable<PaymentRevenueDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PaymentRevenueDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PaymentRevenueDto>(<any>null);
  }

  /**
   * @param typeId (optional)
   * @param fromdate (optional)
   * @param todate (optional)
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getPaymentRevenueListByFilter(
    typeId: number | null | undefined,
    fromdate: moment.Moment | null | undefined,
    todate: moment.Moment | null | undefined,
    page: number | null | undefined,
    pagesize: number | undefined
  ): Observable<PaymentRevenueDtoPageResultDTO> {
    let url_ =
      this.baseUrl +
      "/api/services/app/PaymentRevenue/GetPaymentRevenueListByFilter?";
    if (typeId !== undefined && typeId !== null)
      url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
    if (fromdate !== undefined && fromdate !== null)
      url_ +=
        "fromdate=" +
        encodeURIComponent(fromdate ? "" + fromdate.toJSON() : "") +
        "&";
    if (todate !== undefined && todate !== null)
      url_ +=
        "todate=" +
        encodeURIComponent(todate ? "" + todate.toJSON() : "") +
        "&";
    if (page !== undefined && page !== null)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pagesize === null)
      throw new Error("The parameter 'pagesize' cannot be null.");
    else if (pagesize !== undefined)
      url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPaymentRevenueListByFilter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPaymentRevenueListByFilter(<any>response_);
            } catch (e) {
              return <Observable<PaymentRevenueDtoPageResultDTO>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PaymentRevenueDtoPageResultDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetPaymentRevenueListByFilter(
    response: HttpResponseBase
  ): Observable<PaymentRevenueDtoPageResultDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PaymentRevenueDtoPageResultDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PaymentRevenueDtoPageResultDTO>(<any>null);
  }

  /**
   * @param paymentRevenueID (optional)
   * @return Success
   */
  deletePaymentRevenue(
    paymentRevenueID: number | undefined
  ): Observable<number> {
    let url_ =
      this.baseUrl + "/api/services/app/PaymentRevenue/DeletePaymentRevenue?";
    if (paymentRevenueID === null)
      throw new Error("The parameter 'paymentRevenueID' cannot be null.");
    else if (paymentRevenueID !== undefined)
      url_ +=
        "paymentRevenueID=" + encodeURIComponent("" + paymentRevenueID) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeletePaymentRevenue(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeletePaymentRevenue(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeletePaymentRevenue(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }
}

@Injectable()
export class PointOfSaleDefinitionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getCurrentPOS(): Observable<PointOfSaleDefinitionDTO> {
    let url_ =
      this.baseUrl + "/api/services/app/PointOfSaleDefinition/GetCurrentPOS";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCurrentPOS(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCurrentPOS(<any>response_);
            } catch (e) {
              return <Observable<PointOfSaleDefinitionDTO>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PointOfSaleDefinitionDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetCurrentPOS(
    response: HttpResponseBase
  ): Observable<PointOfSaleDefinitionDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PointOfSaleDefinitionDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PointOfSaleDefinitionDTO>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updatePOSDefinition(
    body: PointOfSaleDefinitionDTO | undefined
  ): Observable<PointOfSaleDefinitionDTO> {
    let url_ =
      this.baseUrl +
      "/api/services/app/PointOfSaleDefinition/UpdatePOSDefinition";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdatePOSDefinition(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdatePOSDefinition(<any>response_);
            } catch (e) {
              return <Observable<PointOfSaleDefinitionDTO>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PointOfSaleDefinitionDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processUpdatePOSDefinition(
    response: HttpResponseBase
  ): Observable<PointOfSaleDefinitionDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PointOfSaleDefinitionDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PointOfSaleDefinitionDTO>(<any>null);
  }

  /**
   * @return Success
   */
  getMonthlyTarget(): Observable<MonthlyTargetDTO> {
    let url_ =
      this.baseUrl + "/api/services/app/PointOfSaleDefinition/GetMonthlyTarget";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMonthlyTarget(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMonthlyTarget(<any>response_);
            } catch (e) {
              return <Observable<MonthlyTargetDTO>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<MonthlyTargetDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  getDailyTarget(): Observable<DailyTargetDTO> {
    let url_ =
      this.baseUrl + "/api/services/app/PointOfSaleDefinition/GetDailyTarget";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDailyTarget(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDailyTarget(<any>response_);
            } catch (e) {
              return <Observable<DailyTargetDTO>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<DailyTargetDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetMonthlyTarget(
    response: HttpResponseBase
  ): Observable<MonthlyTargetDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MonthlyTargetDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<MonthlyTargetDTO>(<any>null);
  }

  protected processGetDailyTarget(
    response: HttpResponseBase
  ): Observable<DailyTargetDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = DailyTargetDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<DailyTargetDTO>(<any>null);
  }
}

@Injectable()
export class POS_UserSettingServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrUpdateUser_setting(
    body: POS_UserSettingDTO | undefined
  ): Observable<void> {
    let url_ =
      this.baseUrl +
      "/api/services/app/POS_UserSetting/CreateOrUpdateUser_setting";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateOrUpdateUser_setting(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateOrUpdateUser_setting(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateOrUpdateUser_setting(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getUserSettingByUserId(
    id: number | undefined
  ): Observable<POS_UserSettingDTO> {
    let url_ =
      this.baseUrl +
      "/api/services/app/POS_UserSetting/GetUserSettingByUserId?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserSettingByUserId(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserSettingByUserId(<any>response_);
            } catch (e) {
              return <Observable<POS_UserSettingDTO>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<POS_UserSettingDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetUserSettingByUserId(
    response: HttpResponseBase
  ): Observable<POS_UserSettingDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = POS_UserSettingDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<POS_UserSettingDTO>(<any>null);
  }
}

@Injectable()
export class ReservationServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getReservationList(): Observable<ReservationDto[]> {
    let url_ =
      this.baseUrl + "/api/services/app/Reservation/GetReservationList";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReservationList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReservationList(<any>response_);
            } catch (e) {
              return <Observable<ReservationDto[]>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<ReservationDto[]>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetReservationList(
    response: HttpResponseBase
  ): Observable<ReservationDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200.push(ReservationDto.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ReservationDto[]>(<any>null);
  }

  /**
   * @param tableId (optional)
   * @param day (optional)
   * @param loungeID (optional)
   * @param clientName (optional)
   * @param clientPhone (optional)
   * @return Success
   */
  getReservationListByFilter(
    tableId: number | null | undefined,
    day: moment.Moment | null | undefined,
    loungeID: number | null | undefined,
    clientName: string | null | undefined,
    clientPhone: string | null | undefined
  ): Observable<ReservationDtoListResultDto> {
    let url_ =
      this.baseUrl +
      "/api/services/app/Reservation/GetReservationListByFilter?";
    if (tableId !== undefined && tableId !== null)
      url_ += "tableId=" + encodeURIComponent("" + tableId) + "&";
    if (day !== undefined && day !== null)
      url_ += "day=" + encodeURIComponent(day ? "" + day.toJSON() : "") + "&";
    if (loungeID !== undefined && loungeID !== null)
      url_ += "LoungeID=" + encodeURIComponent("" + loungeID) + "&";
    if (clientName !== undefined && clientName !== null)
      url_ += "ClientName=" + encodeURIComponent("" + clientName) + "&";
    if (clientPhone !== undefined && clientPhone !== null)
      url_ += "ClientPhone=" + encodeURIComponent("" + clientPhone) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReservationListByFilter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReservationListByFilter(<any>response_);
            } catch (e) {
              return <Observable<ReservationDtoListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ReservationDtoListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetReservationListByFilter(
    response: HttpResponseBase
  ): Observable<ReservationDtoListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReservationDtoListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ReservationDtoListResultDto>(<any>null);
  }

  /**
   * @param tableId (optional)
   * @param day (optional)
   * @param loungeID (optional)
   * @param clientName (optional)
   * @param clientPhone (optional)
   * @param page (optional)
   * @param pagesize (optional)
   * @return Success
   */
  getReservationListByFilterPaginated(
    tableId: number | null | undefined,
    day: moment.Moment | null | undefined,
    loungeID: number | null | undefined,
    clientName: string | null | undefined,
    clientPhone: string | null | undefined,
    page: number | null | undefined,
    pagesize: number | undefined
  ): Observable<ReservationDtoPageResultDTO> {
    let url_ =
      this.baseUrl +
      "/api/services/app/Reservation/GetReservationListByFilterPaginated?";
    if (tableId !== undefined && tableId !== null)
      url_ += "tableId=" + encodeURIComponent("" + tableId) + "&";
    if (day !== undefined && day !== null)
      url_ += "day=" + encodeURIComponent(day ? "" + day.toJSON() : "") + "&";
    if (loungeID !== undefined && loungeID !== null)
      url_ += "LoungeID=" + encodeURIComponent("" + loungeID) + "&";
    if (clientName !== undefined && clientName !== null)
      url_ += "ClientName=" + encodeURIComponent("" + clientName) + "&";
    if (clientPhone !== undefined && clientPhone !== null)
      url_ += "ClientPhone=" + encodeURIComponent("" + clientPhone) + "&";
    if (page !== undefined && page !== null)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pagesize === null)
      throw new Error("The parameter 'pagesize' cannot be null.");
    else if (pagesize !== undefined)
      url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReservationListByFilterPaginated(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReservationListByFilterPaginated(
                <any>response_
              );
            } catch (e) {
              return <Observable<ReservationDtoPageResultDTO>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ReservationDtoPageResultDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetReservationListByFilterPaginated(
    response: HttpResponseBase
  ): Observable<ReservationDtoPageResultDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReservationDtoPageResultDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ReservationDtoPageResultDTO>(<any>null);
  }

  /**
   * @return Success
   */
  getDDl(): Observable<DropdownListDto> {
    let url_ = this.baseUrl + "/api/services/app/Reservation/GetDDl";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDDl(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDDl(<any>response_);
            } catch (e) {
              return <Observable<DropdownListDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<DropdownListDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetDDl(
    response: HttpResponseBase
  ): Observable<DropdownListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = DropdownListDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<DropdownListDto>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addEditReservation(
    body: ReservationDto | undefined
  ): Observable<ReservationDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Reservation/AddEditReservation";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddEditReservation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddEditReservation(<any>response_);
            } catch (e) {
              return <Observable<ReservationDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<ReservationDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processAddEditReservation(
    response: HttpResponseBase
  ): Observable<ReservationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReservationDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ReservationDto>(<any>null);
  }

  /**
   * @param reservationID (optional)
   * @return Success
   */
  deleteReservation(reservationID: number | undefined): Observable<number> {
    let url_ =
      this.baseUrl + "/api/services/app/Reservation/DeleteReservation?";
    if (reservationID === null)
      throw new Error("The parameter 'reservationID' cannot be null.");
    else if (reservationID !== undefined)
      url_ += "reservationID=" + encodeURIComponent("" + reservationID) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteReservation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteReservation(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteReservation(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  checkReservationTimeIntersection(
    body: ReservationDto | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      "/api/services/app/Reservation/CheckReservationTimeIntersection";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckReservationTimeIntersection(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckReservationTimeIntersection(
                <any>response_
              );
            } catch (e) {
              return <Observable<boolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<boolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCheckReservationTimeIntersection(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(<any>null);
  }
}

@Injectable()
export class RoleServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateRoleDto | undefined): Observable<RoleDto> {
    let url_ = this.baseUrl + "/api/services/app/Role/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(<any>response_);
            } catch (e) {
              return <Observable<RoleDto>>(<any>_observableThrow(e));
            }
          } else return <Observable<RoleDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RoleDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<RoleDto>(<any>null);
  }

  /**
   * @param permission (optional)
   * @return Success
   */
  getRoles(
    permission: string | null | undefined
  ): Observable<RoleListDtoListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
    if (permission !== undefined && permission !== null)
      url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRoles(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRoles(<any>response_);
            } catch (e) {
              return <Observable<RoleListDtoListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<RoleListDtoListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetRoles(
    response: HttpResponseBase
  ): Observable<RoleListDtoListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RoleListDtoListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<RoleListDtoListResultDto>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: RoleDto | undefined): Observable<RoleDto> {
    let url_ = this.baseUrl + "/api/services/app/Role/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(<any>response_);
            } catch (e) {
              return <Observable<RoleDto>>(<any>_observableThrow(e));
            }
          } else return <Observable<RoleDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RoleDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<RoleDto>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @return Success
   */
  getAllPermissions(): Observable<PermissionDtoListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllPermissions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllPermissions(<any>response_);
            } catch (e) {
              return <Observable<PermissionDtoListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PermissionDtoListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAllPermissions(
    response: HttpResponseBase
  ): Observable<PermissionDtoListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PermissionDtoListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PermissionDtoListResultDto>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
    let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRoleForEdit(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRoleForEdit(<any>response_);
            } catch (e) {
              return <Observable<GetRoleForEditOutput>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<GetRoleForEditOutput>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetRoleForEdit(
    response: HttpResponseBase
  ): Observable<GetRoleForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetRoleForEditOutput.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetRoleForEditOutput>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<RoleDto> {
    let url_ = this.baseUrl + "/api/services/app/Role/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(<any>response_);
            } catch (e) {
              return <Observable<RoleDto>>(<any>_observableThrow(e));
            }
          } else return <Observable<RoleDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<RoleDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RoleDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<RoleDto>(<any>null);
  }

  /**
   * @param keyword (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | null | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined
  ): Observable<RoleDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
    if (keyword !== undefined && keyword !== null)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(<any>response_);
            } catch (e) {
              return <Observable<RoleDtoPagedResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<RoleDtoPagedResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAll(
    response: HttpResponseBase
  ): Observable<RoleDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RoleDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<RoleDtoPagedResultDto>(<any>null);
  }
}

@Injectable()
export class SessionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
    let url_ =
      this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCurrentLoginInformations(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCurrentLoginInformations(<any>response_);
            } catch (e) {
              return <Observable<GetCurrentLoginInformationsOutput>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<GetCurrentLoginInformationsOutput>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetCurrentLoginInformations(
    response: HttpResponseBase
  ): Observable<GetCurrentLoginInformationsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetCurrentLoginInformationsOutput>(<any>null);
  }
}

@Injectable()
export class SharedShiftServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getPaymentMethods(): Observable<PaymentMethodDTOListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/SharedShift/GetPaymentMethods";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPaymentMethods(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPaymentMethods(<any>response_);
            } catch (e) {
              return <Observable<PaymentMethodDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PaymentMethodDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetPaymentMethods(
    response: HttpResponseBase
  ): Observable<PaymentMethodDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PaymentMethodDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PaymentMethodDTOListResultDto>(<any>null);
  }

  /**
   * @return Success
   */
  getDiscountBonus(): Observable<DiscountBonusDTOListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/SharedShift/GetDiscountBonus";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDiscountBonus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDiscountBonus(<any>response_);
            } catch (e) {
              return <Observable<DiscountBonusDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<DiscountBonusDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetDiscountBonus(
    response: HttpResponseBase
  ): Observable<DiscountBonusDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = DiscountBonusDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<DiscountBonusDTOListResultDto>(<any>null);
  }

  /**
   * @return Success
   */
  getCM_BanksByCompanySNId(): Observable<CM_BanksDTOListResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/SharedShift/GetCM_BanksByCompanySNId";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCM_BanksByCompanySNId(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCM_BanksByCompanySNId(<any>response_);
            } catch (e) {
              return <Observable<CM_BanksDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<CM_BanksDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetCM_BanksByCompanySNId(
    response: HttpResponseBase
  ): Observable<CM_BanksDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CM_BanksDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CM_BanksDTOListResultDto>(<any>null);
  }

  /**
   * @return Success
   */
  getCM_BanksByPerson(): Observable<CM_BanksDTOListResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/SharedShift/GetCM_BanksByPerson";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCM_BanksByPerson(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCM_BanksByPerson(<any>response_);
            } catch (e) {
              return <Observable<CM_BanksDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<CM_BanksDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetCM_BanksByPerson(
    response: HttpResponseBase
  ): Observable<CM_BanksDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CM_BanksDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CM_BanksDTOListResultDto>(<any>null);
  }

  /**
   * @return Success
   */
  getPersons(): Observable<PersonDTOListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/SharedShift/GetPersons";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPersons(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPersons(<any>response_);
            } catch (e) {
              return <Observable<PersonDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PersonDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetPersons(
    response: HttpResponseBase
  ): Observable<PersonDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PersonDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PersonDTOListResultDto>(<any>null);
  }

  /**
   * @return Success
   */
  getPrintTemplateData(): Observable<PrintTemplateDataDTO> {
    let url_ =
      this.baseUrl + "/api/services/app/SharedShift/GetPrintTemplateData";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPrintTemplateData(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPrintTemplateData(<any>response_);
            } catch (e) {
              return <Observable<PrintTemplateDataDTO>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PrintTemplateDataDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetPrintTemplateData(
    response: HttpResponseBase
  ): Observable<PrintTemplateDataDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PrintTemplateDataDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PrintTemplateDataDTO>(<any>null);
  }

  /**
   * @return Success
   */
  getAllTaxes(): Observable<TaxDTOListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/SharedShift/GetAllTaxes";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllTaxes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllTaxes(<any>response_);
            } catch (e) {
              return <Observable<TaxDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<TaxDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAllTaxes(
    response: HttpResponseBase
  ): Observable<TaxDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TaxDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TaxDTOListResultDto>(<any>null);
  }

  /**
   * @return Success
   */
  getCurrentPosTaxId(): Observable<number> {
    let url_ =
      this.baseUrl + "/api/services/app/SharedShift/GetCurrentPosTaxId";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCurrentPosTaxId(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCurrentPosTaxId(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetCurrentPosTaxId(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * @return Success
   */
  getCurrentPosTax(): Observable<TaxDTO> {
    let url_ = this.baseUrl + "/api/services/app/SharedShift/GetCurrentPosTax";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCurrentPosTax(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCurrentPosTax(<any>response_);
            } catch (e) {
              return <Observable<TaxDTO>>(<any>_observableThrow(e));
            }
          } else return <Observable<TaxDTO>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetCurrentPosTax(
    response: HttpResponseBase
  ): Observable<TaxDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TaxDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TaxDTO>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  updatePOSTaxId(id: number | undefined): Observable<number> {
    let url_ = this.baseUrl + "/api/services/app/SharedShift/UpdatePOSTaxId?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdatePOSTaxId(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdatePOSTaxId(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdatePOSTaxId(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * @return Success
   */
  getAllGOVERNRATE(): Observable<GOVERNRATEDTOListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/SharedShift/GetAllGOVERNRATE";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllGOVERNRATE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllGOVERNRATE(<any>response_);
            } catch (e) {
              return <Observable<GOVERNRATEDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<GOVERNRATEDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAllGOVERNRATE(
    response: HttpResponseBase
  ): Observable<GOVERNRATEDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GOVERNRATEDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GOVERNRATEDTOListResultDto>(<any>null);
  }

  /**
   * @return Success
   */
  getCM_SuppliersClients(): Observable<CM_SuppliersClientsDTOListResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/SharedShift/GetCM_SuppliersClients";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCM_SuppliersClients(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCM_SuppliersClients(<any>response_);
            } catch (e) {
              return <Observable<CM_SuppliersClientsDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<CM_SuppliersClientsDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetCM_SuppliersClients(
    response: HttpResponseBase
  ): Observable<CM_SuppliersClientsDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CM_SuppliersClientsDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CM_SuppliersClientsDTOListResultDto>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addNewClient(body: AddNewClientDTO | undefined): Observable<number> {
    let url_ = this.baseUrl + "/api/services/app/SharedShift/AddNewClient";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddNewClient(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddNewClient(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAddNewClient(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateClient(body: CM_SuppliersClientsDTO | undefined): Observable<number> {
    let url_ = this.baseUrl + "/api/services/app/SharedShift/UpdateClient";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateClient(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateClient(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateClient(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }
  updatevoucher(body: VoucherDTO | undefined): Observable<number> {
    let url_ = this.baseUrl + "/api/services/app/Shift/UpdateVoucher";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdatevoucher(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdatevoucher(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }
  protected processUpdatevoucher(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }
  /**
   * @param id (optional)
   * @return Success
   */
  deactviteClient(id: number | undefined): Observable<number> {
    let url_ = this.baseUrl + "/api/services/app/SharedShift/DeactviteClient?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeactviteClient(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeactviteClient(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeactviteClient(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }
}

@Injectable()
export class ShiftServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getPOSHavingStocks(): Observable<PointOfSaleDefinitionDTOListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Shift/GetPOSHavingStocks";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPOSHavingStocks(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPOSHavingStocks(<any>response_);
            } catch (e) {
              return <Observable<PointOfSaleDefinitionDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PointOfSaleDefinitionDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetPOSHavingStocks(
    response: HttpResponseBase
  ): Observable<PointOfSaleDefinitionDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PointOfSaleDefinitionDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PointOfSaleDefinitionDTOListResultDto>(<any>null);
  }

  /**
   * @return Success
   */
  getPOSHavingStocksByPerson(): Observable<PointOfSaleDefinitionDTOListResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Shift/GetPOSHavingStocksByPerson";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPOSHavingStocksByPerson(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPOSHavingStocksByPerson(<any>response_);
            } catch (e) {
              return <Observable<PointOfSaleDefinitionDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PointOfSaleDefinitionDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetPOSHavingStocksByPerson(
    response: HttpResponseBase
  ): Observable<PointOfSaleDefinitionDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PointOfSaleDefinitionDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PointOfSaleDefinitionDTOListResultDto>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  recievingBank(
    body: CreateRecievingBankDetailsDTO | undefined
  ): Observable<CompositeDTO> {
    let url_ = this.baseUrl + "/api/services/app/Shift/RecievingBank";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRecievingBank(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRecievingBank(<any>response_);
            } catch (e) {
              return <Observable<CompositeDTO>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<CompositeDTO>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRecievingBank(
    response: HttpResponseBase
  ): Observable<CompositeDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CompositeDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CompositeDTO>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  deliveringBank(
    body: CreateDeliveringBankDetailsDTO | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Shift/DeliveringBank";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeliveringBank(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeliveringBank(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeliveringBank(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createVoucher(body: CreateVoucherDTO | undefined): Observable<VoucherDTO> {
    let url_ = this.baseUrl + "/api/services/app/Shift/CreateVoucher";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateVoucher(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateVoucher(<any>response_);
            } catch (e) {
              return <Observable<VoucherDTO>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<VoucherDTO>>(<any>_observableThrow(response_));
        })
      );
  }

  createReturnVoucherWithoutInvoice(
    body: CreateVoucherDTO | undefined
  ): Observable<VoucherDTO> {
    let url_ =
      this.baseUrl +
      "/api/services/app/Shift/CreateReturnVoucherWithoutInvoice";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateVoucher(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateVoucher(<any>response_);
            } catch (e) {
              return <Observable<VoucherDTO>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<VoucherDTO>>(<any>_observableThrow(response_));
        })
      );
  }
  protected processCreateVoucher(
    response: HttpResponseBase
  ): Observable<VoucherDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = VoucherDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<VoucherDTO>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createReturnsVoucher(
    body: CreateReturnsVoucherDTO | undefined
  ): Observable<number> {
    let url_ = this.baseUrl + "/api/services/app/Shift/CreateReturnsVoucher";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateReturnsVoucher(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateReturnsVoucher(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateReturnsVoucher(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * @param voucherID (optional)
   * @return Success
   */
  getPrintVoucherData(
    voucherID: number | undefined
  ): Observable<PrintVoucherDTO> {
    let url_ = this.baseUrl + "/api/services/app/Shift/GetPrintVoucherData?";
    if (voucherID === null)
      throw new Error("The parameter 'voucherID' cannot be null.");
    else if (voucherID !== undefined)
      url_ += "voucherID=" + encodeURIComponent("" + voucherID) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPrintVoucherData(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPrintVoucherData(<any>response_);
            } catch (e) {
              return <Observable<PrintVoucherDTO>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<PrintVoucherDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetPrintVoucherData(
    response: HttpResponseBase
  ): Observable<PrintVoucherDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PrintVoucherDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PrintVoucherDTO>(<any>null);
  }

  /**
   * @param voucherID (optional)
   * @return Success
   */
  getVoucherDataById(voucherID: number | undefined): Observable<VoucherDTO> {
    let url_ = this.baseUrl + "/api/services/app/Shift/GetVoucherDataById?";
    if (voucherID === null)
      throw new Error("The parameter 'voucherID' cannot be null.");
    else if (voucherID !== undefined)
      url_ += "voucherID=" + encodeURIComponent("" + voucherID) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVoucherDataById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVoucherDataById(<any>response_);
            } catch (e) {
              return <Observable<VoucherDTO>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<VoucherDTO>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetVoucherDataById(
    response: HttpResponseBase
  ): Observable<VoucherDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = VoucherDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<VoucherDTO>(<any>null);
  }

  /**
   * @param shiftCashierid (optional)
   * @return Success
   */
  getAllVoucherByShift(
    shiftCashierid: number | undefined
  ): Observable<VoucherDTOListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Shift/GetAllVoucherByShift?";
    if (shiftCashierid === null)
      throw new Error("The parameter 'shiftCashierid' cannot be null.");
    else if (shiftCashierid !== undefined)
      url_ += "ShiftCashierid=" + encodeURIComponent("" + shiftCashierid) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllVoucherByShift(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllVoucherByShift(<any>response_);
            } catch (e) {
              return <Observable<VoucherDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<VoucherDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAllVoucherByShift(
    response: HttpResponseBase
  ): Observable<VoucherDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = VoucherDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<VoucherDTOListResultDto>(<any>null);
  }

  /**
   * @param shiftCashierid (optional)
   * @return Success
   */
  getAllPaidVoucherByShift(
    shiftCashierid: number | undefined
  ): Observable<VoucherDTOListResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Shift/GetAllPaidVoucherByShift?";
    if (shiftCashierid === null)
      throw new Error("The parameter 'shiftCashierid' cannot be null.");
    else if (shiftCashierid !== undefined)
      url_ += "ShiftCashierid=" + encodeURIComponent("" + shiftCashierid) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllPaidVoucherByShift(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllPaidVoucherByShift(<any>response_);
            } catch (e) {
              return <Observable<VoucherDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<VoucherDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAllPaidVoucherByShift(
    response: HttpResponseBase
  ): Observable<VoucherDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = VoucherDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<VoucherDTOListResultDto>(<any>null);
  }

  /**
   * @param shiftCashierid (optional)
   * @return Success
   */
  getAllUnPaidVoucherByShift(
    shiftCashierid: number | undefined
  ): Observable<VoucherDTOListResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Shift/GetAllUnPaidVoucherByShift?";
    if (shiftCashierid === null)
      throw new Error("The parameter 'shiftCashierid' cannot be null.");
    else if (shiftCashierid !== undefined)
      url_ += "ShiftCashierid=" + encodeURIComponent("" + shiftCashierid) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllUnPaidVoucherByShift(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllUnPaidVoucherByShift(<any>response_);
            } catch (e) {
              return <Observable<VoucherDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<VoucherDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAllUnPaidVoucherByShift(
    response: HttpResponseBase
  ): Observable<VoucherDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = VoucherDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<VoucherDTOListResultDto>(<any>null);
  }

  /**
   * @param shiftCashierid (optional)
   * @return Success
   */
  getAllPartiallyPaidVoucherByShift(
    shiftCashierid: number | undefined
  ): Observable<VoucherDTOListResultDto> {
    let url_ =
      this.baseUrl +
      "/api/services/app/Shift/GetAllPartiallyPaidVoucherByShift?";
    if (shiftCashierid === null)
      throw new Error("The parameter 'shiftCashierid' cannot be null.");
    else if (shiftCashierid !== undefined)
      url_ += "ShiftCashierid=" + encodeURIComponent("" + shiftCashierid) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllPartiallyPaidVoucherByShift(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllPartiallyPaidVoucherByShift(
                <any>response_
              );
            } catch (e) {
              return <Observable<VoucherDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<VoucherDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAllPartiallyPaidVoucherByShift(
    response: HttpResponseBase
  ): Observable<VoucherDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = VoucherDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<VoucherDTOListResultDto>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  getVoucherByVoucherSerialForReturn(
    input: string | null | undefined
  ): Observable<VoucherDTO> {
    let url_ =
      this.baseUrl +
      "/api/services/app/Shift/GetVoucherByVoucherSerialForReturn?";
    if (input !== undefined && input !== null)
      url_ += "input=" + encodeURIComponent("" + input) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVoucherByVoucherSerialForReturn(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVoucherByVoucherSerialForReturn(
                <any>response_
              );
            } catch (e) {
              return <Observable<VoucherDTO>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<VoucherDTO>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetVoucherByVoucherSerialForReturn(
    response: HttpResponseBase
  ): Observable<VoucherDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = VoucherDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<VoucherDTO>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  voucherPayment(body: PaymentDTO | undefined): Observable<number> {
    let url_ = this.baseUrl + "/api/services/app/Shift/VoucherPayment";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processVoucherPayment(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processVoucherPayment(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processVoucherPayment(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * @return Success
   */
  getLoungesAndTables(): Observable<LoungeDtoListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Shift/GetLoungesAndTables";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLoungesAndTables(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLoungesAndTables(<any>response_);
            } catch (e) {
              return <Observable<LoungeDtoListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<LoungeDtoListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetLoungesAndTables(
    response: HttpResponseBase
  ): Observable<LoungeDtoListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LoungeDtoListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<LoungeDtoListResultDto>(<any>null);
  }

  /**
   * @return Success
   */
  getDeliveryCompanies(): Observable<DeliveryCompanyDtoListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Shift/GetDeliveryCompanies";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDeliveryCompanies(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDeliveryCompanies(<any>response_);
            } catch (e) {
              return <Observable<DeliveryCompanyDtoListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<DeliveryCompanyDtoListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetDeliveryCompanies(
    response: HttpResponseBase
  ): Observable<DeliveryCompanyDtoListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = DeliveryCompanyDtoListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<DeliveryCompanyDtoListResultDto>(<any>null);
  }

  /**
   * @return Success
   */
  getVoucherStatuses(): Observable<VoucherStatusDtoListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Shift/GetVoucherStatuses";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVoucherStatuses(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVoucherStatuses(<any>response_);
            } catch (e) {
              return <Observable<VoucherStatusDtoListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<VoucherStatusDtoListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetVoucherStatuses(
    response: HttpResponseBase
  ): Observable<VoucherStatusDtoListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = VoucherStatusDtoListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<VoucherStatusDtoListResultDto>(<any>null);
  }

  /**
   * @return Success
   */
  getUnfinishedVouchers(): Observable<VoucherDTOListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Shift/GetUnfinishedVouchers";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUnfinishedVouchers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUnfinishedVouchers(<any>response_);
            } catch (e) {
              return <Observable<VoucherDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<VoucherDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetUnfinishedVouchers(
    response: HttpResponseBase
  ): Observable<VoucherDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = VoucherDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<VoucherDTOListResultDto>(<any>null);
  }

  /**
   * @param voucherId (optional)
   * @param voucherStatusId (optional)
   * @return Success
   */
  setVoucherStatus(
    voucherId: number | undefined,
    voucherStatusId: number | undefined
  ): Observable<number> {
    let url_ = this.baseUrl + "/api/services/app/Shift/SetVoucherStatus?";
    if (voucherId === null)
      throw new Error("The parameter 'voucherId' cannot be null.");
    else if (voucherId !== undefined)
      url_ += "voucherId=" + encodeURIComponent("" + voucherId) + "&";
    if (voucherStatusId === null)
      throw new Error("The parameter 'voucherStatusId' cannot be null.");
    else if (voucherStatusId !== undefined)
      url_ +=
        "voucherStatusId=" + encodeURIComponent("" + voucherStatusId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSetVoucherStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSetVoucherStatus(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSetVoucherStatus(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * @param voucherId (optional)
   * @return Success
   */
  getVoucherIncludingsById(
    voucherId: number | undefined
  ): Observable<VoucherDTO> {
    let url_ =
      this.baseUrl + "/api/services/app/Shift/GetVoucherIncludingsById?";
    if (voucherId === null)
      throw new Error("The parameter 'voucherId' cannot be null.");
    else if (voucherId !== undefined)
      url_ += "voucherId=" + encodeURIComponent("" + voucherId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVoucherIncludingsById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVoucherIncludingsById(<any>response_);
            } catch (e) {
              return <Observable<VoucherDTO>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<VoucherDTO>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetVoucherIncludingsById(
    response: HttpResponseBase
  ): Observable<VoucherDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = VoucherDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<VoucherDTO>(<any>null);
  }

  /**
   * @param fromDate (optional)
   * @param toDate (optional)
   * @return Success
   */
  getAllReturnsVoucherByDate(
    fromDate: moment.Moment | undefined,
    toDate: moment.Moment | undefined
  ): Observable<VoucherDTOListResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Shift/GetAllReturnsVoucherByDate?";
    if (fromDate === null)
      throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined)
      url_ +=
        "fromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") +
        "&";
    if (toDate === null)
      throw new Error("The parameter 'toDate' cannot be null.");
    else if (toDate !== undefined)
      url_ +=
        "toDate=" +
        encodeURIComponent(toDate ? "" + toDate.toJSON() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllReturnsVoucherByDate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllReturnsVoucherByDate(<any>response_);
            } catch (e) {
              return <Observable<VoucherDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<VoucherDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAllReturnsVoucherByDate(
    response: HttpResponseBase
  ): Observable<VoucherDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = VoucherDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<VoucherDTOListResultDto>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  getReturnsVoucherBySerial(
    input: string | null | undefined
  ): Observable<VoucherDTO> {
    let url_ =
      this.baseUrl + "/api/services/app/Shift/GetReturnsVoucherBySerial?";
    if (input !== undefined && input !== null)
      url_ += "input=" + encodeURIComponent("" + input) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReturnsVoucherBySerial(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReturnsVoucherBySerial(<any>response_);
            } catch (e) {
              return <Observable<VoucherDTO>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<VoucherDTO>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetReturnsVoucherBySerial(
    response: HttpResponseBase
  ): Observable<VoucherDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = VoucherDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<VoucherDTO>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  getVoucherBySerial(input: string | null | undefined): Observable<VoucherDTO> {
    let url_ = this.baseUrl + "/api/services/app/Shift/GetVoucherBySerial?";
    if (input !== undefined && input !== null)
      url_ += "input=" + encodeURIComponent("" + input) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVoucherBySerial(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVoucherBySerial(<any>response_);
            } catch (e) {
              return <Observable<VoucherDTO>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<VoucherDTO>>(<any>_observableThrow(response_));
        })
      );
  }

sendVoucher(invoices: SchoolInvoiceTransferViewModel): Observable<any> {
  let url_ = AppConsts.sendVoucherToZatca;
  url_ = url_.replace(/[?&]$/, "");

  const content_ = JSON.stringify([invoices]);

  let options_: any = {
    body: content_,
    observe: "response",
    responseType: "json",   // ✅ بيرجع object جاهز
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/json"
    }),
  };

  return this.http.request("post", url_, options_).pipe(
    map((res: any) => {
      // Angular خلاص بيحول JSON → Object
      return res.body ?? res;
    })
  );
}
sendAllVoucher(invoices: SchoolInvoiceTransferViewModel[]): Observable<any> {
  let url_ = AppConsts.sendVoucherToZatca;
  url_ = url_.replace(/[?&]$/, "");

  const content_ = JSON.stringify(invoices); // ابعت array مباشرة

  let options_: any = {
    body: content_,
    observe: "response",
    responseType: "json",
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/json"
    }),
  };

  return this.http.request("post", url_, options_);
}
sendVoucherSimulation(invoices: SchoolInvoiceTransferViewModel): Observable<any> {
  let url_ = AppConsts.sendVoucherToZatcaSimulation;
  url_ = url_.replace(/[?&]$/, "");

  const content_ = JSON.stringify([invoices]);

  let options_: any = {
    body: content_,
    observe: "response",
    responseType: "json",   // ✅ بيرجع object جاهز
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/json"
    }),
  };

  return this.http.request("post", url_, options_).pipe(
    map((res: any) => {
      // Angular خلاص بيحول JSON → Object
      return res.body ?? res;
    })
  );
}
sendAllVoucherSimulation(invoices: SchoolInvoiceTransferViewModel[]): Observable<any> {
  let url_ = AppConsts.sendVoucherToZatcaSimulation;
  url_ = url_.replace(/[?&]$/, "");

  const content_ = JSON.stringify(invoices); // ابعت array مباشرة

  let options_: any = {
    body: content_,
    observe: "response",
    responseType: "json",
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/json"
    }),
  };

  return this.http.request("post", url_, options_);
}

  protected processGetVoucherBySerial(
    response: HttpResponseBase
  ): Observable<VoucherDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = VoucherDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<VoucherDTO>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  fillterVouchersBySalesReportFillter(
    body: SalesReportFillterDTO | undefined
  ): Observable<SalesInvoiceReportDTO> {
    let url_ =
      this.baseUrl +
      "/api/services/app/Shift/FillterVouchersBySalesReportFillter";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFillterVouchersBySalesReportFillter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFillterVouchersBySalesReportFillter(
                <any>response_
              );
            } catch (e) {
              return <Observable<SalesInvoiceReportDTO>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<SalesInvoiceReportDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }
  protected processFillterVouchersBySalesReportFillter(
    response: HttpResponseBase
  ): Observable<SalesInvoiceReportDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SalesInvoiceReportDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SalesInvoiceReportDTO>(<any>null);
  }

  PostInvoices(
    body: VoucherDTO[] | undefined,
    userId: any
  ): Observable<boolean> {
    let url_ = AppConsts.postInvoicesDataUrl;
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify({ Vouchers: body, ABPUserID: userId });

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPostInvoices(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPostInvoices(<any>response_);
            } catch (e) {
              return <Observable<boolean>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<boolean>>(<any>_observableThrow(response_));
        })
      );
  }
PostOnlineInvoices(
  body: VoucherDTO[] | undefined,
  userId: any
): Observable<boolean> {
  let url_ = AppConsts.postOnlineInvoicesDataUrl;
  url_ = url_.replace(/[?&]$/, "");

  const content_ = JSON.stringify({ Vouchers: body, ABPUserID: userId });

  let options_: any = {
    body: content_,
    observe: "body",             // ✅ return only body, not full HttpResponse
    responseType: "json",        // ✅ auto parse JSON
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
    }),
  };

return this.http.post<any>(
  url_,
  content_,
  {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
    }),
    responseType: "json",
    observe: "body"  // ✅ only body, not HttpResponse
  }
).pipe(
  map(res => res.success === true)   // now res is the JSON body
);

}

  protected processPostInvoices(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(<any>null);
  }
  // protected processPostInvoices(
  //   response: HttpResponseBase
  // ): Observable<VoucherDTO[]> {
  //   const status = response.status;
  //   const responseBlob =
  //     response instanceof HttpResponse
  //       ? response.body
  //       : (<any>response).error instanceof Blob
  //       ? (<any>response).error
  //       : undefined;

  //   let _headers: any = {};
  //   if (response.headers) {
  //     for (let key of response.headers.keys()) {
  //       _headers[key] = response.headers.get(key);
  //     }
  //   }
  //   if (status === 200) {
  //     return blobToText(responseBlob).pipe(
  //       _observableMergeMap((_responseText) => {
  //         let result200: any = null;
  //         let resultData200 =
  //           _responseText === ""
  //             ? null
  //             : JSON.parse(_responseText, this.jsonParseReviver);
  //         result200 = VoucherDTO.fromJS(resultData200);
  //         return _observableOf(result200);
  //       })
  //     );
  //   } else if (status !== 200 && status !== 204) {
  //     return blobToText(responseBlob).pipe(
  //       _observableMergeMap((_responseText) => {
  //         return throwException(
  //           "An unexpected server error occurred.",
  //           status,
  //           _responseText,
  //           _headers
  //         );
  //       })
  //     );
  //   }
  //   return _observableOf<VoucherDTO[]>(<any>null);
  // }
  GetPostingInvoices(
    body: SalesReportFillterDTO | undefined
  ): Observable<SalesInvoiceReportDTO> {
    let url_ = this.baseUrl + "/api/services/app/Shift/FillterPostingInvoice";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);
    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {

          return this.processGetPostingInvoices(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPostingInvoices(<any>response_);
            } catch (e) {
              return <Observable<SalesInvoiceReportDTO>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<SalesInvoiceReportDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  GetMovingInvoices(
    body: SalesReportFillterDTO | undefined
  ): Observable<SalesInvoiceReportDTO> {
    let url_ = this.baseUrl + "/api/services/app/Shift/FillterInvoice";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);
    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {

          return this.processGetPostingInvoices(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPostingInvoices(<any>response_);
            } catch (e) {
              return <Observable<SalesInvoiceReportDTO>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<SalesInvoiceReportDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }
  GetVatInvoice(
    body: SalesReportFillterDTO | undefined
  ): Observable<SalesInvoiceReportDTO> {
    let url_ = this.baseUrl + "/api/services/app/Shift/InvoiceToVAT";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);
    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {

          return this.processGetPostingInvoices(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPostingInvoices(<any>response_);
            } catch (e) {
              return <Observable<SalesInvoiceReportDTO>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<SalesInvoiceReportDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }
  protected processGetPostingInvoices(
    response: HttpResponseBase
  ): Observable<SalesInvoiceReportDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SalesInvoiceReportDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SalesInvoiceReportDTO>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  fillterProductsBySalesReportFillter(
    body: SalesReportFillterDTO | undefined
  ): Observable<ProductSalesReportDTO> {
    let url_ =
      this.baseUrl +
      "/api/services/app/Shift/FillterProductsBySalesReportFillter";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFillterProductsBySalesReportFillter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFillterProductsBySalesReportFillter(
                <any>response_
              );
            } catch (e) {
              return <Observable<ProductSalesReportDTO>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ProductSalesReportDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  GetClientsMobilesReportFillter(
    body: ClientMobileFilterDto | undefined
  ): Observable<any> {
    let url_ =
      this.baseUrl + "/api/services/app/Shift/GetAllClientsMobilesByDate?";

    if (body.CustomerMobile)
      url_ += "CustomerMobile=" + body.CustomerMobile + "&";
    if (body.FromDate) url_ += "FromDate=" + body.FromDate + "&";
    if (body.ToDate) url_ += "ToDate=" + body.ToDate;

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFillterCustomerMobileReportFillter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFillterCustomerMobileReportFillter(
                <any>response_
              );
            } catch (e) {
              return <Observable<CustomerMobileReportDTO>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<CustomerMobileReportDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processFillterCustomerMobileReportFillter(
    response: HttpResponseBase
  ): Observable<CustomerMobileReportDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CustomerMobileReportDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CustomerMobileReportDTO[]>(<any>null);
  }

  GetCustomersProductsReportFilter(
    filter: ICustomersProductsReportFilterDto | undefined
  ): Observable<any> {
    let url_ =
      this.baseUrl + "/api/services/app/Shift/GetCustomersProductsWithMobile?";

    if (filter.CustomerMobile)
      url_ += "CustomerMobile=" + filter.CustomerMobile + "&";
    if (filter.FromDate) url_ += "FromDate=" + filter.FromDate + "&";
    if (filter.ToDate) url_ += "ToDate=" + filter.ToDate + "&";
    if (filter.ProductId) url_ += "ProductId=" + filter.ProductId;

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFillterCustomersProductsReportFillter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFillterCustomersProductsReportFillter(
                <any>response_
              );
            } catch (e) {
              return <Observable<CustomersProductsReportDTO>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<CustomersProductsReportDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processFillterCustomersProductsReportFillter(
    response: HttpResponseBase
  ): Observable<CustomersProductsReportDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CustomersProductsReportDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CustomersProductsReportDTO[]>(<any>null);
  }

  protected processFillterProductsBySalesReportFillter(
    response: HttpResponseBase
  ): Observable<ProductSalesReportDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProductSalesReportDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProductSalesReportDTO>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  fillterProductsAndCostBySalesReportFillter(
    body: SalesReportFillterDTO | undefined
  ): Observable<ProductSalesAndCostReportDTO> {
    let url_ =
      this.baseUrl +
      "/api/services/app/Shift/FillterProductsAndCostBySalesReportFillter";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFillterProductsAndCostBySalesReportFillter(
            response_
          );
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFillterProductsAndCostBySalesReportFillter(
                <any>response_
              );
            } catch (e) {
              return <Observable<ProductSalesAndCostReportDTO>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ProductSalesAndCostReportDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processFillterProductsAndCostBySalesReportFillter(
    response: HttpResponseBase
  ): Observable<ProductSalesAndCostReportDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProductSalesAndCostReportDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProductSalesAndCostReportDTO>(<any>null);
  }
}

@Injectable()
export class SupervisorServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getPrintHeader(): Observable<PrintHeaderDTO> {
    let url_ = this.baseUrl + "/api/services/app/Supervisor/GetPrintHeader";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPrintHeader(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPrintHeader(<any>response_);
            } catch (e) {
              return <Observable<PrintHeaderDTO>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<PrintHeaderDTO>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetPrintHeader(
    response: HttpResponseBase
  ): Observable<PrintHeaderDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PrintHeaderDTO.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PrintHeaderDTO>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  shiftsDetailsByDateAndPos(
    body: ReportsFillterDTO | undefined
  ): Observable<ShiftDetailsDTOListResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Supervisor/ShiftsDetailsByDateAndPos";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processShiftsDetailsByDateAndPos(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processShiftsDetailsByDateAndPos(<any>response_);
            } catch (e) {
              return <Observable<ShiftDetailsDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ShiftDetailsDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processShiftsDetailsByDateAndPos(
    response: HttpResponseBase
  ): Observable<ShiftDetailsDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ShiftDetailsDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ShiftDetailsDTOListResultDto>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  productsSummaryByDateAndPos(
    body: ReportsFillterDTO | undefined
  ): Observable<ProductSummaryDTOListResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Supervisor/ProductsSummaryByDateAndPos";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProductsSummaryByDateAndPos(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProductsSummaryByDateAndPos(<any>response_);
            } catch (e) {
              return <Observable<ProductSummaryDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ProductSummaryDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processProductsSummaryByDateAndPos(
    response: HttpResponseBase
  ): Observable<ProductSummaryDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProductSummaryDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProductSummaryDTOListResultDto>(<any>null);
  }

  /**
   * @param shiftCashierId (optional)
   * @return Success
   */
  getVouchersByShift(
    shiftCashierId: number | undefined
  ): Observable<VoucherDTOListResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Supervisor/GetVouchersByShift?";
    if (shiftCashierId === null)
      throw new Error("The parameter 'shiftCashierId' cannot be null.");
    else if (shiftCashierId !== undefined)
      url_ += "shiftCashierId=" + encodeURIComponent("" + shiftCashierId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVouchersByShift(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVouchersByShift(<any>response_);
            } catch (e) {
              return <Observable<VoucherDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<VoucherDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetVouchersByShift(
    response: HttpResponseBase
  ): Observable<VoucherDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = VoucherDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<VoucherDTOListResultDto>(<any>null);
  }

  /**
   * @param shiftCashierId (optional)
   * @return Success
   */
  getShiftSummary(
    shiftCashierId: number | undefined
  ): Observable<ProductSummaryDTOListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Supervisor/GetShiftSummary?";
    if (shiftCashierId === null)
      throw new Error("The parameter 'shiftCashierId' cannot be null.");
    else if (shiftCashierId !== undefined)
      url_ += "shiftCashierId=" + encodeURIComponent("" + shiftCashierId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetShiftSummary(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetShiftSummary(<any>response_);
            } catch (e) {
              return <Observable<ProductSummaryDTOListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ProductSummaryDTOListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetShiftSummary(
    response: HttpResponseBase
  ): Observable<ProductSummaryDTOListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProductSummaryDTOListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProductSummaryDTOListResultDto>(<any>null);
  }
}

@Injectable()
export class TenantServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateTenantDto | undefined): Observable<TenantDto> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(<any>response_);
            } catch (e) {
              return <Observable<TenantDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<TenantDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TenantDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TenantDto>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<TenantDto> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(<any>response_);
            } catch (e) {
              return <Observable<TenantDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<TenantDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<TenantDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TenantDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TenantDto>(<any>null);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | null | undefined,
    isActive: boolean | null | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined
  ): Observable<TenantDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
    if (keyword !== undefined && keyword !== null)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (isActive !== undefined && isActive !== null)
      url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(<any>response_);
            } catch (e) {
              return <Observable<TenantDtoPagedResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<TenantDtoPagedResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAll(
    response: HttpResponseBase
  ): Observable<TenantDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TenantDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TenantDtoPagedResultDto>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: TenantDto | undefined): Observable<TenantDto> {
    let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(<any>response_);
            } catch (e) {
              return <Observable<TenantDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<TenantDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TenantDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TenantDto>(<any>null);
  }
}

@Injectable()
export class TokenAuthServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  authenticate(
    body: AuthenticateModel | undefined
  ): Observable<AuthenticateResultModel> {
    let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuthenticate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuthenticate(<any>response_);
            } catch (e) {
              return <Observable<AuthenticateResultModel>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<AuthenticateResultModel>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processAuthenticate(
    response: HttpResponseBase
  ): Observable<AuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AuthenticateResultModel.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AuthenticateResultModel>(<any>null);
  }

  /**
   * @return Success
   */
  getExternalAuthenticationProviders(): Observable<
    ExternalLoginProviderInfoModel[]
  > {
    let url_ =
      this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetExternalAuthenticationProviders(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetExternalAuthenticationProviders(
                <any>response_
              );
            } catch (e) {
              return <Observable<ExternalLoginProviderInfoModel[]>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ExternalLoginProviderInfoModel[]>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetExternalAuthenticationProviders(
    response: HttpResponseBase
  ): Observable<ExternalLoginProviderInfoModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200.push(ExternalLoginProviderInfoModel.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ExternalLoginProviderInfoModel[]>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  externalAuthenticate(
    body: ExternalAuthenticateModel | undefined
  ): Observable<ExternalAuthenticateResultModel> {
    let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processExternalAuthenticate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processExternalAuthenticate(<any>response_);
            } catch (e) {
              return <Observable<ExternalAuthenticateResultModel>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ExternalAuthenticateResultModel>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processExternalAuthenticate(
    response: HttpResponseBase
  ): Observable<ExternalAuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ExternalAuthenticateResultModel>(<any>null);
  }
}

@Injectable()
export class UserServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return Success
   */
  getAllUsers(): Observable<UserDtoListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/User/GetAllUsers";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllUsers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllUsers(<any>response_);
            } catch (e) {
              return <Observable<UserDtoListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<UserDtoListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAllUsers(
    response: HttpResponseBase
  ): Observable<UserDtoListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserDtoListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserDtoListResultDto>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: CreateUserDto | undefined): Observable<UserDto> {
    let url_ = this.baseUrl + "/api/services/app/User/Create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(<any>response_);
            } catch (e) {
              return <Observable<UserDto>>(<any>_observableThrow(e));
            }
          } else return <Observable<UserDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<UserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserDto>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: UserDto | undefined): Observable<UserDto> {
    let url_ = this.baseUrl + "/api/services/app/User/Update";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(<any>response_);
            } catch (e) {
              return <Observable<UserDto>>(<any>_observableThrow(e));
            }
          } else return <Observable<UserDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserDto>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/User/Delete?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  activate(body: Int64EntityDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/User/Activate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActivate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActivate(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processActivate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  deActivate(body: Int64EntityDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/User/DeActivate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeActivate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeActivate(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeActivate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @return Success
   */
  getRoles(): Observable<RoleDtoListResultDto> {
    let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRoles(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRoles(<any>response_);
            } catch (e) {
              return <Observable<RoleDtoListResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<RoleDtoListResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetRoles(
    response: HttpResponseBase
  ): Observable<RoleDtoListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RoleDtoListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<RoleDtoListResultDto>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangeLanguage(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangeLanguage(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processChangeLanguage(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
    let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangePassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangePassword(<any>response_);
            } catch (e) {
              return <Observable<boolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<boolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processChangePassword(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
    let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResetPassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResetPassword(<any>response_);
            } catch (e) {
              return <Observable<boolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<boolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processResetPassword(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<UserDto> {
    let url_ = this.baseUrl + "/api/services/app/User/Get?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(<any>response_);
            } catch (e) {
              return <Observable<UserDto>>(<any>_observableThrow(e));
            }
          } else return <Observable<UserDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<UserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserDto>(<any>null);
  }

  /**
   * @param keyword (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | null | undefined,
    isActive: boolean | null | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined
  ): Observable<UserDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
    if (keyword !== undefined && keyword !== null)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (isActive !== undefined && isActive !== null)
      url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(<any>response_);
            } catch (e) {
              return <Observable<UserDtoPagedResultDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<UserDtoPagedResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAll(
    response: HttpResponseBase
  ): Observable<UserDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserDtoPagedResultDto>(<any>null);
  }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
  tenancyName: string;

  constructor(data?: IIsTenantAvailableInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data["tenancyName"];
    }
  }

  static fromJS(data: any): IsTenantAvailableInput {
    data = typeof data === "object" ? data : {};
    let result = new IsTenantAvailableInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["tenancyName"] = this.tenancyName;
    return data;
  }

  clone(): IsTenantAvailableInput {
    const json = this.toJSON();
    let result = new IsTenantAvailableInput();
    result.init(json);
    return result;
  }
}

export interface IIsTenantAvailableInput {
  tenancyName: string;
}

export enum TenantAvailabilityState {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
  state: TenantAvailabilityState;
  tenantId: number | undefined;

  constructor(data?: IIsTenantAvailableOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.state = _data["state"];
      this.tenantId = _data["tenantId"];
    }
  }

  static fromJS(data: any): IsTenantAvailableOutput {
    data = typeof data === "object" ? data : {};
    let result = new IsTenantAvailableOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["state"] = this.state;
    data["tenantId"] = this.tenantId;
    return data;
  }

  clone(): IsTenantAvailableOutput {
    const json = this.toJSON();
    let result = new IsTenantAvailableOutput();
    result.init(json);
    return result;
  }
}

export interface IIsTenantAvailableOutput {
  state: TenantAvailabilityState;
  tenantId: number | undefined;
}

export class RegisterInput implements IRegisterInput {
  name: string;
  surname: string;
  userName: string;
  emailAddress: string;
  password: string;
  captchaResponse: string | undefined;

  constructor(data?: IRegisterInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.surname = _data["surname"];
      this.userName = _data["userName"];
      this.emailAddress = _data["emailAddress"];
      this.password = _data["password"];
      this.captchaResponse = _data["captchaResponse"];
    }
  }

  static fromJS(data: any): RegisterInput {
    data = typeof data === "object" ? data : {};
    let result = new RegisterInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["surname"] = this.surname;
    data["userName"] = this.userName;
    data["emailAddress"] = this.emailAddress;
    data["password"] = this.password;
    data["captchaResponse"] = this.captchaResponse;
    return data;
  }

  clone(): RegisterInput {
    const json = this.toJSON();
    let result = new RegisterInput();
    result.init(json);
    return result;
  }
}

export interface IRegisterInput {
  name: string;
  surname: string;
  userName: string;
  emailAddress: string;
  password: string;
  captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
  canLogin: boolean;

  constructor(data?: IRegisterOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.canLogin = _data["canLogin"];
    }
  }

  static fromJS(data: any): RegisterOutput {
    data = typeof data === "object" ? data : {};
    let result = new RegisterOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["canLogin"] = this.canLogin;
    return data;
  }

  clone(): RegisterOutput {
    const json = this.toJSON();
    let result = new RegisterOutput();
    result.init(json);
    return result;
  }
}

export interface IRegisterOutput {
  canLogin: boolean;
}

export class CreateBranchInput implements ICreateBranchInput {
  name: string | undefined;

  constructor(data?: ICreateBranchInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): CreateBranchInput {
    data = typeof data === "object" ? data : {};
    let result = new CreateBranchInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    return data;
  }

  clone(): CreateBranchInput {
    const json = this.toJSON();
    let result = new CreateBranchInput();
    result.init(json);
    return result;
  }
}

export interface ICreateBranchInput {
  name: string | undefined;
}

export class BranchDTO implements IBranchDTO {
  id: number;
  name: string | undefined;
  loungesCount: number;
  tenantId: number;

  constructor(data?: IBranchDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.loungesCount = _data["loungesCount"];
      this.tenantId = _data["tenantId"];
    }
  }

  static fromJS(data: any): BranchDTO {
    data = typeof data === "object" ? data : {};
    let result = new BranchDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["loungesCount"] = this.loungesCount;
    data["tenantId"] = this.tenantId;
    return data;
  }

  clone(): BranchDTO {
    const json = this.toJSON();
    let result = new BranchDTO();
    result.init(json);
    return result;
  }
}

export interface IBranchDTO {
  id: number;
  name: string | undefined;
  loungesCount: number;
  tenantId: number;
}

export class TableDto implements ITableDto {
  id: number;
  loungeId: number;
  maxCustomersNumber: number;
  name: string | undefined;
  loungeName: string | undefined;
  creationTime: moment.Moment;
  isDeleted: boolean;

  constructor(data?: ITableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.loungeId = _data["loungeId"];
      this.maxCustomersNumber = _data["maxCustomersNumber"];
      this.name = _data["name"];
      this.loungeName = _data["loungeName"];
      this.creationTime = _data["creationTime"]
        ? moment(_data["creationTime"].toString())
        : <any>undefined;
      this.isDeleted = _data["isDeleted"];
    }
  }

  static fromJS(data: any): TableDto {
    data = typeof data === "object" ? data : {};
    let result = new TableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["loungeId"] = this.loungeId;
    data["maxCustomersNumber"] = this.maxCustomersNumber;
    data["name"] = this.name;
    data["loungeName"] = this.loungeName;
    data["creationTime"] = this.creationTime
      ? this.creationTime.toISOString()
      : <any>undefined;
    data["isDeleted"] = this.isDeleted;
    return data;
  }

  clone(): TableDto {
    const json = this.toJSON();
    let result = new TableDto();
    result.init(json);
    return result;
  }
}

export interface ITableDto {
  id: number;
  loungeId: number;
  maxCustomersNumber: number;
  name: string | undefined;
  loungeName: string | undefined;
  creationTime: moment.Moment;
  isDeleted: boolean;
}

export class TableDtoPageResultDTO implements ITableDtoPageResultDTO {
  count: number;
  pageIndex: number;
  pageSize: number;
  items: TableDto[] | undefined;

  constructor(data?: ITableDtoPageResultDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data["count"];
      this.pageIndex = _data["pageIndex"];
      this.pageSize = _data["pageSize"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items.push(TableDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): TableDtoPageResultDTO {
    data = typeof data === "object" ? data : {};
    let result = new TableDtoPageResultDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["count"] = this.count;
    data["pageIndex"] = this.pageIndex;
    data["pageSize"] = this.pageSize;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): TableDtoPageResultDTO {
    const json = this.toJSON();
    let result = new TableDtoPageResultDTO();
    result.init(json);
    return result;
  }
}

export interface ITableDtoPageResultDTO {
  count: number;
  pageIndex: number;
  pageSize: number;
  items: TableDto[] | undefined;
}

export class LoungeDto implements ILoungeDto {
  id: number;
  name: string | undefined;
  tables: TableDto[] | undefined;

  constructor(data?: ILoungeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      if (Array.isArray(_data["tables"])) {
        this.tables = [] as any;
        for (let item of _data["tables"])
          this.tables.push(TableDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): LoungeDto {
    data = typeof data === "object" ? data : {};
    let result = new LoungeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    if (Array.isArray(this.tables)) {
      data["tables"] = [];
      for (let item of this.tables) data["tables"].push(item.toJSON());
    }
    return data;
  }

  clone(): LoungeDto {
    const json = this.toJSON();
    let result = new LoungeDto();
    result.init(json);
    return result;
  }
}
export interface SchoolInvoiceTransferViewModel {
  InvoiceId: number;
  ocF_Code: number;
  staticalCode: string;
}

export interface ILoungeDto {
  id: number;
  name: string | undefined;
  tables: TableDto[] | undefined;
}

export class LoungeDtoListResultDto implements ILoungeDtoListResultDto {
  items: LoungeDto[] | undefined;

  constructor(data?: ILoungeDtoListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(LoungeDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): LoungeDtoListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new LoungeDtoListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): LoungeDtoListResultDto {
    const json = this.toJSON();
    let result = new LoungeDtoListResultDto();
    result.init(json);
    return result;
  }
}

export interface ILoungeDtoListResultDto {
  items: LoungeDto[] | undefined;
}

export class ProductDTO implements IProductDTO {
  id: number | undefined;
  name: string | undefined;
  productCode: string | undefined;
  productNameE: string | undefined;
  productMUParcode: string | undefined;
  price: number | undefined;
  taxPercentage: number | undefined;
  taxValue: number | undefined;
  productPriceAftrTax: number | undefined;
  measuringUnitID: number | undefined;
  measuringUnitName: string | undefined;
  productImageURL: string | undefined;
  taxID: number | undefined;
  quantity: number;
  productMeasuringUnitID: number | undefined;
  parcode: string | undefined;

  constructor(data?: IProductDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.productCode = _data["productCode"];
      this.productNameE = _data["productNameE"];
      this.productMUParcode = _data["productMUParcode"];
      this.price = _data["price"];
      this.taxPercentage = _data["taxPercentage"];
      this.taxValue = _data["taxValue"];
      this.productPriceAftrTax = _data["productPriceAftrTax"];
      this.measuringUnitID = _data["measuringUnitID"];
      this.measuringUnitName = _data["measuringUnitName"];
      this.productImageURL = _data["productImageURL"];
      this.taxID = _data["taxID"];
      this.quantity = _data["quantity"];
      this.productMeasuringUnitID = _data["productMeasuringUnitID"];
      this.parcode = _data["parcode"];
    }
  }

  static fromJS(data: any): ProductDTO {
    data = typeof data === "object" ? data : {};
    let result = new ProductDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["productCode"] = this.productCode;
    data["productNameE"] = this.productNameE;
    data["productMUParcode"] = this.productMUParcode;
    data["price"] = this.price;
    data["taxPercentage"] = this.taxPercentage;
    data["taxValue"] = this.taxValue;
    data["productPriceAftrTax"] = this.productPriceAftrTax;
    data["measuringUnitID"] = this.measuringUnitID;
    data["measuringUnitName"] = this.measuringUnitName;
    data["productImageURL"] = this.productImageURL;
    data["taxID"] = this.taxID;
    data["quantity"] = this.quantity;
    data["productMeasuringUnitID"] = this.productMeasuringUnitID;
    data["parcode"] = this.parcode;
    return data;
  }

  clone(): ProductDTO {
    const json = this.toJSON();
    let result = new ProductDTO();
    result.init(json);
    return result;
  }
}

export interface IProductDTO {
  id: number | undefined;
  name: string | undefined;
  productCode: string | undefined;
  productNameE: string | undefined;
  productMUParcode: string | undefined;
  price: number | undefined;
  taxPercentage: number | undefined;
  taxValue: number | undefined;
  productPriceAftrTax: number | undefined;
  measuringUnitID: number | undefined;
  measuringUnitName: string | undefined;
  productImageURL: string | undefined;
  taxID: number | undefined;
  quantity: number;
  productMeasuringUnitID: number | undefined;
  parcode: string | undefined;
}

export class CategoryDTO implements ICategoryDTO {
  id: number | undefined;
  name: string | undefined;
  products: ProductDTO[] | undefined;

  constructor(data?: ICategoryDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      if (Array.isArray(_data["products"])) {
        this.products = [] as any;
        for (let item of _data["products"])
          this.products.push(ProductDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CategoryDTO {
    data = typeof data === "object" ? data : {};
    let result = new CategoryDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    if (Array.isArray(this.products)) {
      data["products"] = [];
      for (let item of this.products) data["products"].push(item.toJSON());
    }
    return data;
  }

  clone(): CategoryDTO {
    const json = this.toJSON();
    let result = new CategoryDTO();
    result.init(json);
    return result;
  }
}

export interface ICategoryDTO {
  id: number | undefined;
  name: string | undefined;
  products: ProductDTO[] | undefined;
}

export class RootCategoryDTO implements IRootCategoryDTO {
  id: number | undefined;
  name: string | undefined;
  categories: CategoryDTO[] | undefined;

  constructor(data?: IRootCategoryDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      if (Array.isArray(_data["categories"])) {
        this.categories = [] as any;
        for (let item of _data["categories"])
          this.categories.push(CategoryDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RootCategoryDTO {
    data = typeof data === "object" ? data : {};
    let result = new RootCategoryDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    if (Array.isArray(this.categories)) {
      data["categories"] = [];
      for (let item of this.categories) data["categories"].push(item.toJSON());
    }
    return data;
  }

  clone(): RootCategoryDTO {
    const json = this.toJSON();
    let result = new RootCategoryDTO();
    result.init(json);
    return result;
  }
}

export interface IRootCategoryDTO {
  id: number | undefined;
  name: string | undefined;
  categories: CategoryDTO[] | undefined;
}

export class V_ProductDataDTO implements IV_ProductDataDTO {
  productID: number | undefined;
  productName: string | undefined;
  productCode: string | undefined;
  productNameE: string | undefined;
  productMUParcode: string | undefined;
  productImageURL: string | undefined;
  categoryID: number | undefined;
  categoryName: string | undefined;
  rootCategoryID: number | undefined;
  rootCategoryName: string | undefined;
  quantity: number;
  stockID: number;
  measuringUnitID: number;
  measuringUnitName: string | undefined;
  productMeasuringUnitID: number;
  price: number | undefined;
  taxID: number;
  taxPercentage: number;
  taxValue: number | undefined;
  totalPrice: number | undefined;
  parcode: string | undefined;

  constructor(data?: IV_ProductDataDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productID = _data["productID"];
      this.productName = _data["productName"];
      this.productCode = _data["productCode"];
      this.productNameE = _data["productNameE"];
      this.productMUParcode = _data["productMUParcode"];
      this.productImageURL = _data["productImageURL"];
      this.categoryID = _data["categoryID"];
      this.categoryName = _data["categoryName"];
      this.rootCategoryID = _data["rootCategoryID"];
      this.rootCategoryName = _data["rootCategoryName"];
      this.quantity = _data["quantity"];
      this.stockID = _data["stockID"];
      this.measuringUnitID = _data["measuringUnitID"];
      this.measuringUnitName = _data["measuringUnitName"];
      this.productMeasuringUnitID = _data["productMeasuringUnitID"];
      this.price = _data["price"];
      this.taxID = _data["taxID"];
      this.taxPercentage = _data["taxPercentage"];
      this.taxValue = _data["taxValue"];
      this.totalPrice = _data["totalPrice"];
      this.parcode = _data["parcode"];
    }
  }

  static fromJS(data: any): V_ProductDataDTO {
    data = typeof data === "object" ? data : {};
    let result = new V_ProductDataDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["productID"] = this.productID;
    data["productName"] = this.productName;
    data["productCode"] = this.productCode;
    data["productNameE"] = this.productNameE;
    data["productMUParcode"] = this.productMUParcode;
    data["productImageURL"] = this.productImageURL;
    data["categoryID"] = this.categoryID;
    data["categoryName"] = this.categoryName;
    data["rootCategoryID"] = this.rootCategoryID;
    data["rootCategoryName"] = this.rootCategoryName;
    data["quantity"] = this.quantity;
    data["stockID"] = this.stockID;
    data["measuringUnitID"] = this.measuringUnitID;
    data["measuringUnitName"] = this.measuringUnitName;
    data["productMeasuringUnitID"] = this.productMeasuringUnitID;
    data["price"] = this.price;
    data["taxID"] = this.taxID;
    data["taxPercentage"] = this.taxPercentage;
    data["taxValue"] = this.taxValue;
    data["totalPrice"] = this.totalPrice;
    data["parcode"] = this.parcode;
    return data;
  }

  clone(): V_ProductDataDTO {
    const json = this.toJSON();
    let result = new V_ProductDataDTO();
    result.init(json);
    return result;
  }
}

export interface IV_ProductDataDTO {
  productID: number | undefined;
  productName: string | undefined;
  productCode: string | undefined;
  productNameE: string | undefined;
  productMUParcode: string | undefined;
  productImageURL: string | undefined;
  categoryID: number | undefined;
  categoryName: string | undefined;
  rootCategoryID: number | undefined;
  rootCategoryName: string | undefined;
  quantity: number;
  stockID: number;
  measuringUnitID: number;
  measuringUnitName: string | undefined;
  productMeasuringUnitID: number;
  price: number | undefined;
  taxID: number;
  taxPercentage: number;
  taxValue: number | undefined;
  totalPrice: number | undefined;
  parcode: string | undefined;
}

export class MainProductDataDto implements IMainProductDataDto {
  rootCategories: RootCategoryDTO[] | undefined;
  productsData: V_ProductDataDTO[] | undefined;

  constructor(data?: IMainProductDataDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["rootCategories"])) {
        this.rootCategories = [] as any;
        for (let item of _data["rootCategories"])
          this.rootCategories.push(RootCategoryDTO.fromJS(item));
      }
      if (Array.isArray(_data["productsData"])) {
        this.productsData = [] as any;
        for (let item of _data["productsData"])
          this.productsData.push(V_ProductDataDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MainProductDataDto {
    data = typeof data === "object" ? data : {};
    let result = new MainProductDataDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.rootCategories)) {
      data["rootCategories"] = [];
      for (let item of this.rootCategories)
        data["rootCategories"].push(item.toJSON());
    }
    if (Array.isArray(this.productsData)) {
      data["productsData"] = [];
      for (let item of this.productsData)
        data["productsData"].push(item.toJSON());
    }
    return data;
  }

  clone(): MainProductDataDto {
    const json = this.toJSON();
    let result = new MainProductDataDto();
    result.init(json);
    return result;
  }
}

export interface IMainProductDataDto {
  rootCategories: RootCategoryDTO[] | undefined;
  productsData: V_ProductDataDTO[] | undefined;
}

export class RootCategoryDTOListResultDto
  implements IRootCategoryDTOListResultDto
{
  items: RootCategoryDTO[] | undefined;

  constructor(data?: IRootCategoryDTOListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(RootCategoryDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RootCategoryDTOListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new RootCategoryDTOListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): RootCategoryDTOListResultDto {
    const json = this.toJSON();
    let result = new RootCategoryDTOListResultDto();
    result.init(json);
    return result;
  }
}

export interface IRootCategoryDTOListResultDto {
  items: RootCategoryDTO[] | undefined;
}

export class V_ProductDataDTOListResultDto
  implements IV_ProductDataDTOListResultDto
{
  items: V_ProductDataDTO[] | undefined;

  constructor(data?: IV_ProductDataDTOListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(V_ProductDataDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): V_ProductDataDTOListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new V_ProductDataDTOListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): V_ProductDataDTOListResultDto {
    const json = this.toJSON();
    let result = new V_ProductDataDTOListResultDto();
    result.init(json);
    return result;
  }
}

export interface IV_ProductDataDTOListResultDto {
  items: V_ProductDataDTO[] | undefined;
}

export class MC_BOM_DTO implements IMC_BOM_DTO {
  id: number;
  bomCode: string | undefined;
  bomName: string | undefined;
  productId: number;

  constructor(data?: IMC_BOM_DTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.bomCode = _data["bomCode"];
      this.bomName = _data["bomName"];
      this.productId = _data["productId"];
    }
  }

  static fromJS(data: any): MC_BOM_DTO {
    data = typeof data === "object" ? data : {};
    let result = new MC_BOM_DTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["bomCode"] = this.bomCode;
    data["bomName"] = this.bomName;
    data["productId"] = this.productId;
    return data;
  }

  clone(): MC_BOM_DTO {
    const json = this.toJSON();
    let result = new MC_BOM_DTO();
    result.init(json);
    return result;
  }
}

export interface IMC_BOM_DTO {
  id: number;
  bomCode: string | undefined;
  bomName: string | undefined;
  productId: number;
}

export class MC_BOMContentsDTO implements IMC_BOMContentsDTO {
  id: number;
  mC_BOM: MC_BOM_DTO;
  rowMaterialId: number;
  productRowMaterial: ProductDTO;

  constructor(data?: IMC_BOMContentsDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.mC_BOM = _data["mC_BOM"]
        ? MC_BOM_DTO.fromJS(_data["mC_BOM"])
        : <any>undefined;
      this.rowMaterialId = _data["rowMaterialId"];
      this.productRowMaterial = _data["productRowMaterial"]
        ? ProductDTO.fromJS(_data["productRowMaterial"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): MC_BOMContentsDTO {
    data = typeof data === "object" ? data : {};
    let result = new MC_BOMContentsDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["mC_BOM"] = this.mC_BOM ? this.mC_BOM.toJSON() : <any>undefined;
    data["rowMaterialId"] = this.rowMaterialId;
    data["productRowMaterial"] = this.productRowMaterial
      ? this.productRowMaterial.toJSON()
      : <any>undefined;
    return data;
  }

  clone(): MC_BOMContentsDTO {
    const json = this.toJSON();
    let result = new MC_BOMContentsDTO();
    result.init(json);
    return result;
  }
}

export interface IMC_BOMContentsDTO {
  id: number;
  mC_BOM: MC_BOM_DTO;
  rowMaterialId: number;
  productRowMaterial: ProductDTO;
}

export class MC_BOMContentsDTOListResultDto
  implements IMC_BOMContentsDTOListResultDto
{
  items: MC_BOMContentsDTO[] | undefined;

  constructor(data?: IMC_BOMContentsDTOListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(MC_BOMContentsDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MC_BOMContentsDTOListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new MC_BOMContentsDTOListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): MC_BOMContentsDTOListResultDto {
    const json = this.toJSON();
    let result = new MC_BOMContentsDTOListResultDto();
    result.init(json);
    return result;
  }
}

export interface IMC_BOMContentsDTOListResultDto {
  items: MC_BOMContentsDTO[] | undefined;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
  theme: string;

  constructor(data?: IChangeUiThemeInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.theme = _data["theme"];
    }
  }

  static fromJS(data: any): ChangeUiThemeInput {
    data = typeof data === "object" ? data : {};
    let result = new ChangeUiThemeInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["theme"] = this.theme;
    return data;
  }

  clone(): ChangeUiThemeInput {
    const json = this.toJSON();
    let result = new ChangeUiThemeInput();
    result.init(json);
    return result;
  }
}

export interface IChangeUiThemeInput {
  theme: string;
}

export class CustomerTypeDTO implements ICustomerTypeDTO {
  id: number;
  name: string | undefined;

  constructor(data?: ICustomerTypeDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): CustomerTypeDTO {
    data = typeof data === "object" ? data : {};
    let result = new CustomerTypeDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }

  clone(): CustomerTypeDTO {
    const json = this.toJSON();
    let result = new CustomerTypeDTO();
    result.init(json);
    return result;
  }
}

export interface ICustomerTypeDTO {
  id: number;
  name: string | undefined;
}

export class CustomerTypeDTOListResultDto
  implements ICustomerTypeDTOListResultDto
{
  items: CustomerTypeDTO[] | undefined;

  constructor(data?: ICustomerTypeDTOListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(CustomerTypeDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CustomerTypeDTOListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new CustomerTypeDTOListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): CustomerTypeDTOListResultDto {
    const json = this.toJSON();
    let result = new CustomerTypeDTOListResultDto();
    result.init(json);
    return result;
  }
}

export interface ICustomerTypeDTOListResultDto {
  items: CustomerTypeDTO[] | undefined;
}

export class DeliveryCompanyDto implements IDeliveryCompanyDto {
  id: number;
  name: string | undefined;

  constructor(data?: IDeliveryCompanyDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): DeliveryCompanyDto {
    data = typeof data === "object" ? data : {};
    let result = new DeliveryCompanyDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }

  clone(): DeliveryCompanyDto {
    const json = this.toJSON();
    let result = new DeliveryCompanyDto();
    result.init(json);
    return result;
  }
}

export interface IDeliveryCompanyDto {
  id: number;
  name: string | undefined;
}

export class DeliveryCompanyDtoPageResultDTO
  implements IDeliveryCompanyDtoPageResultDTO
{
  count: number;
  pageIndex: number;
  pageSize: number;
  items: DeliveryCompanyDto[] | undefined;

  constructor(data?: IDeliveryCompanyDtoPageResultDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data["count"];
      this.pageIndex = _data["pageIndex"];
      this.pageSize = _data["pageSize"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(DeliveryCompanyDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DeliveryCompanyDtoPageResultDTO {
    data = typeof data === "object" ? data : {};
    let result = new DeliveryCompanyDtoPageResultDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["count"] = this.count;
    data["pageIndex"] = this.pageIndex;
    data["pageSize"] = this.pageSize;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): DeliveryCompanyDtoPageResultDTO {
    const json = this.toJSON();
    let result = new DeliveryCompanyDtoPageResultDTO();
    result.init(json);
    return result;
  }
}

export interface IDeliveryCompanyDtoPageResultDTO {
  count: number;
  pageIndex: number;
  pageSize: number;
  items: DeliveryCompanyDto[] | undefined;
}

export class InvoiceDetailsDTO implements IInvoiceDetailsDTO {
  productMeasuringUnitId: number | undefined;
  quantity: number | undefined;
  purchasePricePerUnit: number | undefined;
  taxId: number | undefined;
  taxNature: boolean | undefined;
  taxPercentage: number | undefined;
  taxValue: number | undefined;

  constructor(data?: IInvoiceDetailsDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productMeasuringUnitId = _data["productMeasuringUnitId"];
      this.quantity = _data["quantity"];
      this.purchasePricePerUnit = _data["purchasePricePerUnit"];
      this.taxId = _data["taxId"];
      this.taxNature = _data["taxNature"];
      this.taxPercentage = _data["taxPercentage"];
      this.taxValue = _data["taxValue"];
    }
  }

  static fromJS(data: any): InvoiceDetailsDTO {
    data = typeof data === "object" ? data : {};
    let result = new InvoiceDetailsDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["productMeasuringUnitId"] = this.productMeasuringUnitId;
    data["quantity"] = this.quantity;
    data["purchasePricePerUnit"] = this.purchasePricePerUnit;
    data["taxId"] = this.taxId;
    data["taxNature"] = this.taxNature;
    data["taxPercentage"] = this.taxPercentage;
    data["taxValue"] = this.taxValue;
    return data;
  }

  clone(): InvoiceDetailsDTO {
    const json = this.toJSON();
    let result = new InvoiceDetailsDTO();
    result.init(json);
    return result;
  }
}

export interface IInvoiceDetailsDTO {
  productMeasuringUnitId: number | undefined;
  quantity: number | undefined;
  purchasePricePerUnit: number | undefined;
  taxId: number | undefined;
  taxNature: boolean | undefined;
  taxPercentage: number | undefined;
  taxValue: number | undefined;
}

export class DiscountBonusInvoiceDTO implements IDiscountBonusInvoiceDTO {
  bonusDiscountId: number | undefined;
  percentage: number | undefined;
  value: number | undefined;
  valueAfterTax: number | undefined;

  constructor(data?: IDiscountBonusInvoiceDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bonusDiscountId = _data["bonusDiscountId"];
      this.percentage = _data["percentage"];
      this.value = _data["value"];
      this.valueAfterTax = _data["valueAfterTax"];
    }
  }

  static fromJS(data: any): DiscountBonusInvoiceDTO {
    data = typeof data === "object" ? data : {};
    let result = new DiscountBonusInvoiceDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["bonusDiscountId"] = this.bonusDiscountId;
    data["percentage"] = this.percentage;
    data["value"] = this.value;
    data["valueAfterTax"] = this.valueAfterTax;
    return data;
  }

  clone(): DiscountBonusInvoiceDTO {
    const json = this.toJSON();
    let result = new DiscountBonusInvoiceDTO();
    result.init(json);
    return result;
  }
}

export interface IDiscountBonusInvoiceDTO {
  bonusDiscountId: number | undefined;
  percentage: number | undefined;
  value: number | undefined;
  valueAfterTax: number | undefined;
}

export class SalesInvoiceDTO implements ISalesInvoiceDTO {
  invoiceValueAfterTax: number | undefined;
  invoiceClientName: string | undefined;
  invoiceDetails: InvoiceDetailsDTO[] | undefined;
  discount: DiscountBonusInvoiceDTO;
  bonus: DiscountBonusInvoiceDTO;

  constructor(data?: ISalesInvoiceDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.invoiceValueAfterTax = _data["invoiceValueAfterTax"];
      this.invoiceClientName = _data["invoiceClientName"];
      if (Array.isArray(_data["invoiceDetails"])) {
        this.invoiceDetails = [] as any;
        for (let item of _data["invoiceDetails"])
          this.invoiceDetails.push(InvoiceDetailsDTO.fromJS(item));
      }
      this.discount = _data["discount"]
        ? DiscountBonusInvoiceDTO.fromJS(_data["discount"])
        : <any>undefined;
      this.bonus = _data["bonus"]
        ? DiscountBonusInvoiceDTO.fromJS(_data["bonus"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): SalesInvoiceDTO {
    data = typeof data === "object" ? data : {};
    let result = new SalesInvoiceDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["invoiceValueAfterTax"] = this.invoiceValueAfterTax;
    data["invoiceClientName"] = this.invoiceClientName;
    if (Array.isArray(this.invoiceDetails)) {
      data["invoiceDetails"] = [];
      for (let item of this.invoiceDetails)
        data["invoiceDetails"].push(item.toJSON());
    }
    data["discount"] = this.discount ? this.discount.toJSON() : <any>undefined;
    data["bonus"] = this.bonus ? this.bonus.toJSON() : <any>undefined;
    return data;
  }

  clone(): SalesInvoiceDTO {
    const json = this.toJSON();
    let result = new SalesInvoiceDTO();
    result.init(json);
    return result;
  }
}

export interface ISalesInvoiceDTO {
  invoiceValueAfterTax: number | undefined;
  invoiceClientName: string | undefined;
  invoiceDetails: InvoiceDetailsDTO[] | undefined;
  discount: DiscountBonusInvoiceDTO;
  bonus: DiscountBonusInvoiceDTO;
}

export class PaymentRevenuesTypeDto implements IPaymentRevenuesTypeDto {
  id: number;
  name: string | undefined;

  constructor(data?: IPaymentRevenuesTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): PaymentRevenuesTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new PaymentRevenuesTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }

  clone(): PaymentRevenuesTypeDto {
    const json = this.toJSON();
    let result = new PaymentRevenuesTypeDto();
    result.init(json);
    return result;
  }
}

export interface IPaymentRevenuesTypeDto {
  id: number;
  name: string | undefined;
}

export class PaymentRevenueDto implements IPaymentRevenueDto {
  id: number;
  paymentRevenueSerial: string | undefined;
  shiftCashierId: number;
  paymentRevenuesTypeId: number;
  paymentRevenuesType: string | undefined;
  value: number;
  notes: string | undefined;
  statement: string | undefined;
  date: moment.Moment;
  transactionId: number | undefined;

  constructor(data?: IPaymentRevenueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.paymentRevenueSerial = _data["paymentRevenueSerial"];
      this.shiftCashierId = _data["shiftCashierId"];
      this.paymentRevenuesTypeId = _data["paymentRevenuesTypeId"];
      this.paymentRevenuesType = _data["paymentRevenuesType"];
      this.value = _data["value"];
      this.notes = _data["notes"];
      this.statement = _data["statement"];
      this.date = _data["date"]
        ? moment(_data["date"].toString())
        : <any>undefined;
      this.transactionId = _data["transactionId"];
    }
  }

  static fromJS(data: any): PaymentRevenueDto {
    data = typeof data === "object" ? data : {};
    let result = new PaymentRevenueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["paymentRevenueSerial"] = this.paymentRevenueSerial;
    data["shiftCashierId"] = this.shiftCashierId;
    data["paymentRevenuesTypeId"] = this.paymentRevenuesTypeId;
    data["paymentRevenuesType"] = this.paymentRevenuesType;
    data["value"] = this.value;
    data["notes"] = this.notes;
    data["statement"] = this.statement;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    data["transactionId"] = this.transactionId;
    return data;
  }

  clone(): PaymentRevenueDto {
    const json = this.toJSON();
    let result = new PaymentRevenueDto();
    result.init(json);
    return result;
  }
}

export interface IPaymentRevenueDto {
  id: number;
  paymentRevenueSerial: string | undefined;
  shiftCashierId: number;
  paymentRevenuesTypeId: number;
  paymentRevenuesType: string | undefined;
  value: number;
  notes: string | undefined;
  statement: string | undefined;
  date: moment.Moment;
  transactionId: number | undefined;
}

export class PaymentRevenueDtoPageResultDTO
  implements IPaymentRevenueDtoPageResultDTO
{
  count: number;
  pageIndex: number;
  pageSize: number;
  items: PaymentRevenueDto[] | undefined;

  constructor(data?: IPaymentRevenueDtoPageResultDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data["count"];
      this.pageIndex = _data["pageIndex"];
      this.pageSize = _data["pageSize"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(PaymentRevenueDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PaymentRevenueDtoPageResultDTO {
    data = typeof data === "object" ? data : {};
    let result = new PaymentRevenueDtoPageResultDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["count"] = this.count;
    data["pageIndex"] = this.pageIndex;
    data["pageSize"] = this.pageSize;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): PaymentRevenueDtoPageResultDTO {
    const json = this.toJSON();
    let result = new PaymentRevenueDtoPageResultDTO();
    result.init(json);
    return result;
  }
}

export interface IPaymentRevenueDtoPageResultDTO {
  count: number;
  pageIndex: number;
  pageSize: number;
  items: PaymentRevenueDto[] | undefined;
}

export class PointOfSaleDefinitionDTO implements IPointOfSaleDefinitionDTO {
  id: number;
  companyBranchId: number;
  statisticaL_CODE: string | undefined;
  ocF_Code: number;
  posCode: string | undefined;
  shortDescription: string | undefined;
  posAdress: string | undefined;
  personInChargeNID: string | undefined;
  personInChargeNatCode: number | undefined;
  telNo: string | undefined;
  faxNo: string | undefined;
  email: string | undefined;
  gpsAdress: string | undefined;
  imageURL: string | undefined;
  onlineId: number | undefined;
  january: number | undefined;
  february: number | undefined;
  march: number | undefined;
  april: number | undefined;
  may: number | undefined;
  june: number | undefined;
  july: number | undefined;
  august: number | undefined;
  september: number | undefined;
  october: number | undefined;
  november: number | undefined;
  december: number | undefined;
  isAuction: boolean | undefined;
  displayProductName: boolean;
  displayAvailableQuantity: boolean;
  displayProductPrice: boolean | undefined;
  displayCompanyName: boolean | undefined;
  displayDiscountBonus: boolean | undefined;
  priceInclusiveTax: boolean | undefined;
  displayProductUnit: boolean | undefined;
  displayProductWithoutCredit: boolean | undefined;
  printCashierVoucher: number| undefined;
  printBigCashierVoucher: boolean;
  password: string | undefined;
  code: string | undefined;

  saturday: number | undefined;
  sunday: number | undefined;
  monday: number | undefined;
  tuesday: number | undefined;
  wednesday: number | undefined;
  thursday: number | undefined;
  friday: number | undefined;

  constructor(data?: IPointOfSaleDefinitionDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.companyBranchId = _data["companyBranchId"];
      this.statisticaL_CODE = _data["statisticaL_CODE"];
      this.ocF_Code = _data["ocF_Code"];
      this.posCode = _data["posCode"];
      this.shortDescription = _data["shortDescription"];
      this.posAdress = _data["posAdress"];
      this.personInChargeNID = _data["personInChargeNID"];
      this.personInChargeNatCode = _data["personInChargeNatCode"];
      this.telNo = _data["telNo"];
      this.faxNo = _data["faxNo"];
      this.email = _data["email"];
      this.gpsAdress = _data["gpsAdress"];
      this.imageURL = _data["imageURL"];
      this.onlineId = _data["onlineId"];
      this.january = _data["january"];
      this.february = _data["february"];
      this.march = _data["march"];
      this.april = _data["april"];
      this.may = _data["may"];
      this.june = _data["june"];
      this.july = _data["july"];
      this.august = _data["august"];
      this.september = _data["september"];
      this.october = _data["october"];
      this.november = _data["november"];
      this.december = _data["december"];
      this.isAuction = _data["isAuction"];
      this.displayProductName = _data["displayProductName"];
      this.displayAvailableQuantity = _data["displayAvailableQuantity"];
      this.displayProductPrice = _data["displayProductPrice"];
      this.displayCompanyName = _data["displayCompanyName"];
      this.displayDiscountBonus = _data["displayDiscountBonus"];
      this.priceInclusiveTax = _data["priceInclusiveTax"];
      this.displayProductUnit = _data["displayProductUnit"];
      this.displayProductWithoutCredit = _data["displayProductWithoutCredit"];
      this.printCashierVoucher = _data["printCashierVoucher"];
      this.printBigCashierVoucher = _data["printBigCashierVoucher"];
      this.password = _data["password"];
      this.code = _data["code"];
      this.saturday = _data["saturday"];
      this.sunday = _data["sunday"];
      this.monday = _data["monday"];
      this.tuesday = _data["tuesday"];
      this.wednesday = _data["wednesday"];
      this.thursday = _data["thursday"];
      this.friday = _data["friday"];
    }
  }

  static fromJS(data: any): PointOfSaleDefinitionDTO {
    data = typeof data === "object" ? data : {};
    let result = new PointOfSaleDefinitionDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["companyBranchId"] = this.companyBranchId;
    data["statisticaL_CODE"] = this.statisticaL_CODE;
    data["ocF_Code"] = this.ocF_Code;
    data["posCode"] = this.posCode;
    data["shortDescription"] = this.shortDescription;
    data["posAdress"] = this.posAdress;
    data["personInChargeNID"] = this.personInChargeNID;
    data["personInChargeNatCode"] = this.personInChargeNatCode;
    data["telNo"] = this.telNo;
    data["faxNo"] = this.faxNo;
    data["email"] = this.email;
    data["gpsAdress"] = this.gpsAdress;
    data["imageURL"] = this.imageURL;
    data["onlineId"] = this.onlineId;
    data["january"] = this.january;
    data["february"] = this.february;
    data["march"] = this.march;
    data["april"] = this.april;
    data["may"] = this.may;
    data["june"] = this.june;
    data["july"] = this.july;
    data["august"] = this.august;
    data["september"] = this.september;
    data["october"] = this.october;
    data["november"] = this.november;
    data["december"] = this.december;
    data["isAuction"] = this.isAuction;
    data["displayProductName"] = this.displayProductName;
    data["displayAvailableQuantity"] = this.displayAvailableQuantity;
    data["displayProductPrice"] = this.displayProductPrice;
    data["displayCompanyName"] = this.displayCompanyName;
    data["displayDiscountBonus"] = this.displayDiscountBonus;
    data["priceInclusiveTax"] = this.priceInclusiveTax;
    data["displayProductUnit"] = this.displayProductUnit;
    data["displayProductWithoutCredit"] = this.displayProductWithoutCredit;
    data["printCashierVoucher"] = this.printCashierVoucher;
    data["printBigCashierVoucher"] = this.printBigCashierVoucher;
    data["password"] = this.password;
    data["code"] = this.code;
    data["saturday"] = this.saturday;
    data["sunday"] = this.sunday;
    data["monday"] = this.monday;
    data["tuesday"] = this.tuesday;
    data["wednesday"] = this.wednesday;
    data["thursday"] = this.thursday;
    data["friday"] = this.friday;

    return data;
  }

  clone(): PointOfSaleDefinitionDTO {
    const json = this.toJSON();
    let result = new PointOfSaleDefinitionDTO();
    result.init(json);
    return result;
  }
}

export interface IPointOfSaleDefinitionDTO {
  id: number;
  companyBranchId: number;
  statisticaL_CODE: string | undefined;
  ocF_Code: number;
  posCode: string | undefined;
  shortDescription: string | undefined;
  posAdress: string | undefined;
  personInChargeNID: string | undefined;
  personInChargeNatCode: number | undefined;
  telNo: string | undefined;
  faxNo: string | undefined;
  email: string | undefined;
  gpsAdress: string | undefined;
  imageURL: string | undefined;
  onlineId: number | undefined;
  january: number | undefined;
  february: number | undefined;
  march: number | undefined;
  april: number | undefined;
  may: number | undefined;
  june: number | undefined;
  july: number | undefined;
  august: number | undefined;
  september: number | undefined;
  october: number | undefined;
  november: number | undefined;
  december: number | undefined;
  isAuction: boolean | undefined;
  displayProductName: boolean;
  displayAvailableQuantity: boolean;
  displayProductPrice: boolean | undefined;
  displayCompanyName: boolean | undefined;
  displayDiscountBonus: boolean | undefined;
  priceInclusiveTax: boolean | undefined;
  displayProductUnit: boolean | undefined;
  displayProductWithoutCredit: boolean | undefined;
  printCashierVoucher: number | undefined;
  printBigCashierVoucher: boolean;

  password: string | undefined;
  code: string | undefined;

  saturday: number | undefined;
  sunday: number | undefined;
  monday: number | undefined;
  tuesday: number | undefined;
  wednesday: number | undefined;
  thursday: number | undefined;
  friday: number | undefined;
}

export class MonthlyTargetDTO implements IMonthlyTargetDTO {
  targetPercentage: number;
  salesTotal: number | undefined;
  monthlyTarget: number | undefined;

  constructor(data?: IMonthlyTargetDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.targetPercentage = _data["targetPercentage"];
      this.salesTotal = _data["salesTotal"];
      this.monthlyTarget = _data["monthlyTarget"];
    }
  }

  static fromJS(data: any): MonthlyTargetDTO {
    data = typeof data === "object" ? data : {};
    let result = new MonthlyTargetDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["targetPercentage"] = this.targetPercentage;
    data["salesTotal"] = this.salesTotal;
    data["monthlyTarget"] = this.monthlyTarget;
    return data;
  }

  clone(): MonthlyTargetDTO {
    const json = this.toJSON();
    let result = new MonthlyTargetDTO();
    result.init(json);
    return result;
  }
}

export interface IMonthlyTargetDTO {
  targetPercentage: number;
  salesTotal: number | undefined;
  monthlyTarget: number | undefined;
}

export class DailyTargetDTO implements IDailyTargetDTO {
  targetPercentage: number;
  salesTotal: number | undefined;
  dailyTarget: number | undefined;

  constructor(data?: IDailyTargetDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.targetPercentage = _data["targetPercentage"];
      this.salesTotal = _data["salesTotal"];
      this.dailyTarget = _data["dailyTarget"];
    }
  }

  static fromJS(data: any): DailyTargetDTO {
    data = typeof data === "object" ? data : {};
    let result = new DailyTargetDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["targetPercentage"] = this.targetPercentage;
    data["salesTotal"] = this.salesTotal;
    data["dailyTarget"] = this.dailyTarget;
    return data;
  }

  clone(): DailyTargetDTO {
    const json = this.toJSON();
    let result = new DailyTargetDTO();
    result.init(json);
    return result;
  }
}

export interface IDailyTargetDTO {
  targetPercentage: number;
  salesTotal: number | undefined;
  dailyTarget: number | undefined;
}

export class POS_UserSettingDTO implements IPOS_UserSettingDTO {
  userId: number;
  personNid: string | undefined;
  natCode: number;
  posId: number;

  constructor(data?: IPOS_UserSettingDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.personNid = _data["personNid"];
      this.natCode = _data["natCode"];
      this.posId = _data["posId"];
    }
  }

  static fromJS(data: any): POS_UserSettingDTO {
    data = typeof data === "object" ? data : {};
    let result = new POS_UserSettingDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userId"] = this.userId;
    data["personNid"] = this.personNid;
    data["natCode"] = this.natCode;
    data["posId"] = this.posId;
    return data;
  }

  clone(): POS_UserSettingDTO {
    const json = this.toJSON();
    let result = new POS_UserSettingDTO();
    result.init(json);
    return result;
  }
}

export interface IPOS_UserSettingDTO {
  userId: number;
  personNid: string | undefined;
  natCode: number;
  posId: number;
}

export class ReservationDto implements IReservationDto {
  id: number;
  tableID: number;
  tableName: string | undefined;
  date: moment.Moment;
  startTimeStr: string | undefined;
  endTimeStr: string | undefined;
  count: number;
  loungeID: number;
  loungeName: string | undefined;
  clientName: string | undefined;
  clientPhone: string | undefined;

  constructor(data?: IReservationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.tableID = _data["tableID"];
      this.tableName = _data["tableName"];
      this.date = _data["date"]
        ? moment(_data["date"].toString())
        : <any>undefined;
      this.startTimeStr = _data["startTimeStr"];
      this.endTimeStr = _data["endTimeStr"];
      this.count = _data["count"];
      this.loungeID = _data["loungeID"];
      this.loungeName = _data["loungeName"];
      this.clientName = _data["clientName"];
      this.clientPhone = _data["clientPhone"];
    }
  }

  static fromJS(data: any): ReservationDto {
    data = typeof data === "object" ? data : {};
    let result = new ReservationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["tableID"] = this.tableID;
    data["tableName"] = this.tableName;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    data["startTimeStr"] = this.startTimeStr;
    data["endTimeStr"] = this.endTimeStr;
    data["count"] = this.count;
    data["loungeID"] = this.loungeID;
    data["loungeName"] = this.loungeName;
    data["clientName"] = this.clientName;
    data["clientPhone"] = this.clientPhone;
    return data;
  }

  clone(): ReservationDto {
    const json = this.toJSON();
    let result = new ReservationDto();
    result.init(json);
    return result;
  }
}

export interface IReservationDto {
  id: number;
  tableID: number;
  tableName: string | undefined;
  date: moment.Moment;
  startTimeStr: string | undefined;
  endTimeStr: string | undefined;
  count: number;
  loungeID: number;
  loungeName: string | undefined;
  clientName: string | undefined;
  clientPhone: string | undefined;
}

export class ReservationDtoListResultDto
  implements IReservationDtoListResultDto
{
  items: ReservationDto[] | undefined;

  constructor(data?: IReservationDtoListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(ReservationDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ReservationDtoListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new ReservationDtoListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): ReservationDtoListResultDto {
    const json = this.toJSON();
    let result = new ReservationDtoListResultDto();
    result.init(json);
    return result;
  }
}

export interface IReservationDtoListResultDto {
  items: ReservationDto[] | undefined;
}

export class ReservationDtoPageResultDTO
  implements IReservationDtoPageResultDTO
{
  count: number;
  pageIndex: number;
  pageSize: number;
  items: ReservationDto[] | undefined;

  constructor(data?: IReservationDtoPageResultDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data["count"];
      this.pageIndex = _data["pageIndex"];
      this.pageSize = _data["pageSize"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(ReservationDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ReservationDtoPageResultDTO {
    data = typeof data === "object" ? data : {};
    let result = new ReservationDtoPageResultDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["count"] = this.count;
    data["pageIndex"] = this.pageIndex;
    data["pageSize"] = this.pageSize;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): ReservationDtoPageResultDTO {
    const json = this.toJSON();
    let result = new ReservationDtoPageResultDTO();
    result.init(json);
    return result;
  }
}

export interface IReservationDtoPageResultDTO {
  count: number;
  pageIndex: number;
  pageSize: number;
  items: ReservationDto[] | undefined;
}

export class DropdownListDto implements IDropdownListDto {
  loungesDDL: LoungeDto[] | undefined;
  tablesDDL: TableDto[] | undefined;

  constructor(data?: IDropdownListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["loungesDDL"])) {
        this.loungesDDL = [] as any;
        for (let item of _data["loungesDDL"])
          this.loungesDDL.push(LoungeDto.fromJS(item));
      }
      if (Array.isArray(_data["tablesDDL"])) {
        this.tablesDDL = [] as any;
        for (let item of _data["tablesDDL"])
          this.tablesDDL.push(TableDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DropdownListDto {
    data = typeof data === "object" ? data : {};
    let result = new DropdownListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.loungesDDL)) {
      data["loungesDDL"] = [];
      for (let item of this.loungesDDL) data["loungesDDL"].push(item.toJSON());
    }
    if (Array.isArray(this.tablesDDL)) {
      data["tablesDDL"] = [];
      for (let item of this.tablesDDL) data["tablesDDL"].push(item.toJSON());
    }
    return data;
  }

  clone(): DropdownListDto {
    const json = this.toJSON();
    let result = new DropdownListDto();
    result.init(json);
    return result;
  }
}

export interface IDropdownListDto {
  loungesDDL: LoungeDto[] | undefined;
  tablesDDL: TableDto[] | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
  name: string;
  displayName: string;
  normalizedName: string | undefined;
  description: string | undefined;
  grantedPermissions: string[] | undefined;

  constructor(data?: ICreateRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.normalizedName = _data["normalizedName"];
      this.description = _data["description"];
      if (Array.isArray(_data["grantedPermissions"])) {
        this.grantedPermissions = [] as any;
        for (let item of _data["grantedPermissions"])
          this.grantedPermissions.push(item);
      }
    }
  }

  static fromJS(data: any): CreateRoleDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["normalizedName"] = this.normalizedName;
    data["description"] = this.description;
    if (Array.isArray(this.grantedPermissions)) {
      data["grantedPermissions"] = [];
      for (let item of this.grantedPermissions)
        data["grantedPermissions"].push(item);
    }
    return data;
  }

  clone(): CreateRoleDto {
    const json = this.toJSON();
    let result = new CreateRoleDto();
    result.init(json);
    return result;
  }
}

export interface ICreateRoleDto {
  name: string;
  displayName: string;
  normalizedName: string | undefined;
  description: string | undefined;
  grantedPermissions: string[] | undefined;
}

export class RoleDto implements IRoleDto {
  name: string;
  displayName: string;
  normalizedName: string | undefined;
  description: string | undefined;
  grantedPermissions: string[] | undefined;
  id: number;

  constructor(data?: IRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.normalizedName = _data["normalizedName"];
      this.description = _data["description"];
      if (Array.isArray(_data["grantedPermissions"])) {
        this.grantedPermissions = [] as any;
        for (let item of _data["grantedPermissions"])
          this.grantedPermissions.push(item);
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): RoleDto {
    data = typeof data === "object" ? data : {};
    let result = new RoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["normalizedName"] = this.normalizedName;
    data["description"] = this.description;
    if (Array.isArray(this.grantedPermissions)) {
      data["grantedPermissions"] = [];
      for (let item of this.grantedPermissions)
        data["grantedPermissions"].push(item);
    }
    data["id"] = this.id;
    return data;
  }

  clone(): RoleDto {
    const json = this.toJSON();
    let result = new RoleDto();
    result.init(json);
    return result;
  }
}

export interface IRoleDto {
  name: string;
  displayName: string;
  normalizedName: string | undefined;
  description: string | undefined;
  grantedPermissions: string[] | undefined;
  id: number;
}

export class RoleListDto implements IRoleListDto {
  name: string | undefined;
  displayName: string | undefined;
  isStatic: boolean;
  isDefault: boolean;
  creationTime: moment.Moment;
  id: number;

  constructor(data?: IRoleListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.isStatic = _data["isStatic"];
      this.isDefault = _data["isDefault"];
      this.creationTime = _data["creationTime"]
        ? moment(_data["creationTime"].toString())
        : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): RoleListDto {
    data = typeof data === "object" ? data : {};
    let result = new RoleListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["isStatic"] = this.isStatic;
    data["isDefault"] = this.isDefault;
    data["creationTime"] = this.creationTime
      ? this.creationTime.toISOString()
      : <any>undefined;
    data["id"] = this.id;
    return data;
  }

  clone(): RoleListDto {
    const json = this.toJSON();
    let result = new RoleListDto();
    result.init(json);
    return result;
  }
}

export interface IRoleListDto {
  name: string | undefined;
  displayName: string | undefined;
  isStatic: boolean;
  isDefault: boolean;
  creationTime: moment.Moment;
  id: number;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
  items: RoleListDto[] | undefined;

  constructor(data?: IRoleListDtoListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(RoleListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RoleListDtoListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new RoleListDtoListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): RoleListDtoListResultDto {
    const json = this.toJSON();
    let result = new RoleListDtoListResultDto();
    result.init(json);
    return result;
  }
}

export interface IRoleListDtoListResultDto {
  items: RoleListDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;
  id: number;

  constructor(data?: IPermissionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.description = _data["description"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): PermissionDto {
    data = typeof data === "object" ? data : {};
    let result = new PermissionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["description"] = this.description;
    data["id"] = this.id;
    return data;
  }

  clone(): PermissionDto {
    const json = this.toJSON();
    let result = new PermissionDto();
    result.init(json);
    return result;
  }
}

export interface IPermissionDto {
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;
  id: number;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
  items: PermissionDto[] | undefined;

  constructor(data?: IPermissionDtoListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(PermissionDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PermissionDtoListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new PermissionDtoListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): PermissionDtoListResultDto {
    const json = this.toJSON();
    let result = new PermissionDtoListResultDto();
    result.init(json);
    return result;
  }
}

export interface IPermissionDtoListResultDto {
  items: PermissionDto[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
  name: string;
  displayName: string;
  description: string | undefined;
  isStatic: boolean;
  id: number;

  constructor(data?: IRoleEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.description = _data["description"];
      this.isStatic = _data["isStatic"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): RoleEditDto {
    data = typeof data === "object" ? data : {};
    let result = new RoleEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["description"] = this.description;
    data["isStatic"] = this.isStatic;
    data["id"] = this.id;
    return data;
  }

  clone(): RoleEditDto {
    const json = this.toJSON();
    let result = new RoleEditDto();
    result.init(json);
    return result;
  }
}

export interface IRoleEditDto {
  name: string;
  displayName: string;
  description: string | undefined;
  isStatic: boolean;
  id: number;
}

export class FlatPermissionDto implements IFlatPermissionDto {
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;

  constructor(data?: IFlatPermissionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): FlatPermissionDto {
    data = typeof data === "object" ? data : {};
    let result = new FlatPermissionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["description"] = this.description;
    return data;
  }

  clone(): FlatPermissionDto {
    const json = this.toJSON();
    let result = new FlatPermissionDto();
    result.init(json);
    return result;
  }
}

export interface IFlatPermissionDto {
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
  role: RoleEditDto;
  permissions: FlatPermissionDto[] | undefined;
  grantedPermissionNames: string[] | undefined;

  constructor(data?: IGetRoleForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.role = _data["role"]
        ? RoleEditDto.fromJS(_data["role"])
        : <any>undefined;
      if (Array.isArray(_data["permissions"])) {
        this.permissions = [] as any;
        for (let item of _data["permissions"])
          this.permissions.push(FlatPermissionDto.fromJS(item));
      }
      if (Array.isArray(_data["grantedPermissionNames"])) {
        this.grantedPermissionNames = [] as any;
        for (let item of _data["grantedPermissionNames"])
          this.grantedPermissionNames.push(item);
      }
    }
  }

  static fromJS(data: any): GetRoleForEditOutput {
    data = typeof data === "object" ? data : {};
    let result = new GetRoleForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["role"] = this.role ? this.role.toJSON() : <any>undefined;
    if (Array.isArray(this.permissions)) {
      data["permissions"] = [];
      for (let item of this.permissions)
        data["permissions"].push(item.toJSON());
    }
    if (Array.isArray(this.grantedPermissionNames)) {
      data["grantedPermissionNames"] = [];
      for (let item of this.grantedPermissionNames)
        data["grantedPermissionNames"].push(item);
    }
    return data;
  }

  clone(): GetRoleForEditOutput {
    const json = this.toJSON();
    let result = new GetRoleForEditOutput();
    result.init(json);
    return result;
  }
}

export interface IGetRoleForEditOutput {
  role: RoleEditDto;
  permissions: FlatPermissionDto[] | undefined;
  grantedPermissionNames: string[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
  totalCount: number;
  items: RoleDto[] | undefined;

  constructor(data?: IRoleDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items.push(RoleDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RoleDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new RoleDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): RoleDtoPagedResultDto {
    const json = this.toJSON();
    let result = new RoleDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IRoleDtoPagedResultDto {
  totalCount: number;
  items: RoleDto[] | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
  version: string | undefined;
  releaseDate: moment.Moment;
  features: { [key: string]: boolean } | undefined;

  constructor(data?: IApplicationInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.version = _data["version"];
      this.releaseDate = _data["releaseDate"]
        ? moment(_data["releaseDate"].toString())
        : <any>undefined;
      if (_data["features"]) {
        this.features = {} as any;
        for (let key in _data["features"]) {
          if (_data["features"].hasOwnProperty(key))
            this.features[key] = _data["features"][key];
        }
      }
    }
  }

  static fromJS(data: any): ApplicationInfoDto {
    data = typeof data === "object" ? data : {};
    let result = new ApplicationInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["version"] = this.version;
    data["releaseDate"] = this.releaseDate
      ? this.releaseDate.toISOString()
      : <any>undefined;
    if (this.features) {
      data["features"] = {};
      for (let key in this.features) {
        if (this.features.hasOwnProperty(key))
          data["features"][key] = this.features[key];
      }
    }
    return data;
  }

  clone(): ApplicationInfoDto {
    const json = this.toJSON();
    let result = new ApplicationInfoDto();
    result.init(json);
    return result;
  }
}

export interface IApplicationInfoDto {
  version: string | undefined;
  releaseDate: moment.Moment;
  features: { [key: string]: boolean } | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
  name: string | undefined;
  surname: string | undefined;
  userName: string | undefined;
  emailAddress: string | undefined;
  id: number;

  constructor(data?: IUserLoginInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.surname = _data["surname"];
      this.userName = _data["userName"];
      this.emailAddress = _data["emailAddress"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): UserLoginInfoDto {
    data = typeof data === "object" ? data : {};
    let result = new UserLoginInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["surname"] = this.surname;
    data["userName"] = this.userName;
    data["emailAddress"] = this.emailAddress;
    data["id"] = this.id;
    return data;
  }

  clone(): UserLoginInfoDto {
    const json = this.toJSON();
    let result = new UserLoginInfoDto();
    result.init(json);
    return result;
  }
}

export interface IUserLoginInfoDto {
  name: string | undefined;
  surname: string | undefined;
  userName: string | undefined;
  emailAddress: string | undefined;
  id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
  tenancyName: string | undefined;
  name: string | undefined;
  id: number;

  constructor(data?: ITenantLoginInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data["tenancyName"];
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TenantLoginInfoDto {
    data = typeof data === "object" ? data : {};
    let result = new TenantLoginInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["tenancyName"] = this.tenancyName;
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }

  clone(): TenantLoginInfoDto {
    const json = this.toJSON();
    let result = new TenantLoginInfoDto();
    result.init(json);
    return result;
  }
}

export interface ITenantLoginInfoDto {
  tenancyName: string | undefined;
  name: string | undefined;
  id: number;
}

export class GetCurrentLoginInformationsOutput
  implements IGetCurrentLoginInformationsOutput
{
  application: ApplicationInfoDto;
  user: UserLoginInfoDto;
  tenant: TenantLoginInfoDto;
  pointOfSaleDefinition: PointOfSaleDefinitionDTO;
  shiftCashierId: number;

  constructor(data?: IGetCurrentLoginInformationsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.application = _data["application"]
        ? ApplicationInfoDto.fromJS(_data["application"])
        : <any>undefined;
      this.user = _data["user"]
        ? UserLoginInfoDto.fromJS(_data["user"])
        : <any>undefined;
      this.tenant = _data["tenant"]
        ? TenantLoginInfoDto.fromJS(_data["tenant"])
        : <any>undefined;
      this.pointOfSaleDefinition = _data["pointOfSaleDefinition"]
        ? PointOfSaleDefinitionDTO.fromJS(_data["pointOfSaleDefinition"])
        : <any>undefined;
      this.shiftCashierId = _data["shiftCashierId"];
    }
  }

  static fromJS(data: any): GetCurrentLoginInformationsOutput {
    data = typeof data === "object" ? data : {};
    let result = new GetCurrentLoginInformationsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["application"] = this.application
      ? this.application.toJSON()
      : <any>undefined;
    data["user"] = this.user ? this.user.toJSON() : <any>undefined;
    data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
    data["pointOfSaleDefinition"] = this.pointOfSaleDefinition
      ? this.pointOfSaleDefinition.toJSON()
      : <any>undefined;
    data["shiftCashierId"] = this.shiftCashierId;
    return data;
  }

  clone(): GetCurrentLoginInformationsOutput {
    const json = this.toJSON();
    let result = new GetCurrentLoginInformationsOutput();
    result.init(json);
    return result;
  }
}

export interface IGetCurrentLoginInformationsOutput {
  application: ApplicationInfoDto;
  user: UserLoginInfoDto;
  tenant: TenantLoginInfoDto;
  pointOfSaleDefinition: PointOfSaleDefinitionDTO;
  shiftCashierId: number;
}

export class PaymentMethodDTO implements IPaymentMethodDTO {
  id: number;
  paymentMethodName: string | undefined;

  constructor(data?: IPaymentMethodDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.paymentMethodName = _data["paymentMethodName"];
    }
  }

  static fromJS(data: any): PaymentMethodDTO {
    data = typeof data === "object" ? data : {};
    let result = new PaymentMethodDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["paymentMethodName"] = this.paymentMethodName;
    return data;
  }

  clone(): PaymentMethodDTO {
    const json = this.toJSON();
    let result = new PaymentMethodDTO();
    result.init(json);
    return result;
  }
}

export interface IPaymentMethodDTO {
  id: number;
  paymentMethodName: string | undefined;
}

export class PaymentMethodDTOListResultDto
  implements IPaymentMethodDTOListResultDto
{
  items: PaymentMethodDTO[] | undefined;

  constructor(data?: IPaymentMethodDTOListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(PaymentMethodDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PaymentMethodDTOListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new PaymentMethodDTOListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): PaymentMethodDTOListResultDto {
    const json = this.toJSON();
    let result = new PaymentMethodDTOListResultDto();
    result.init(json);
    return result;
  }
}

export interface IPaymentMethodDTOListResultDto {
  items: PaymentMethodDTO[] | undefined;
}

export class DiscountBonusDTO implements IDiscountBonusDTO {
  id: number;
  bonusDiscountName: string | undefined;
  bonusDiscountFlage: boolean;
  taxId: number | undefined;
  taxPercentage: number;
  percentage: number;
  value: number | undefined;
  valueAfterTax: number | undefined;

  constructor(data?: IDiscountBonusDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.bonusDiscountName = _data["bonusDiscountName"];
      this.bonusDiscountFlage = _data["bonusDiscountFlage"];
      this.taxId = _data["taxId"];
      this.taxPercentage = _data["taxPercentage"];
      this.percentage = _data["percentage"];
      this.value = _data["value"];
      this.valueAfterTax = _data["valueAfterTax"];
    }
  }

  static fromJS(data: any): DiscountBonusDTO {
    data = typeof data === "object" ? data : {};
    let result = new DiscountBonusDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["bonusDiscountName"] = this.bonusDiscountName;
    data["bonusDiscountFlage"] = this.bonusDiscountFlage;
    data["taxId"] = this.taxId;
    data["taxPercentage"] = this.taxPercentage;
    data["percentage"] = this.percentage;
    data["value"] = this.value;
    data["valueAfterTax"] = this.valueAfterTax;
    return data;
  }

  clone(): DiscountBonusDTO {
    const json = this.toJSON();
    let result = new DiscountBonusDTO();
    result.init(json);
    return result;
  }
}

export interface IDiscountBonusDTO {
  id: number;
  bonusDiscountName: string | undefined;
  bonusDiscountFlage: boolean;
  taxId: number | undefined;
  taxPercentage: number;
  percentage: number;
  value: number | undefined;
  valueAfterTax: number | undefined;
}

export class DiscountBonusDTOListResultDto
  implements IDiscountBonusDTOListResultDto
{
  items: DiscountBonusDTO[] | undefined;

  constructor(data?: IDiscountBonusDTOListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(DiscountBonusDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DiscountBonusDTOListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new DiscountBonusDTOListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): DiscountBonusDTOListResultDto {
    const json = this.toJSON();
    let result = new DiscountBonusDTOListResultDto();
    result.init(json);
    return result;
  }
}

export interface IDiscountBonusDTOListResultDto {
  items: DiscountBonusDTO[] | undefined;
}

export class CM_BanksDTO implements ICM_BanksDTO {
  id: number;
  name: string | undefined;

  constructor(data?: ICM_BanksDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): CM_BanksDTO {
    data = typeof data === "object" ? data : {};
    let result = new CM_BanksDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }

  clone(): CM_BanksDTO {
    const json = this.toJSON();
    let result = new CM_BanksDTO();
    result.init(json);
    return result;
  }
}

export interface ICM_BanksDTO {
  id: number;
  name: string | undefined;
}

export class CM_BanksDTOListResultDto implements ICM_BanksDTOListResultDto {
  items: CM_BanksDTO[] | undefined;

  constructor(data?: ICM_BanksDTOListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(CM_BanksDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CM_BanksDTOListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new CM_BanksDTOListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): CM_BanksDTOListResultDto {
    const json = this.toJSON();
    let result = new CM_BanksDTOListResultDto();
    result.init(json);
    return result;
  }
}

export interface ICM_BanksDTOListResultDto {
  items: CM_BanksDTO[] | undefined;
}

export class PersonDTO implements IPersonDTO {
  nid: string | undefined;
  naT_CODE: number;
  fullName: string | undefined;

  constructor(data?: IPersonDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.nid = _data["nid"];
      this.naT_CODE = _data["naT_CODE"];
      this.fullName = _data["fullName"];
    }
  }

  static fromJS(data: any): PersonDTO {
    data = typeof data === "object" ? data : {};
    let result = new PersonDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["nid"] = this.nid;
    data["naT_CODE"] = this.naT_CODE;
    data["fullName"] = this.fullName;
    return data;
  }

  clone(): PersonDTO {
    const json = this.toJSON();
    let result = new PersonDTO();
    result.init(json);
    return result;
  }
}

export interface IPersonDTO {
  nid: string | undefined;
  naT_CODE: number;
  fullName: string | undefined;
}

export class PersonDTOListResultDto implements IPersonDTOListResultDto {
  items: PersonDTO[] | undefined;

  constructor(data?: IPersonDTOListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(PersonDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PersonDTOListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new PersonDTOListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): PersonDTOListResultDto {
    const json = this.toJSON();
    let result = new PersonDTOListResultDto();
    result.init(json);
    return result;
  }
}

export interface IPersonDTOListResultDto {
  items: PersonDTO[] | undefined;
}

export class PrintTemplateDataDTO implements IPrintTemplateDataDTO {
  image: string | undefined;
  companyName: string | undefined;
  posName: string | undefined;
  posAdress: string | undefined;
  taxRegistrationNo: string | undefined;

  constructor(data?: IPrintTemplateDataDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.image = _data["image"];
      this.companyName = _data["companyName"];
      this.posName = _data["posName"];
      this.posAdress = _data["posAdress"];
      this.taxRegistrationNo = _data["taxRegistrationNo"];
    }
  }

  static fromJS(data: any): PrintTemplateDataDTO {
    data = typeof data === "object" ? data : {};
    let result = new PrintTemplateDataDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["image"] = this.image;
    data["companyName"] = this.companyName;
    data["posName"] = this.posName;
    data["posAdress"] = this.posAdress;
    data["taxRegistrationNo"] = this.taxRegistrationNo;
    return data;
  }

  clone(): PrintTemplateDataDTO {
    const json = this.toJSON();
    let result = new PrintTemplateDataDTO();
    result.init(json);
    return result;
  }
}

export interface IPrintTemplateDataDTO {
  image: string | undefined;
  companyName: string | undefined;
  posName: string | undefined;
  posAdress: string | undefined;
  taxRegistrationNo: string | undefined;
}

export class TaxDTO implements ITaxDTO {
  taxID: number;
  taxName: string | undefined;
  taxNameE: string | undefined;
  validFrom: moment.Moment;
  validTo: moment.Moment | undefined;
  percentage: number;
  tax_TypeID: number | undefined;
  taxNature: boolean | undefined;
  accountNO: number | undefined;

  constructor(data?: ITaxDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.taxID = _data["taxID"];
      this.taxName = _data["taxName"];
      this.taxNameE = _data["taxNameE"];
      this.validFrom = _data["validFrom"]
        ? moment(_data["validFrom"].toString())
        : <any>undefined;
      this.validTo = _data["validTo"]
        ? moment(_data["validTo"].toString())
        : <any>undefined;
      this.percentage = _data["percentage"];
      this.tax_TypeID = _data["tax_TypeID"];
      this.taxNature = _data["taxNature"];
      this.accountNO = _data["accountNO"];
    }
  }

  static fromJS(data: any): TaxDTO {
    data = typeof data === "object" ? data : {};
    let result = new TaxDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["taxID"] = this.taxID;
    data["taxName"] = this.taxName;
    data["taxNameE"] = this.taxNameE;
    data["validFrom"] = this.validFrom
      ? this.validFrom.toISOString()
      : <any>undefined;
    data["validTo"] = this.validTo
      ? this.validTo.toISOString()
      : <any>undefined;
    data["percentage"] = this.percentage;
    data["tax_TypeID"] = this.tax_TypeID;
    data["taxNature"] = this.taxNature;
    data["accountNO"] = this.accountNO;
    return data;
  }

  clone(): TaxDTO {
    const json = this.toJSON();
    let result = new TaxDTO();
    result.init(json);
    return result;
  }
}

export interface ITaxDTO {
  taxID: number;
  taxName: string | undefined;
  taxNameE: string | undefined;
  validFrom: moment.Moment;
  validTo: moment.Moment | undefined;
  percentage: number;
  tax_TypeID: number | undefined;
  taxNature: boolean | undefined;
  accountNO: number | undefined;
}

export class TaxDTOListResultDto implements ITaxDTOListResultDto {
  items: TaxDTO[] | undefined;

  constructor(data?: ITaxDTOListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items.push(TaxDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): TaxDTOListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new TaxDTOListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): TaxDTOListResultDto {
    const json = this.toJSON();
    let result = new TaxDTOListResultDto();
    result.init(json);
    return result;
  }
}

export interface ITaxDTOListResultDto {
  items: TaxDTO[] | undefined;
}

export class GOVERNRATEDTO implements IGOVERNRATEDTO {
  goV_CODE: number;
  name: string | undefined;
  namE_ENGLISH: string | undefined;
  namE_FRENCH: string | undefined;
  namE_GERMAN: string | undefined;
  namE_ITALIAN: string | undefined;
  namE_SPANISH: string | undefined;
  postaL_CODE: string | undefined;
  map: string | undefined;
  websitE_ADDRESS: string | undefined;
  emaiL_ADDRESS: string | undefined;

  constructor(data?: IGOVERNRATEDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.goV_CODE = _data["goV_CODE"];
      this.name = _data["name"];
      this.namE_ENGLISH = _data["namE_ENGLISH"];
      this.namE_FRENCH = _data["namE_FRENCH"];
      this.namE_GERMAN = _data["namE_GERMAN"];
      this.namE_ITALIAN = _data["namE_ITALIAN"];
      this.namE_SPANISH = _data["namE_SPANISH"];
      this.postaL_CODE = _data["postaL_CODE"];
      this.map = _data["map"];
      this.websitE_ADDRESS = _data["websitE_ADDRESS"];
      this.emaiL_ADDRESS = _data["emaiL_ADDRESS"];
    }
  }

  static fromJS(data: any): GOVERNRATEDTO {
    data = typeof data === "object" ? data : {};
    let result = new GOVERNRATEDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["goV_CODE"] = this.goV_CODE;
    data["name"] = this.name;
    data["namE_ENGLISH"] = this.namE_ENGLISH;
    data["namE_FRENCH"] = this.namE_FRENCH;
    data["namE_GERMAN"] = this.namE_GERMAN;
    data["namE_ITALIAN"] = this.namE_ITALIAN;
    data["namE_SPANISH"] = this.namE_SPANISH;
    data["postaL_CODE"] = this.postaL_CODE;
    data["map"] = this.map;
    data["websitE_ADDRESS"] = this.websitE_ADDRESS;
    data["emaiL_ADDRESS"] = this.emaiL_ADDRESS;
    return data;
  }

  clone(): GOVERNRATEDTO {
    const json = this.toJSON();
    let result = new GOVERNRATEDTO();
    result.init(json);
    return result;
  }
}

export interface IGOVERNRATEDTO {
  goV_CODE: number;
  name: string | undefined;
  namE_ENGLISH: string | undefined;
  namE_FRENCH: string | undefined;
  namE_GERMAN: string | undefined;
  namE_ITALIAN: string | undefined;
  namE_SPANISH: string | undefined;
  postaL_CODE: string | undefined;
  map: string | undefined;
  websitE_ADDRESS: string | undefined;
  emaiL_ADDRESS: string | undefined;
}

export class GOVERNRATEDTOListResultDto implements IGOVERNRATEDTOListResultDto {
  items: GOVERNRATEDTO[] | undefined;

  constructor(data?: IGOVERNRATEDTOListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(GOVERNRATEDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GOVERNRATEDTOListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new GOVERNRATEDTOListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): GOVERNRATEDTOListResultDto {
    const json = this.toJSON();
    let result = new GOVERNRATEDTOListResultDto();
    result.init(json);
    return result;
  }
}

export interface IGOVERNRATEDTOListResultDto {
  items: GOVERNRATEDTO[] | undefined;
}

export class CM_SuppliersClientsDTO implements ICM_SuppliersClientsDTO {
  id: number | undefined;
  arabicName: string | undefined;
  englishName: string | undefined;
  company_SN: number | undefined;
  status: number;
  serialNo: string | undefined;
  currencY_ID: number;
  type: number;
  accountID: number | undefined;
  commercialName: string | undefined;
  commercialNameE: string | undefined;
  responsiblePersonName: string | undefined;
  responsibleTitle: string | undefined;
  maxCreditLimitation: number | undefined;
  creditDays: number | undefined;
  commercialRecordNo: string | undefined;
  legalRecordNo: string | undefined;
  commercialRecordDate: moment.Moment | undefined;
  legalRecordDate: moment.Moment | undefined;
  email: string | undefined;
  gMap: string | undefined;
  postalCode: string | undefined;
  streeT_ADDRESS: string | undefined;
  streeT_ADDRESS_FL2: string | undefined;
  streeT_ADDRESS_FL1: string | undefined;
  adress_NUMBER: string | undefined;
  governrateId: number | undefined;
  canExceedCreditLimit: boolean | undefined;
  canExceedCreditPeriod: boolean | undefined;
  postalBox: string | undefined;
  isExternal: boolean | undefined;
  registrationNo: string | undefined;
  governrateName: string | undefined;
  building_number:string | undefined;
  secondary_No: string | undefined;
  districts_name: string | undefined;
  city_name: string | undefined;

  constructor(data?: ICM_SuppliersClientsDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.arabicName = _data["arabicName"];
      this.englishName = _data["englishName"];
      this.company_SN = _data["company_SN"];
      this.status = _data["status"];
      this.serialNo = _data["serialNo"];
      this.currencY_ID = _data["currencY_ID"];
      this.type = _data["type"];
      this.accountID = _data["accountID"];
      this.commercialName = _data["commercialName"];
      this.commercialNameE = _data["commercialNameE"];
      this.responsiblePersonName = _data["responsiblePersonName"];
      this.responsibleTitle = _data["responsibleTitle"];
      this.maxCreditLimitation = _data["maxCreditLimitation"];
      this.creditDays = _data["creditDays"];
      this.commercialRecordNo = _data["commercialRecordNo"];
      this.legalRecordNo = _data["legalRecordNo"];
      this.commercialRecordDate = _data["commercialRecordDate"]
        ? moment(_data["commercialRecordDate"].toString())
        : <any>undefined;
      this.legalRecordDate = _data["legalRecordDate"]
        ? moment(_data["legalRecordDate"].toString())
        : <any>undefined;
      this.email = _data["email"];
      this.gMap = _data["gMap"];
      this.postalCode = _data["postalCode"];
      this.streeT_ADDRESS = _data["streeT_ADDRESS"];
      this.streeT_ADDRESS_FL2 = _data["streeT_ADDRESS_FL2"];
      this.streeT_ADDRESS_FL1 = _data["streeT_ADDRESS_FL1"];
      this.adress_NUMBER = _data["adress_NUMBER"];
      this.governrateId = _data["governrateId"];
      this.canExceedCreditLimit = _data["canExceedCreditLimit"];
      this.canExceedCreditPeriod = _data["canExceedCreditPeriod"];
      this.postalBox = _data["postalBox"];
      this.isExternal = _data["isExternal"];
      this.registrationNo = _data["registrationNo"];
      this.governrateName = _data["governrateName"];
      this.building_number = _data["building_number"];
      this.secondary_No = _data["secondary_No"];
      this.districts_name = _data["districts_name"];
      this.city_name = _data["city_name"];
    }
  }

  static fromJS(data: any): CM_SuppliersClientsDTO {
    data = typeof data === "object" ? data : {};
    let result = new CM_SuppliersClientsDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["arabicName"] = this.arabicName;
    data["englishName"] = this.englishName;
    data["company_SN"] = this.company_SN;
    data["status"] = this.status;
    data["serialNo"] = this.serialNo;
    data["currencY_ID"] = this.currencY_ID;
    data["type"] = this.type;
    data["accountID"] = this.accountID;
    data["commercialName"] = this.commercialName;
    data["commercialNameE"] = this.commercialNameE;
    data["responsiblePersonName"] = this.responsiblePersonName;
    data["responsibleTitle"] = this.responsibleTitle;
    data["maxCreditLimitation"] = this.maxCreditLimitation;
    data["creditDays"] = this.creditDays;
    data["commercialRecordNo"] = this.commercialRecordNo;
    data["legalRecordNo"] = this.legalRecordNo;
    data["commercialRecordDate"] = this.commercialRecordDate
      ? this.commercialRecordDate.toISOString()
      : <any>undefined;
    data["legalRecordDate"] = this.legalRecordDate
      ? this.legalRecordDate.toISOString()
      : <any>undefined;
    data["email"] = this.email;
    data["gMap"] = this.gMap;
    data["postalCode"] = this.postalCode;
    data["streeT_ADDRESS"] = this.streeT_ADDRESS;
    data["streeT_ADDRESS_FL2"] = this.streeT_ADDRESS_FL2;
    data["streeT_ADDRESS_FL1"] = this.streeT_ADDRESS_FL1;
    data["adress_NUMBER"] = this.adress_NUMBER;
    data["governrateId"] = this.governrateId;
    data["canExceedCreditLimit"] = this.canExceedCreditLimit;
    data["canExceedCreditPeriod"] = this.canExceedCreditPeriod;
    data["postalBox"] = this.postalBox;
    data["isExternal"] = this.isExternal;
    data["registrationNo"] = this.registrationNo;
    data["governrateName"] = this.governrateName;
    data["building_number"] = this.building_number;
    data["secondary_No"] = this.secondary_No;
    data["districts_name"] = this.districts_name;
    data["city_name"] = this.city_name;

    return data;
  }

  clone(): CM_SuppliersClientsDTO {
    const json = this.toJSON();
    let result = new CM_SuppliersClientsDTO();
    result.init(json);
    return result;
  }
}

export interface ICM_SuppliersClientsDTO {
  id: number | undefined;
  arabicName: string | undefined;
  englishName: string | undefined;
  company_SN: number | undefined;
  status: number;
  serialNo: string | undefined;
  currencY_ID: number;
  type: number;
  accountID: number | undefined;
  commercialName: string | undefined;
  commercialNameE: string | undefined;
  responsiblePersonName: string | undefined;
  responsibleTitle: string | undefined;
  maxCreditLimitation: number | undefined;
  creditDays: number | undefined;
  commercialRecordNo: string | undefined;
  legalRecordNo: string | undefined;
  commercialRecordDate: moment.Moment | undefined;
  legalRecordDate: moment.Moment | undefined;
  email: string | undefined;
  gMap: string | undefined;
  postalCode: string | undefined;
  streeT_ADDRESS: string | undefined;
  streeT_ADDRESS_FL2: string | undefined;
  streeT_ADDRESS_FL1: string | undefined;
  adress_NUMBER: string | undefined;
  governrateId: number | undefined;
  canExceedCreditLimit: boolean | undefined;
  canExceedCreditPeriod: boolean | undefined;
  postalBox: string | undefined;
  isExternal: boolean | undefined;
  registrationNo: string | undefined;
  governrateName: string | undefined;
  building_number:string | undefined;
  secondary_No: string | undefined;
  districts_name: string | undefined;
  city_name: string | undefined;

}

export class CM_SuppliersClientsDTOListResultDto
  implements ICM_SuppliersClientsDTOListResultDto
{
  items: CM_SuppliersClientsDTO[] | undefined;

  constructor(data?: ICM_SuppliersClientsDTOListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(CM_SuppliersClientsDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CM_SuppliersClientsDTOListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new CM_SuppliersClientsDTOListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): CM_SuppliersClientsDTOListResultDto {
    const json = this.toJSON();
    let result = new CM_SuppliersClientsDTOListResultDto();
    result.init(json);
    return result;
  }
}

export interface ICM_SuppliersClientsDTOListResultDto {
  items: CM_SuppliersClientsDTO[] | undefined;
}

export class AddNewClientDTO implements IAddNewClientDTO {
  arabicName: string | undefined;
  englishName: string | undefined;
  email: string | undefined;
  governrateId: number | undefined;
  streeT_ADDRESS: string | undefined;
  registrationNo: string | undefined;
  commercialRecordNo: string | undefined;
  building_number:string | undefined;
  secondary_No: string | undefined;
  districts_name: string | undefined;
  postalCode: string | undefined;
  city_name: string | undefined;

  constructor(data?: IAddNewClientDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.arabicName = _data["arabicName"];
      this.englishName = _data["englishName"];
      this.email = _data["email"];
      this.governrateId = _data["governrateId"];
      this.streeT_ADDRESS = _data["streeT_ADDRESS"];
      this.registrationNo = _data["registrationNo"];
      this.commercialRecordNo = _data["commercialRecordNo"];
      this.building_number = _data["building_number"];
      this.secondary_No = _data["secondary_No"];
      this.districts_name = _data["districts_name"];
      this.postalCode = _data["postalCode"];
      this.city_name = _data["city_name"];

    }
  }

  static fromJS(data: any): AddNewClientDTO {
    data = typeof data === "object" ? data : {};
    let result = new AddNewClientDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["arabicName"] = this.arabicName;
    data["englishName"] = this.englishName;
    data["email"] = this.email;
    data["governrateId"] = this.governrateId;
    data["streeT_ADDRESS"] = this.streeT_ADDRESS;
    data["registrationNo"] = this.registrationNo;
    data["commercialRecordNo"] = this.commercialRecordNo;
    data["building_number"] = this.building_number;
    data["secondary_No"] = this.secondary_No;
    data["districts_name"] = this.districts_name;
    data["postalCode"] = this.postalCode;
    data["city_name"] = this.city_name;

    return data;
  }

  clone(): AddNewClientDTO {
    const json = this.toJSON();
    let result = new AddNewClientDTO();
    result.init(json);
    return result;
  }
}

export interface IAddNewClientDTO {
  arabicName: string | undefined;
  englishName: string | undefined;
  email: string | undefined;
  governrateId: number | undefined;
  streeT_ADDRESS: string | undefined;
  registrationNo: string | undefined;
  commercialRecordNo: string | undefined;
  building_number:string | undefined;
  secondary_No: string | undefined;
  districts_name: string | undefined;
  postalCode: string | undefined;
  city_name: string | undefined;

}

export class PointOfSaleDefinitionDTOListResultDto
  implements IPointOfSaleDefinitionDTOListResultDto
{
  items: PointOfSaleDefinitionDTO[] | undefined;

  constructor(data?: IPointOfSaleDefinitionDTOListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(PointOfSaleDefinitionDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PointOfSaleDefinitionDTOListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new PointOfSaleDefinitionDTOListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): PointOfSaleDefinitionDTOListResultDto {
    const json = this.toJSON();
    let result = new PointOfSaleDefinitionDTOListResultDto();
    result.init(json);
    return result;
  }
}

export interface IPointOfSaleDefinitionDTOListResultDto {
  items: PointOfSaleDefinitionDTO[] | undefined;
}

export class CreateRecievingBankDetailsDTO
  implements ICreateRecievingBankDetailsDTO
{
  time: string | undefined;
  date: moment.Moment;
  changeDate: boolean;
  openingValue: number | undefined;
  notes: string | undefined;
  bankId: number | undefined;

  constructor(data?: ICreateRecievingBankDetailsDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.time = _data["time"];
      this.date = _data["date"]
        ? moment(_data["date"].toString())
        : <any>undefined;
      this.changeDate = _data["changeDate"];
      this.openingValue = _data["openingValue"];
      this.notes = _data["notes"];
      this.bankId = _data["bankId"];
    }
  }

  static fromJS(data: any): CreateRecievingBankDetailsDTO {
    data = typeof data === "object" ? data : {};
    let result = new CreateRecievingBankDetailsDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["time"] = this.time;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    data["changeDate"] = this.changeDate;
    data["openingValue"] = this.openingValue;
    data["notes"] = this.notes;
    data["bankId"] = this.bankId;
    return data;
  }

  clone(): CreateRecievingBankDetailsDTO {
    const json = this.toJSON();
    let result = new CreateRecievingBankDetailsDTO();
    result.init(json);
    return result;
  }
}

export interface ICreateRecievingBankDetailsDTO {
  time: string | undefined;
  date: moment.Moment;
  changeDate: boolean;
  openingValue: number | undefined;
  notes: string | undefined;
  bankId: number | undefined;
}

export class CompositeDTO implements ICompositeDTO {
  recievingBankDetailsID: number;
  shiftCashierID: number;

  constructor(data?: ICompositeDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.recievingBankDetailsID = _data["recievingBankDetailsID"];
      this.shiftCashierID = _data["shiftCashierID"];
    }
  }

  static fromJS(data: any): CompositeDTO {
    data = typeof data === "object" ? data : {};
    let result = new CompositeDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["recievingBankDetailsID"] = this.recievingBankDetailsID;
    data["shiftCashierID"] = this.shiftCashierID;
    return data;
  }

  clone(): CompositeDTO {
    const json = this.toJSON();
    let result = new CompositeDTO();
    result.init(json);
    return result;
  }
}

export interface ICompositeDTO {
  recievingBankDetailsID: number;
  shiftCashierID: number;
}

export class CreateDeliveringBankDetailsDTO
  implements ICreateDeliveringBankDetailsDTO
{
  recievingBankDetailsID: number;
  shiftCashierId: number;
  closingValue: number | undefined;
  closingVisaValue: number | undefined;
  closingMasterValue: number | undefined;
  closingMadaValue: number | undefined;
  closingMoneyTransferValue: number | undefined;
  notes: string | undefined;

  constructor(data?: ICreateDeliveringBankDetailsDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.recievingBankDetailsID = _data["recievingBankDetailsID"];
      this.shiftCashierId = _data["shiftCashierId"];
      this.closingValue = _data["closingValue"];
      this.closingVisaValue = _data["closingVisaValue"];
      this.closingMasterValue = _data["closingMasterValue"];
      this.closingMadaValue = _data["closingMadaValue"];
      this.closingMoneyTransferValue = _data["closingMoneyTransferValue"];
      this.notes = _data["notes"];
    }
  }

  static fromJS(data: any): CreateDeliveringBankDetailsDTO {
    data = typeof data === "object" ? data : {};
    let result = new CreateDeliveringBankDetailsDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["recievingBankDetailsID"] = this.recievingBankDetailsID;
    data["shiftCashierId"] = this.shiftCashierId;
    data["closingValue"] = this.closingValue;
    data["closingVisaValue"] = this.closingVisaValue;
    data["closingMasterValue"] = this.closingMasterValue;
    data["closingMadaValue"] = this.closingMadaValue;
    data["closingMoneyTransferValue"] = this.closingMoneyTransferValue;
    data["notes"] = this.notes;
    return data;
  }

  clone(): CreateDeliveringBankDetailsDTO {
    const json = this.toJSON();
    let result = new CreateDeliveringBankDetailsDTO();
    result.init(json);
    return result;
  }
}

export interface ICreateDeliveringBankDetailsDTO {
  recievingBankDetailsID: number;
  shiftCashierId: number;
  closingValue: number | undefined;
  closingVisaValue: number | undefined;
  closingMasterValue: number | undefined;
  closingMadaValue: number | undefined;
  closingMoneyTransferValue: number | undefined;
  notes: string | undefined;
}

export class CreateVoucherDetailsDTO implements ICreateVoucherDetailsDTO {
  productMeasuringUnitId: number;
  quantity: number;
  salesPricePerUnit: number;
  discountValue: number;
  taxValue: number;
  addedValue: number;
  comment: string | undefined;
  notes: string | undefined;
  isAddOn: boolean;
  returnedQuantity: number;
  canReturn: boolean;

  constructor(data?: ICreateVoucherDetailsDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productMeasuringUnitId = _data["productMeasuringUnitId"];
      this.quantity = _data["quantity"];
      this.salesPricePerUnit = _data["salesPricePerUnit"];
      this.discountValue = _data["discountValue"];
      this.taxValue = _data["taxValue"];
      this.addedValue = _data["addedValue"];
      this.comment = _data["comment"];
      this.notes = _data["notes"];
      this.isAddOn = _data["isAddOn"];
      this.canReturn = true;
    }
  }

  static fromJS(data: any): CreateVoucherDetailsDTO {
    data = typeof data === "object" ? data : {};
    let result = new CreateVoucherDetailsDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["productMeasuringUnitId"] = this.productMeasuringUnitId;
    data["quantity"] = this.quantity;
    data["salesPricePerUnit"] = this.salesPricePerUnit;
    data["discountValue"] = this.discountValue;
    data["taxValue"] = this.taxValue;
    data["addedValue"] = this.addedValue;
    data["comment"] = this.comment;
    data["notes"] = this.notes;
    data["isAddOn"] = this.isAddOn;
    return data;
  }

  clone(): CreateVoucherDetailsDTO {
    const json = this.toJSON();
    let result = new CreateVoucherDetailsDTO();
    result.init(json);
    return result;
  }
}

export interface ICreateVoucherDetailsDTO {
  productMeasuringUnitId: number;
  quantity: number;
  salesPricePerUnit: number;
  discountValue: number;
  taxValue: number;
  addedValue: number;
  comment: string | undefined;
  notes: string | undefined;
  isAddOn: boolean;
  canReturn: boolean;
}

export class CreateVoucherDTO implements ICreateVoucherDTO {
  time: string | undefined;
  date: moment.Moment | undefined;
  addedValue: number;
  discountValue: number;
  taxValue: number;
  totalPayment: number;
  voucherDetailsList: CreateVoucherDetailsDTO[] | undefined;
  recievingBankDetailsID: number;
  shiftCashierId: number;
  tableId: number | undefined;
  deliveryCompanyId: number | undefined;
  customerTypeId: number | undefined;
  customerName: string | undefined;
  supplierClientId: number | undefined;
  canReturn: boolean;
  returnFlag: boolean;
  customerMobile: string | undefined;
 discountId?: number;
  bonusId?: number;
  constructor(data?: ICreateVoucherDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.time = _data["time"];
      this.date = _data["date"]
        ? moment(_data["date"].toString())
        : <any>undefined;
      this.addedValue = _data["addedValue"];
      this.discountValue = _data["discountValue"];
      this.taxValue = _data["taxValue"];
      this.totalPayment = _data["totalPayment"];
      if (Array.isArray(_data["voucherDetailsList"])) {
        this.voucherDetailsList = [] as any;
        for (let item of _data["voucherDetailsList"])
          this.voucherDetailsList.push(CreateVoucherDetailsDTO.fromJS(item));
      }
      this.recievingBankDetailsID = _data["recievingBankDetailsID"];
      this.shiftCashierId = _data["shiftCashierId"];
      this.tableId = _data["tableId"];
      this.deliveryCompanyId = _data["deliveryCompanyId"];
      this.customerTypeId = _data["customerTypeId"];
      this.customerName = _data["customerName"];
      this.supplierClientId = _data["supplierClientId"];
      this.customerMobile = _data["customerMobile"];
           this.discountId = _data["discountId"];
      this.bonusId = _data["bonusId"];
    }
  }

  static fromJS(data: any): CreateVoucherDTO {
    data = typeof data === "object" ? data : {};
    let result = new CreateVoucherDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["time"] = this.time;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    data["addedValue"] = this.addedValue;
    data["discountValue"] = this.discountValue;
    data["taxValue"] = this.taxValue;
    data["totalPayment"] = this.totalPayment;
    if (Array.isArray(this.voucherDetailsList)) {
      data["voucherDetailsList"] = [];
      for (let item of this.voucherDetailsList)
        data["voucherDetailsList"].push(item.toJSON());
    }
    data["recievingBankDetailsID"] = this.recievingBankDetailsID;
    data["shiftCashierId"] = this.shiftCashierId;
    data["tableId"] = this.tableId;
    data["deliveryCompanyId"] = this.deliveryCompanyId;
    data["customerTypeId"] = this.customerTypeId;
    data["customerName"] = this.customerName;
    data["supplierClientId"] = this.supplierClientId;
    data["customerMobile"] = this.customerMobile;
     data["discountId"] = this.discountId;
    data["bonusId"] = this.bonusId;
    return data;
  }

  clone(): CreateVoucherDTO {
    const json = this.toJSON();
    let result = new CreateVoucherDTO();
    result.init(json);
    return result;
  }
}

export interface ICreateVoucherDTO {
  time: string | undefined;
  date: moment.Moment | undefined;
  addedValue: number;
  discountValue: number;
  taxValue: number;
  totalPayment: number;
  voucherDetailsList: CreateVoucherDetailsDTO[] | undefined;
  recievingBankDetailsID: number;
  shiftCashierId: number;
  tableId: number | undefined;
  deliveryCompanyId: number | undefined;
  customerTypeId: number | undefined;
  customerName: string | undefined;
  supplierClientId: number | undefined;
  customerMobile: string | undefined;
  discountId?: number;
  bonusId?: number;
}

export class VoucherDetailsDTO implements IVoucherDetailsDTO {
  id: number;
  voucherId: number | undefined;
  productMeasuringUnitId: number | undefined;
  productMeasuringUnitName: string | undefined;
  productName: string | undefined;
  quantity: number | undefined;
  salesPricePerUnit: number | undefined;
  discountValue: number | undefined;
  returnedQuantity: number | undefined;
  taxValue: number | undefined;
  addedValue: number | undefined;
  canReturn: boolean | undefined;
  comment: string | undefined;
  notes: string | undefined;
  isAddOn: boolean;
  remainingStockQuantity: number;
  parcode: string | undefined;
  oldQTY: number | undefined;

  constructor(data?: IVoucherDetailsDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.voucherId = _data["voucherId"];
      this.productMeasuringUnitId = _data["productMeasuringUnitId"];
      this.productMeasuringUnitName = _data["productMeasuringUnitName"];
      this.productName = _data["productName"];
      this.quantity = _data["quantity"];
      this.salesPricePerUnit = _data["salesPricePerUnit"];
      this.discountValue = _data["discountValue"];
      this.returnedQuantity = _data["returnedQuantity"];
      this.taxValue = _data["taxValue"];
      this.addedValue = _data["addedValue"];
      this.canReturn = _data["canReturn"];
      this.comment = _data["comment"];
      this.notes = _data["notes"];
      this.isAddOn = _data["isAddOn"];
      this.remainingStockQuantity = _data["remainingStockQuantity"];
      this.parcode = _data["parcode"];
    }
  }

  static fromJS(data: any): VoucherDetailsDTO {
    data = typeof data === "object" ? data : {};
    let result = new VoucherDetailsDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["voucherId"] = this.voucherId;
    data["productMeasuringUnitId"] = this.productMeasuringUnitId;
    data["productMeasuringUnitName"] = this.productMeasuringUnitName;
    data["productName"] = this.productName;
    data["quantity"] = this.quantity;
    data["salesPricePerUnit"] = this.salesPricePerUnit;
    data["discountValue"] = this.discountValue;
    data["returnedQuantity"] = this.returnedQuantity;
    data["taxValue"] = this.taxValue;
    data["addedValue"] = this.addedValue;
    data["canReturn"] = this.canReturn;
    data["comment"] = this.comment;
    data["notes"] = this.notes;
    data["isAddOn"] = this.isAddOn;
    data["remainingStockQuantity"] = this.remainingStockQuantity;
    data["parcode"] = this.parcode;
    return data;
  }

  clone(): VoucherDetailsDTO {
    const json = this.toJSON();
    let result = new VoucherDetailsDTO();
    result.init(json);
    return result;
  }
}

export interface IVoucherDetailsDTO {
  id: number;
  voucherId: number | undefined;
  productMeasuringUnitId: number | undefined;
  productMeasuringUnitName: string | undefined;
  productName: string | undefined;
  quantity: number | undefined;
  salesPricePerUnit: number | undefined;
  discountValue: number | undefined;
  returnedQuantity: number | undefined;
  taxValue: number | undefined;
  addedValue: number | undefined;
  canReturn: boolean | undefined;
  comment: string | undefined;
  notes: string | undefined;
  isAddOn: boolean;
  remainingStockQuantity: number;
  parcode: string | undefined;
  oldQTY: number | undefined;
}

export class VoucherPaymentDTO implements IVoucherPaymentDTO {
  paymentMethodId: number;
  paymentMethod: PaymentMethodDTO | undefined; // ✅ SINGLE object, not an array
  amount: number;
  paymentMethodName: string | undefined;
  cardNumber: string | undefined;

  constructor(data?: IVoucherPaymentDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.paymentMethodId = _data["paymentMethodId"];
      this.paymentMethod = _data["paymentMethod"]
        ? PaymentMethodDTO.fromJS(_data["paymentMethod"])
        : undefined;
      this.amount = _data["amount"];
      this.paymentMethodName = _data["paymentMethodName"];
      this.cardNumber = _data["cardNumber"];
    }
  }

  static fromJS(data: any): VoucherPaymentDTO {
    data = typeof data === "object" ? data : {};
    let result = new VoucherPaymentDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["paymentMethodId"] = this.paymentMethodId;
    data["paymentMethod"] = this.paymentMethod
      ? this.paymentMethod.toJSON()
      : undefined;
    data["amount"] = this.amount;
    data["paymentMethodName"] = this.paymentMethodName;
    data["cardNumber"] = this.cardNumber;
    return data;
  }

  clone(): VoucherPaymentDTO {
    const json = this.toJSON();
    let result = new VoucherPaymentDTO();
    result.init(json);
    return result;
  }
}

export interface IVoucherPaymentDTO {
  paymentMethodId: number;
  paymentMethod: PaymentMethodDTO | undefined; // ✅ SINGLE
  amount: number;
  paymentMethodName: string | undefined;
  cardNumber: string | undefined;
}


export class VoucherDTO implements IVoucherDTO {
  id: number;
  shiftCashierId: number;
  supplierClientId: number | undefined ;
  supplierClient: CM_SuppliersClientsDTO;
  voucherDetailsList: VoucherDetailsDTO[] | undefined;
  voucherPayment: VoucherPaymentDTO[] | undefined;
  transactionId: number | undefined;
  voucherSerial: string | undefined;
  voucherDate: moment.Moment | undefined;
  voucherTime: moment.Moment | undefined;
  cashierNID: string | undefined;
  cashierNAT_Code: number | undefined;
  shiftId: number | undefined;
  voucherStatusId: number | undefined;
  voucherStatusName: string | undefined;
  bankId: number | undefined;
  paidValue: number | undefined;
  restValue: number | undefined;
  returnFlag: boolean | undefined;
  taxValue: number | undefined;
  discountValue: number | undefined;
  addedValue: number | undefined;
  totalPayment: number;
  canReturn: boolean | undefined;
  recievingBankDetailsID: number;
  tableId: number | undefined;
  deliveryCompanyId: number | undefined;
  customerTypeId: number | undefined;
  customerType: CustomerTypeDTO;
  customerName: string | undefined;
  table: TableDto;
  orderNumber: number | undefined;
  voucherCode: string | undefined;
  apiCode: string | undefined;
vatInvNum: string | undefined;
retInv_ID: number | undefined;
sourceTransactionId: number | undefined;

  customerMobile: string | undefined;
  IsSelected: boolean;
 discountId?: number;
  bonusId?: number;
  constructor(data?: IVoucherDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.shiftCashierId = _data["shiftCashierId"];
      this.supplierClientId = _data["supplierClientId"];
      this.supplierClient = _data["supplierClient"]
      ? CM_SuppliersClientsDTO.fromJS(_data["supplierClient"])
      : <any>undefined;
      if (Array.isArray(_data["voucherDetailsList"])) {
        this.voucherDetailsList = [] as any;
        for (let item of _data["voucherDetailsList"])
          this.voucherDetailsList.push(VoucherDetailsDTO.fromJS(item));
      }
      if (Array.isArray(_data["voucherPayment"])) {
        this.voucherPayment = [] as any;
        for (let item of _data["voucherPayment"])
          this.voucherPayment.push(VoucherPaymentDTO.fromJS(item));
      }
      this.transactionId = _data["transactionId"];
      this.voucherSerial = _data["voucherSerial"];
      this.voucherDate = _data["voucherDate"]
        ? moment(_data["voucherDate"].toString())
        : <any>undefined;
      this.voucherTime = _data["voucherTime"]
        ? moment(_data["voucherTime"].toString())
        : <any>undefined;
      this.cashierNID = _data["cashierNID"];
      this.cashierNAT_Code = _data["cashierNAT_Code"];
      this.shiftId = _data["shiftId"];
      this.voucherStatusId = _data["voucherStatusId"];
      this.voucherStatusName = _data["voucherStatusName"];
      this.bankId = _data["bankId"];
      this.paidValue = _data["paidValue"];
      this.restValue = _data["restValue"];
      this.returnFlag = _data["returnFlag"];
      this.taxValue = _data["taxValue"];
      this.discountValue = _data["discountValue"];
      this.addedValue = _data["addedValue"];
      this.totalPayment = _data["totalPayment"];
      this.canReturn = _data["canReturn"];
      this.recievingBankDetailsID = _data["recievingBankDetailsID"];
      this.tableId = _data["tableId"];
      this.deliveryCompanyId = _data["deliveryCompanyId"];
      this.customerTypeId = _data["customerTypeId"];
      this.customerType = _data["customerType"]
        ? CustomerTypeDTO.fromJS(_data["customerType"])
        : <any>undefined;
      this.customerName = _data["customerName"];
      this.table = _data["table"]
        ? TableDto.fromJS(_data["table"])
        : <any>undefined;
      this.orderNumber = _data["orderNumber"];
      this.voucherCode = _data["voucherCode"];
      this.apiCode = _data["apiCode"];
      this.vatInvNum = _data["vatInvNum"];
      this.retInv_ID = _data["retInv_ID"];
      this.sourceTransactionId = _data["sourceTransactionId"];
          this.discountId = _data["discountId"];
      this.bonusId = _data["bonusId"];
      this.customerMobile = _data["customerMobile"];
    }
  }

  static fromJS(data: any): VoucherDTO {
    data = typeof data === "object" ? data : {};
    let result = new VoucherDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["shiftCashierId"] = this.shiftCashierId;
    data["supplierClientId"] = this.supplierClientId;
    data["supplierClient"] = this.supplierClient
    ? this.supplierClient.toJSON()
    : <any>undefined;
    if (Array.isArray(this.voucherDetailsList)) {
      data["voucherDetailsList"] = [];
      for (let item of this.voucherDetailsList)
        data["voucherDetailsList"].push(item.toJSON());
    }
    if (Array.isArray(this.voucherPayment)) {
      data["voucherPayment"] = [];
      for (let item of this.voucherPayment)
        data["voucherPayment"].push(item.toJSON());
    }
    data["transactionId"] = this.transactionId;
    data["voucherSerial"] = this.voucherSerial;
    data["voucherDate"] = this.voucherDate
      ? this.voucherDate.toISOString()
      : <any>undefined;
    data["voucherTime"] = this.voucherTime
      ? this.voucherTime.toISOString()
      : <any>undefined;
    data["cashierNID"] = this.cashierNID;
    data["cashierNAT_Code"] = this.cashierNAT_Code;
    data["shiftId"] = this.shiftId;
    data["voucherStatusId"] = this.voucherStatusId;
    data["voucherStatusName"] = this.voucherStatusName;
    data["bankId"] = this.bankId;
    data["paidValue"] = this.paidValue;
    data["restValue"] = this.restValue;
    data["returnFlag"] = this.returnFlag;
    data["taxValue"] = this.taxValue;
    data["discountValue"] = this.discountValue;
    data["addedValue"] = this.addedValue;
    data["totalPayment"] = this.totalPayment;
    data["canReturn"] = this.canReturn;
    data["recievingBankDetailsID"] = this.recievingBankDetailsID;
    data["tableId"] = this.tableId;
    data["deliveryCompanyId"] = this.deliveryCompanyId;
    data["customerTypeId"] = this.customerTypeId;
    data["customerType"] = this.customerType
      ? this.customerType.toJSON()
      : <any>undefined;
    data["customerName"] = this.customerName;
    data["table"] = this.table ? this.table.toJSON() : <any>undefined;
    data["orderNumber"] = this.orderNumber;
    data["voucherCode"] = this.voucherCode;
    data["apiCode"] = this.apiCode;
    data["vatInvNum"] = this.vatInvNum;
    data["retInv_ID"] = this.retInv_ID;
    data["sourceTransactionId"] = this.sourceTransactionId;
    data["discountId"] = this.discountId;
    data["bonusId"] = this.bonusId;
    data["customerMobile"] = this.customerMobile;
    return data;
  }

  clone(): VoucherDTO {
    const json = this.toJSON();
    let result = new VoucherDTO();
    result.init(json);
    return result;
  }
}

export interface IVoucherDTO {
  id: number;
  shiftCashierId: number;
  supplierClientId: number | undefined ;
  supplierClient: CM_SuppliersClientsDTO;
  voucherDetailsList: VoucherDetailsDTO[] | undefined;
  voucherPayment: VoucherPaymentDTO[] | undefined;
  transactionId: number | undefined;
  voucherSerial: string | undefined;
  voucherDate: moment.Moment | undefined;
  voucherTime: moment.Moment | undefined;
  cashierNID: string | undefined;
  cashierNAT_Code: number | undefined;
  shiftId: number | undefined;
  voucherStatusId: number | undefined;
  voucherStatusName: string | undefined;
  bankId: number | undefined;
  paidValue: number | undefined;
  restValue: number | undefined;
  returnFlag: boolean | undefined;
  taxValue: number | undefined;
  discountValue: number | undefined;
  addedValue: number | undefined;
  totalPayment: number;
  canReturn: boolean | undefined;
  recievingBankDetailsID: number;
  tableId: number | undefined;
  deliveryCompanyId: number | undefined;
  customerTypeId: number | undefined;
  customerType: CustomerTypeDTO;
  customerName: string | undefined;
  table: TableDto;
  orderNumber: number | undefined;
  voucherCode: string | undefined;
  apiCode: string | undefined;
vatInvNum: string | undefined;
retInv_ID: number | undefined;
sourceTransactionId: number | undefined;
 discountId?: number;
  bonusId?: number;
  customerMobile: string | undefined;
}

export class CreateReturnsVoucherDTO implements ICreateReturnsVoucherDTO {
  returnsVoucher: VoucherDTO;
  voucherId: number;
  voucher: VoucherDTO;

  constructor(data?: ICreateReturnsVoucherDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.returnsVoucher = _data["returnsVoucher"]
        ? VoucherDTO.fromJS(_data["returnsVoucher"])
        : <any>undefined;
      this.voucherId = _data["voucherId"];
      this.voucher = _data["voucher"]
        ? VoucherDTO.fromJS(_data["voucher"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): CreateReturnsVoucherDTO {
    data = typeof data === "object" ? data : {};
    let result = new CreateReturnsVoucherDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["returnsVoucher"] = this.returnsVoucher
      ? this.returnsVoucher.toJSON()
      : <any>undefined;
    data["voucherId"] = this.voucherId;
    data["voucher"] = this.voucher ? this.voucher.toJSON() : <any>undefined;
    return data;
  }

  clone(): CreateReturnsVoucherDTO {
    const json = this.toJSON();
    let result = new CreateReturnsVoucherDTO();
    result.init(json);
    return result;
  }
}

export interface ICreateReturnsVoucherDTO {
  returnsVoucher: VoucherDTO;
  voucherId: number;
  voucher: VoucherDTO;
}

export class PrintVoucherDTO implements IPrintVoucherDTO {
  voucher: VoucherDTO;
  supplierClient: CM_SuppliersClientsDTO;
  image: string | undefined;
  companyName: string | undefined;
  posName: string | undefined;
  posAdress: string | undefined;
  taxRegistrationNo: string | undefined;

  constructor(data?: IPrintVoucherDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.voucher = _data["voucher"]
        ? VoucherDTO.fromJS(_data["voucher"])
        : <any>undefined;
      this.supplierClient = _data["supplierClient"]
        ? CM_SuppliersClientsDTO.fromJS(_data["supplierClient"])
        : <any>undefined;
      this.image = _data["image"];
      this.companyName = _data["companyName"];
      this.posName = _data["posName"];
      this.posAdress = _data["posAdress"];
      this.taxRegistrationNo = _data["taxRegistrationNo"];
    }
  }

  static fromJS(data: any): PrintVoucherDTO {
    data = typeof data === "object" ? data : {};
    let result = new PrintVoucherDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["voucher"] = this.voucher ? this.voucher.toJSON() : <any>undefined;
    data["supplierClient"] = this.supplierClient
      ? this.supplierClient.toJSON()
      : <any>undefined;
    data["image"] = this.image;
    data["companyName"] = this.companyName;
    data["posName"] = this.posName;
    data["posAdress"] = this.posAdress;
    data["taxRegistrationNo"] = this.taxRegistrationNo;
    return data;
  }

  clone(): PrintVoucherDTO {
    const json = this.toJSON();
    let result = new PrintVoucherDTO();
    result.init(json);
    return result;
  }
}

export interface IPrintVoucherDTO {
  voucher: VoucherDTO;
  supplierClient: CM_SuppliersClientsDTO;
  image: string | undefined;
  companyName: string | undefined;
  posName: string | undefined;
  posAdress: string | undefined;
  taxRegistrationNo: string | undefined;
}

export class VoucherDTOListResultDto implements IVoucherDTOListResultDto {
  items: VoucherDTO[] | undefined;

  constructor(data?: IVoucherDTOListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(VoucherDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): VoucherDTOListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new VoucherDTOListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): VoucherDTOListResultDto {
    const json = this.toJSON();
    let result = new VoucherDTOListResultDto();
    result.init(json);
    return result;
  }
}

export interface IVoucherDTOListResultDto {
  items: VoucherDTO[] | undefined;
}

export class PaymentDTO implements IPaymentDTO {
  voucherPayments: VoucherPaymentDTO[] | undefined;
  voucherId: number;
  restValue: number | undefined;
  paidValue: number | undefined;

  constructor(data?: IPaymentDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["voucherPayments"])) {
        this.voucherPayments = [] as any;
        for (let item of _data["voucherPayments"])
          this.voucherPayments.push(VoucherPaymentDTO.fromJS(item));
      }
      this.voucherId = _data["voucherId"];
      this.restValue = _data["restValue"];
      this.paidValue = _data["paidValue"];
    }
  }

  static fromJS(data: any): PaymentDTO {
    data = typeof data === "object" ? data : {};
    let result = new PaymentDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.voucherPayments)) {
      data["voucherPayments"] = [];
      for (let item of this.voucherPayments)
        data["voucherPayments"].push(item.toJSON());
    }
    data["voucherId"] = this.voucherId;
    data["restValue"] = this.restValue;
    data["paidValue"] = this.paidValue;
    return data;
  }

  clone(): PaymentDTO {
    const json = this.toJSON();
    let result = new PaymentDTO();
    result.init(json);
    return result;
  }
}

export interface IPaymentDTO {
  voucherPayments: VoucherPaymentDTO[] | undefined;
  voucherId: number;
  restValue: number | undefined;
  paidValue: number | undefined;
}

export class DeliveryCompanyDtoListResultDto
  implements IDeliveryCompanyDtoListResultDto
{
  items: DeliveryCompanyDto[] | undefined;

  constructor(data?: IDeliveryCompanyDtoListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(DeliveryCompanyDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DeliveryCompanyDtoListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new DeliveryCompanyDtoListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): DeliveryCompanyDtoListResultDto {
    const json = this.toJSON();
    let result = new DeliveryCompanyDtoListResultDto();
    result.init(json);
    return result;
  }
}

export interface IDeliveryCompanyDtoListResultDto {
  items: DeliveryCompanyDto[] | undefined;
}

export class VoucherStatusDto implements IVoucherStatusDto {
  id: number;
  name: string | undefined;

  constructor(data?: IVoucherStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): VoucherStatusDto {
    data = typeof data === "object" ? data : {};
    let result = new VoucherStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }

  clone(): VoucherStatusDto {
    const json = this.toJSON();
    let result = new VoucherStatusDto();
    result.init(json);
    return result;
  }
}

export interface IVoucherStatusDto {
  id: number;
  name: string | undefined;
}

export class VoucherStatusDtoListResultDto
  implements IVoucherStatusDtoListResultDto
{
  items: VoucherStatusDto[] | undefined;

  constructor(data?: IVoucherStatusDtoListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(VoucherStatusDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): VoucherStatusDtoListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new VoucherStatusDtoListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): VoucherStatusDtoListResultDto {
    const json = this.toJSON();
    let result = new VoucherStatusDtoListResultDto();
    result.init(json);
    return result;
  }
}

export interface IVoucherStatusDtoListResultDto {
  items: VoucherStatusDto[] | undefined;
}

export class SalesReportFillterDTO implements ISalesReportFillterDTO {
  fromDate: moment.Moment;
  toDate: moment.Moment;
  posId: number | undefined;
  userId: number | undefined;
  returnsVoucherFillter: number;
  vatVoucherFillter: number;

  customerName: string | undefined;
  fromTime: string | undefined;
  toTime: string | undefined;
  voucherTypes: string[] | undefined;
  customerTypeIds: number[] | undefined;
  paymentMethodIds: number[] | undefined;
  topSellingCount: number | undefined;
  lowestSellingCount: number | undefined;
  productId: number | undefined;

  constructor(data?: ISalesReportFillterDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fromDate = _data["fromDate"]
        ? moment(_data["fromDate"].toString())
        : <any>undefined;
      this.toDate = _data["toDate"]
        ? moment(_data["toDate"].toString())
        : <any>undefined;
      this.posId = _data["posId"];
      this.userId = _data["userId"];
      this.returnsVoucherFillter = _data["returnsVoucherFillter"];
            this.vatVoucherFillter = _data["vatVoucherFillter"];

      this.customerName = _data["customerName"];
      this.fromTime = _data["fromTime"];
      this.toTime = _data["toTime"];
      if (Array.isArray(_data["voucherTypes"])) {
        this.voucherTypes = [] as any;
        for (let item of _data["voucherTypes"]) this.voucherTypes.push(item);
      }
      if (Array.isArray(_data["customerTypeIds"])) {
        this.customerTypeIds = [] as any;
        for (let item of _data["customerTypeIds"])
          this.customerTypeIds.push(item);
      }
      if (Array.isArray(_data["paymentMethodIds"])) {
        this.paymentMethodIds = [] as any;
        for (let item of _data["paymentMethodIds"])
          this.paymentMethodIds.push(item);
      }
      this.topSellingCount = _data["topSellingCount"];
      this.lowestSellingCount = _data["lowestSellingCount"];
    }
  }

  static fromJS(data: any): SalesReportFillterDTO {
    data = typeof data === "object" ? data : {};
    let result = new SalesReportFillterDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["fromDate"] = this.fromDate
      ? this.fromDate.toISOString()
      : <any>undefined;
    data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
    data["posId"] = this.posId;
    data["userId"] = this.userId;
    data["returnsVoucherFillter"] = this.returnsVoucherFillter;
    data["vatVoucherFillter"] = this.vatVoucherFillter;
    data["customerName"] = this.customerName;
    data["fromTime"] = this.fromTime;
    data["toTime"] = this.toTime;
    if (Array.isArray(this.voucherTypes)) {
      data["voucherTypes"] = [];
      for (let item of this.voucherTypes) data["voucherTypes"].push(item);
    }
    if (Array.isArray(this.customerTypeIds)) {
      data["customerTypeIds"] = [];
      for (let item of this.customerTypeIds) data["customerTypeIds"].push(item);
    }
    if (Array.isArray(this.paymentMethodIds)) {
      data["paymentMethodIds"] = [];
      for (let item of this.paymentMethodIds)
        data["paymentMethodIds"].push(item);
    }
    data["topSellingCount"] = this.topSellingCount;
    data["lowestSellingCount"] = this.lowestSellingCount;
    data["productId"] = this.productId;
    return data;
  }

  clone(): SalesReportFillterDTO {
    const json = this.toJSON();
    let result = new SalesReportFillterDTO();
    result.init(json);
    return result;
  }
}

export interface ISalesReportFillterDTO {
  fromDate: moment.Moment;
  toDate: moment.Moment;
  posId: number | undefined;
  userId: number | undefined;
  returnsVoucherFillter: number;
  vatVoucherFillter: number;

  customerName: string | undefined;
  fromTime: string | undefined;
  toTime: string | undefined;
  voucherTypes: string[] | undefined;
  customerTypeIds: number[] | undefined;
  paymentMethodIds: number[] | undefined;
  topSellingCount: number | undefined;
  lowestSellingCount: number | undefined;
  productId: number | undefined;
}

export class SalesInvoiceReportDTO implements ISalesInvoiceReportDTO {
  vouchers: VoucherDTO[] | undefined;
  vouchersTotal: number | undefined;
  vouchersCount: number;
  vouchersAverage: number | undefined;
  vouchersMax: number | undefined;
  vouchersMin: number | undefined;
  vouchersTax: number | undefined;
  vouchersTotalWithoutTax: number | undefined;
  discountTotal: number | undefined;
  bonusTotal: number | undefined;

  constructor(data?: ISalesInvoiceReportDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["vouchers"])) {
        this.vouchers = [] as any;
        for (let item of _data["vouchers"])
          this.vouchers.push(VoucherDTO.fromJS(item));
      }
      this.vouchersTotal = _data["vouchersTotal"];
      this.vouchersCount = _data["vouchersCount"];
      this.vouchersAverage = _data["vouchersAverage"];
      this.vouchersMax = _data["vouchersMax"];
      this.vouchersMin = _data["vouchersMin"];
      this.vouchersTax = _data["vouchersTax"];
      this.vouchersTotalWithoutTax = _data["vouchersTotalWithoutTax"];
      this.discountTotal = _data["discountTotal"];
      this.bonusTotal = _data["bonusTotal"];
    }
  }

  static fromJS(data: any): SalesInvoiceReportDTO {
    data = typeof data === "object" ? data : {};
    let result = new SalesInvoiceReportDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.vouchers)) {
      data["vouchers"] = [];
      for (let item of this.vouchers) data["vouchers"].push(item.toJSON());
    }
    data["vouchersTotal"] = this.vouchersTotal;
    data["vouchersCount"] = this.vouchersCount;
    data["vouchersAverage"] = this.vouchersAverage;
    data["vouchersMax"] = this.vouchersMax;
    data["vouchersMin"] = this.vouchersMin;
    data["vouchersTax"] = this.vouchersTax;
    data["vouchersTotalWithoutTax"] = this.vouchersTotalWithoutTax;
    data["discountTotal"] = this.discountTotal;
    data["bonusTotal"] = this.bonusTotal;
    return data;
  }

  clone(): SalesInvoiceReportDTO {
    const json = this.toJSON();
    let result = new SalesInvoiceReportDTO();
    result.init(json);
    return result;
  }
}

export interface ISalesInvoiceReportDTO {
  vouchers: VoucherDTO[] | undefined;
  vouchersTotal: number | undefined;
  vouchersCount: number;
  vouchersAverage: number | undefined;
  vouchersMax: number | undefined;
  vouchersMin: number | undefined;
  vouchersTax: number | undefined;
  vouchersTotalWithoutTax: number | undefined;
  discountTotal: number | undefined;
  bonusTotal: number | undefined;
}

export class RowMaterialDTO implements IRowMaterialDTO {
  id: number;
  productId: number;
  productName: string | undefined;
  totalProductCost: number | undefined;
  quantity: number | undefined;
  measuringUnitName: string | undefined;
  measuringUnitId: number | undefined;

  constructor(data?: IRowMaterialDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.productId = _data["productId"];
      this.productName = _data["productName"];
      this.totalProductCost = _data["totalProductCost"];
      this.quantity = _data["quantity"];
      this.measuringUnitName = _data["measuringUnitName"];
      this.measuringUnitId = _data["measuringUnitId"];
    }
  }

  static fromJS(data: any): RowMaterialDTO {
    data = typeof data === "object" ? data : {};
    let result = new RowMaterialDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["productId"] = this.productId;
    data["productName"] = this.productName;
    data["totalProductCost"] = this.totalProductCost;
    data["quantity"] = this.quantity;
    data["measuringUnitName"] = this.measuringUnitName;
    data["measuringUnitId"] = this.measuringUnitId;
    return data;
  }

  clone(): RowMaterialDTO {
    const json = this.toJSON();
    let result = new RowMaterialDTO();
    result.init(json);
    return result;
  }
}

export interface IRowMaterialDTO {
  id: number;
  productId: number;
  productName: string | undefined;
  totalProductCost: number | undefined;
  quantity: number | undefined;
  measuringUnitName: string | undefined;
  measuringUnitId: number | undefined;
}

export class ProductSalesDTO implements IProductSalesDTO {
  productMeasuringUnitId: number | undefined;
  totalQuantity: number | undefined;
  totalReturnsQuantity: number | undefined;
  totalNetQuantity: number | undefined;
  productName: string | undefined;
  measuringUnitName: string | undefined;
  pricePerUnit: number | undefined;
  calculatedPricePerUnit: number | undefined;
  totalPrice: number | undefined;
  totalReturnsPrice: number | undefined;
  productTaxvalue: number | undefined;
  productCostPerUnit: number | undefined;
  totalProductCost: number | undefined;
  rowMaterials: RowMaterialDTO[] | undefined;
  netTotalPrice: number | undefined;
  netSales: number | undefined;

  constructor(data?: IProductSalesDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productMeasuringUnitId = _data["productMeasuringUnitId"];
      this.totalQuantity = _data["totalQuantity"];
      this.totalReturnsQuantity = _data["totalReturnsQuantity"];
      this.totalNetQuantity = _data["totalNetQuantity"];
      this.productName = _data["productName"];
      this.measuringUnitName = _data["measuringUnitName"];
      this.pricePerUnit = _data["pricePerUnit"];
      this.calculatedPricePerUnit = _data["calculatedPricePerUnit"];
      this.totalPrice = _data["totalPrice"];
      this.totalReturnsPrice = _data["totalReturnsPrice"];
      this.productTaxvalue = _data["productTaxvalue"];
      this.productCostPerUnit = _data["productCostPerUnit"];
      this.totalProductCost = _data["totalProductCost"];
      if (Array.isArray(_data["rowMaterials"])) {
        this.rowMaterials = [] as any;
        for (let item of _data["rowMaterials"])
          this.rowMaterials.push(RowMaterialDTO.fromJS(item));
      }
      this.netTotalPrice = _data["netTotalPrice"];
      this.netSales = _data["netSales"];
    }
  }

  static fromJS(data: any): ProductSalesDTO {
    data = typeof data === "object" ? data : {};
    let result = new ProductSalesDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["productMeasuringUnitId"] = this.productMeasuringUnitId;
    data["totalQuantity"] = this.totalQuantity;
    data["totalReturnsQuantity"] = this.totalReturnsQuantity;
    data["totalNetQuantity"] = this.totalNetQuantity;
    data["productName"] = this.productName;
    data["measuringUnitName"] = this.measuringUnitName;
    data["pricePerUnit"] = this.pricePerUnit;
    data["calculatedPricePerUnit"] = this.calculatedPricePerUnit;
    data["totalPrice"] = this.totalPrice;
    data["totalReturnsPrice"] = this.totalReturnsPrice;
    data["productTaxvalue"] = this.productTaxvalue;
    data["productCostPerUnit"] = this.productCostPerUnit;
    data["totalProductCost"] = this.totalProductCost;
    if (Array.isArray(this.rowMaterials)) {
      data["rowMaterials"] = [];
      for (let item of this.rowMaterials)
        data["rowMaterials"].push(item.toJSON());
    }
    data["netTotalPrice"] = this.netTotalPrice;
    data["netSales"] = this.netSales;
    return data;
  }

  clone(): ProductSalesDTO {
    const json = this.toJSON();
    let result = new ProductSalesDTO();
    result.init(json);
    return result;
  }
}

export interface IProductSalesDTO {
  productMeasuringUnitId: number | undefined;
  totalQuantity: number | undefined;
  totalReturnsQuantity: number | undefined;
  totalNetQuantity: number | undefined;
  productName: string | undefined;
  measuringUnitName: string | undefined;
  pricePerUnit: number | undefined;
  calculatedPricePerUnit: number | undefined;
  totalPrice: number | undefined;
  totalReturnsPrice: number | undefined;
  productTaxvalue: number | undefined;
  productCostPerUnit: number | undefined;
  totalProductCost: number | undefined;
  rowMaterials: RowMaterialDTO[] | undefined;
  netTotalPrice: number | undefined;
  netSales: number | undefined;
}

export class ProductSalesReportDTO implements IProductSalesReportDTO {
  products: ProductSalesDTO[] | undefined;
  productsTotal: number | undefined;
  productsCount: number;
  productsAverage: number | undefined;
  productsMax: number | undefined;
  productsMin: number | undefined;
  productsTax: number | undefined;
  productsTotalWithoutTax: number | undefined;
  discountTotal: number | undefined;
  bonusTotal: number | undefined;
  constructor(data?: IProductSalesReportDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["products"])) {
        this.products = [] as any;
        for (let item of _data["products"])
          this.products.push(ProductSalesDTO.fromJS(item));
      }
      this.productsTotal = _data["productsTotal"];
      this.productsCount = _data["productsCount"];
      this.productsAverage = _data["productsAverage"];
      this.productsMax = _data["productsMax"];
      this.productsMin = _data["productsMin"];
      this.productsTax = _data["productsTax"];
      this.productsTotalWithoutTax = _data["productsTotalWithoutTax"];
      this.discountTotal = _data["discountTotal"];
      this.bonusTotal = _data["bonusTotal"];
    }
  }

  static fromJS(data: any): ProductSalesReportDTO {
    data = typeof data === "object" ? data : {};
    let result = new ProductSalesReportDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.products)) {
      data["products"] = [];
      for (let item of this.products) data["products"].push(item.toJSON());
    }
    data["productsTotal"] = this.productsTotal;
    data["productsCount"] = this.productsCount;
    data["productsAverage"] = this.productsAverage;
    data["productsMax"] = this.productsMax;
    data["productsMin"] = this.productsMin;
    data["productsTax"] = this.productsTax;
    data["productsTotalWithoutTax"] = this.productsTotalWithoutTax;
    data["discountTotal"] = this.discountTotal;
    data["bonusTotal"] = this.bonusTotal;
    return data;
  }

  clone(): ProductSalesReportDTO {
    const json = this.toJSON();
    let result = new ProductSalesReportDTO();
    result.init(json);
    return result;
  }
}

export interface IProductSalesReportDTO {
  products: ProductSalesDTO[] | undefined;
  productsTotal: number | undefined;
  productsCount: number;
  productsAverage: number | undefined;
  productsMax: number | undefined;
  productsMin: number | undefined;
  productsTax: number | undefined;
  productsTotalWithoutTax: number | undefined;
  discountTotal: number | undefined;
  bonusTotal: number | undefined;
}

export class CustomerMobileReportDTO implements ICustomerMobileReportDTO {
  data: CustomerMobileReportDTO[] | undefined;
  id: number;
  customerMobile: string;
  firstDate: moment.Moment;
  lastDate: moment.Moment;

  constructor(data?: ICustomerMobileReportDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data)) {
        this.data = [] as any;
        for (let item of _data)
          this.data.push(CustomerMobileReportDTO.fromJS(item));
      }
      this.id = _data["id"];
      this.customerMobile = _data["customerMobile"];
      this.firstDate = _data["firstDate"];
      this.lastDate = _data["lastDate"];
    }
  }

  static fromJS(data: any): CustomerMobileReportDTO {
    data = typeof data === "object" ? data : {};
    let result = new CustomerMobileReportDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};

    data["id"] = this.id;
    data["customerMobile"] = this.customerMobile;
    data["firstDate"] = this.firstDate;
    data["lastDate"] = this.lastDate;

    return data;
  }

  clone(): CustomerMobileReportDTO {
    const json = this.toJSON();
    let result = new CustomerMobileReportDTO();
    result.init(json);
    return result;
  }
}

export interface ICustomerMobileReportDTO {
  id: number;
  customerMobile: string;
  firstDate: moment.Moment;
  lastDate: moment.Moment;
}

export class ClientMobileFilterDto implements IClientMobileFilterDto {
  CustomerMobile: string = "";
  FromDate: Date | null;
  ToDate: Date | null;
}
export interface IClientMobileFilterDto {
  CustomerMobile: string;
  FromDate: Date;
  ToDate: Date;
}
export class CustomersProductsReportFilterDto
  implements ICustomersProductsReportFilterDto
{
  CustomerMobile: string = "";
  FromDate: Date | null;
  ToDate: Date | null;
  ProductId: number;
}
export interface ICustomersProductsReportFilterDto {
  CustomerMobile: string;
  FromDate: Date;
  ToDate: Date;
  ProductId: number;
}
export class CustomersProductsReportDTO implements ICustomersProductsReportDTO {
  data: CustomersProductsReportDTO[] | undefined;
  id: number;
  customerMobile: string;
  productName: string;
  quantity: number;
  voucherDate: moment.Moment;

  constructor(data?: ICustomersProductsReportDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data)) {
        this.data = [] as any;
        for (let item of _data)
          this.data.push(CustomersProductsReportDTO.fromJS(item));
      }
      this.id = _data["id"];
      this.customerMobile = _data["customerMobile"];
      this.productName = _data["productName"];
      this.quantity = _data["quantity"];
      this.voucherDate = _data["voucherDate"];
    }
  }

  static fromJS(data: any): CustomersProductsReportDTO {
    data = typeof data === "object" ? data : {};
    let result = new CustomersProductsReportDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};

    data["id"] = this.id;
    data["customerMobile"] = this.customerMobile;
    data["productName"] = this.productName;
    data["quantity"] = this.quantity;
    data["voucherDate"] = this.voucherDate;

    return data;
  }

  clone(): CustomersProductsReportDTO {
    const json = this.toJSON();
    let result = new CustomersProductsReportDTO();
    result.init(json);
    return result;
  }
}

export interface ICustomersProductsReportDTO {
  id: number;
  customerMobile: string;
  productName: string;
  quantity: number;
  voucherDate: moment.Moment;
}

export class ProductSalesAndCostReportDTO
  implements IProductSalesAndCostReportDTO
{
  products: ProductSalesDTO[] | undefined;
  productsTotal: number | undefined;
  productsCount: number;
  productsAverage: number | undefined;
  productsMax: number | undefined;
  productsMin: number | undefined;
  productsTax: number | undefined;
  productsTotalWithoutTax: number | undefined;
  discountTotal: number | undefined;
  bonusTotal: number | undefined;
  netSalesTotal: number | undefined;

  constructor(data?: IProductSalesAndCostReportDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["products"])) {
        this.products = [] as any;
        for (let item of _data["products"])
          this.products.push(ProductSalesDTO.fromJS(item));
      }
      this.productsTotal = _data["productsTotal"];
      this.productsCount = _data["productsCount"];
      this.productsAverage = _data["productsAverage"];
      this.productsMax = _data["productsMax"];
      this.productsMin = _data["productsMin"];
      this.productsTax = _data["productsTax"];
      this.productsTotalWithoutTax = _data["productsTotalWithoutTax"];
      this.discountTotal = _data["discountTotal"];
      this.bonusTotal = _data["bonusTotal"];
      this.netSalesTotal = _data["netSalesTotal"];
    }
  }

  static fromJS(data: any): ProductSalesAndCostReportDTO {
    data = typeof data === "object" ? data : {};
    let result = new ProductSalesAndCostReportDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.products)) {
      data["products"] = [];
      for (let item of this.products) data["products"].push(item.toJSON());
    }
    data["productsTotal"] = this.productsTotal;
    data["productsCount"] = this.productsCount;
    data["productsAverage"] = this.productsAverage;
    data["productsMax"] = this.productsMax;
    data["productsMin"] = this.productsMin;
    data["productsTax"] = this.productsTax;
    data["productsTotalWithoutTax"] = this.productsTotalWithoutTax;
    data["discountTotal"] = this.discountTotal;
    data["bonusTotal"] = this.bonusTotal;
    data["netSalesTotal"] = this.netSalesTotal;
    return data;
  }

  clone(): ProductSalesAndCostReportDTO {
    const json = this.toJSON();
    let result = new ProductSalesAndCostReportDTO();
    result.init(json);
    return result;
  }
}

export interface IProductSalesAndCostReportDTO {
  products: ProductSalesDTO[] | undefined;
  productsTotal: number | undefined;
  productsCount: number;
  productsAverage: number | undefined;
  productsMax: number | undefined;
  productsMin: number | undefined;
  productsTax: number | undefined;
  productsTotalWithoutTax: number | undefined;
  discountTotal: number | undefined;
  bonusTotal: number | undefined;
  netSalesTotal: number | undefined;
}

export class PrintHeaderDTO implements IPrintHeaderDTO {
  image: string | undefined;
  posShortDescription: string | undefined;
  posAdress: string | undefined;
  companyName: string | undefined;

  constructor(data?: IPrintHeaderDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.image = _data["image"];
      this.posShortDescription = _data["posShortDescription"];
      this.posAdress = _data["posAdress"];
      this.companyName = _data["companyName"];
    }
  }

  static fromJS(data: any): PrintHeaderDTO {
    data = typeof data === "object" ? data : {};
    let result = new PrintHeaderDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["image"] = this.image;
    data["posShortDescription"] = this.posShortDescription;
    data["posAdress"] = this.posAdress;
    data["companyName"] = this.companyName;
    return data;
  }

  clone(): PrintHeaderDTO {
    const json = this.toJSON();
    let result = new PrintHeaderDTO();
    result.init(json);
    return result;
  }
}

export interface IPrintHeaderDTO {
  image: string | undefined;
  posShortDescription: string | undefined;
  posAdress: string | undefined;
  companyName: string | undefined;
}

export class ReportsFillterDTO implements IReportsFillterDTO {
  date: moment.Moment;
  posId: number | undefined;
  changePOS: boolean;

  constructor(data?: IReportsFillterDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.date = _data["date"]
        ? moment(_data["date"].toString())
        : <any>undefined;
      this.posId = _data["posId"];
      this.changePOS = _data["changePOS"];
    }
  }

  static fromJS(data: any): ReportsFillterDTO {
    data = typeof data === "object" ? data : {};
    let result = new ReportsFillterDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    data["posId"] = this.posId;
    data["changePOS"] = this.changePOS;
    return data;
  }

  clone(): ReportsFillterDTO {
    const json = this.toJSON();
    let result = new ReportsFillterDTO();
    result.init(json);
    return result;
  }
}

export interface IReportsFillterDTO {
  date: moment.Moment;
  posId: number | undefined;
  changePOS: boolean;
}

export class ShiftDTO implements IShiftDTO {
  id: number;
  shiftCode: string | undefined;
  dayNo: number;
  fromTime: moment.Moment;
  toTime: moment.Moment;

  constructor(data?: IShiftDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.shiftCode = _data["shiftCode"];
      this.dayNo = _data["dayNo"];
      this.fromTime = _data["fromTime"]
        ? moment(_data["fromTime"].toString())
        : <any>undefined;
      this.toTime = _data["toTime"]
        ? moment(_data["toTime"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): ShiftDTO {
    data = typeof data === "object" ? data : {};
    let result = new ShiftDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["shiftCode"] = this.shiftCode;
    data["dayNo"] = this.dayNo;
    data["fromTime"] = this.fromTime
      ? this.fromTime.toISOString()
      : <any>undefined;
    data["toTime"] = this.toTime ? this.toTime.toISOString() : <any>undefined;
    return data;
  }

  clone(): ShiftDTO {
    const json = this.toJSON();
    let result = new ShiftDTO();
    result.init(json);
    return result;
  }
}

export interface IShiftDTO {
  id: number;
  shiftCode: string | undefined;
  dayNo: number;
  fromTime: moment.Moment;
  toTime: moment.Moment;
}

export class RecievingBankDetailsDTO implements IRecievingBankDetailsDTO {
  id: number;
  transactionId: number | undefined;
  bankId: number | undefined;
  shiftId: number | undefined;
  cashierNID: string | undefined;
  cashierNATCode: number | undefined;
  bankRecievingDate: moment.Moment | undefined;
  bankRecievingTime: moment.Moment | undefined;
  openingValue: number | undefined;
  notes: string | undefined;
  shift: ShiftDTO;

  constructor(data?: IRecievingBankDetailsDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.transactionId = _data["transactionId"];
      this.bankId = _data["bankId"];
      this.shiftId = _data["shiftId"];
      this.cashierNID = _data["cashierNID"];
      this.cashierNATCode = _data["cashierNATCode"];
      this.bankRecievingDate = _data["bankRecievingDate"]
        ? moment(_data["bankRecievingDate"].toString())
        : <any>undefined;
      this.bankRecievingTime = _data["bankRecievingTime"]
        ? moment(_data["bankRecievingTime"].toString())
        : <any>undefined;
      this.openingValue = _data["openingValue"];
      this.notes = _data["notes"];
      this.shift = _data["shift"]
        ? ShiftDTO.fromJS(_data["shift"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): RecievingBankDetailsDTO {
    data = typeof data === "object" ? data : {};
    let result = new RecievingBankDetailsDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["transactionId"] = this.transactionId;
    data["bankId"] = this.bankId;
    data["shiftId"] = this.shiftId;
    data["cashierNID"] = this.cashierNID;
    data["cashierNATCode"] = this.cashierNATCode;
    data["bankRecievingDate"] = this.bankRecievingDate
      ? this.bankRecievingDate.toISOString()
      : <any>undefined;
    data["bankRecievingTime"] = this.bankRecievingTime
      ? this.bankRecievingTime.toISOString()
      : <any>undefined;
    data["openingValue"] = this.openingValue;
    data["notes"] = this.notes;
    data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
    return data;
  }

  clone(): RecievingBankDetailsDTO {
    const json = this.toJSON();
    let result = new RecievingBankDetailsDTO();
    result.init(json);
    return result;
  }
}

export interface IRecievingBankDetailsDTO {
  id: number;
  transactionId: number | undefined;
  bankId: number | undefined;
  shiftId: number | undefined;
  cashierNID: string | undefined;
  cashierNATCode: number | undefined;
  bankRecievingDate: moment.Moment | undefined;
  bankRecievingTime: moment.Moment | undefined;
  openingValue: number | undefined;
  notes: string | undefined;
  shift: ShiftDTO;
}

export class DeliveringBankDetailsDTO implements IDeliveringBankDetailsDTO {
  id: number;
  transactionId: number | undefined;
  bankId: number | undefined;
  shiftId: number | undefined;
  cashierNID: string | undefined;
  cashierNATCode: number | undefined;
  bankDeliveringDate: moment.Moment | undefined;
  bankDeliveringTime: moment.Moment | undefined;
  closingValue: number | undefined;
  calculatedValue: number | undefined;
  notes: string | undefined;
  closingVisaValue: number | undefined;
  calculatedVisaValues: number | undefined;
  closingMasterValue: number | undefined;
  calculatedMasterValues: number | undefined;
  closingMadaValue: number | undefined;
  calculatedMadaValues: number | undefined;
  closingMoneyTransferValue: number | undefined;
  calculatedMoneyTransferValues: number | undefined;

  constructor(data?: IDeliveringBankDetailsDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.transactionId = _data["transactionId"];
      this.bankId = _data["bankId"];
      this.shiftId = _data["shiftId"];
      this.cashierNID = _data["cashierNID"];
      this.cashierNATCode = _data["cashierNATCode"];
      this.bankDeliveringDate = _data["bankDeliveringDate"]
        ? moment(_data["bankDeliveringDate"].toString())
        : <any>undefined;
      this.bankDeliveringTime = _data["bankDeliveringTime"]
        ? moment(_data["bankDeliveringTime"].toString())
        : <any>undefined;
      this.closingValue = _data["closingValue"];
      this.calculatedValue = _data["calculatedValue"];
      this.notes = _data["notes"];
      this.closingVisaValue = _data["closingVisaValue"];
      this.calculatedVisaValues = _data["calculatedVisaValues"];
      this.closingMasterValue = _data["closingMasterValue"];
      this.calculatedMasterValues = _data["calculatedMasterValues"];
      this.closingMadaValue = _data["closingMadaValue"];
      this.calculatedMadaValues = _data["calculatedMadaValues"];
      this.closingMoneyTransferValue = _data["closingMoneyTransferValue"];
      this.calculatedMoneyTransferValues =
        _data["calculatedMoneyTransferValues"];
    }
  }

  static fromJS(data: any): DeliveringBankDetailsDTO {
    data = typeof data === "object" ? data : {};
    let result = new DeliveringBankDetailsDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["transactionId"] = this.transactionId;
    data["bankId"] = this.bankId;
    data["shiftId"] = this.shiftId;
    data["cashierNID"] = this.cashierNID;
    data["cashierNATCode"] = this.cashierNATCode;
    data["bankDeliveringDate"] = this.bankDeliveringDate
      ? this.bankDeliveringDate.toISOString()
      : <any>undefined;
    data["bankDeliveringTime"] = this.bankDeliveringTime
      ? this.bankDeliveringTime.toISOString()
      : <any>undefined;
    data["closingValue"] = this.closingValue;
    data["calculatedValue"] = this.calculatedValue;
    data["notes"] = this.notes;
    data["closingVisaValue"] = this.closingVisaValue;
    data["calculatedVisaValues"] = this.calculatedVisaValues;
    data["closingMasterValue"] = this.closingMasterValue;
    data["calculatedMasterValues"] = this.calculatedMasterValues;
    data["closingMadaValue"] = this.closingMadaValue;
    data["calculatedMadaValues"] = this.calculatedMadaValues;
    data["closingMoneyTransferValue"] = this.closingMoneyTransferValue;
    data["calculatedMoneyTransferValues"] = this.calculatedMoneyTransferValues;
    return data;
  }

  clone(): DeliveringBankDetailsDTO {
    const json = this.toJSON();
    let result = new DeliveringBankDetailsDTO();
    result.init(json);
    return result;
  }
}

export interface IDeliveringBankDetailsDTO {
  id: number;
  transactionId: number | undefined;
  bankId: number | undefined;
  shiftId: number | undefined;
  cashierNID: string | undefined;
  cashierNATCode: number | undefined;
  bankDeliveringDate: moment.Moment | undefined;
  bankDeliveringTime: moment.Moment | undefined;
  closingValue: number | undefined;
  calculatedValue: number | undefined;
  notes: string | undefined;
  closingVisaValue: number | undefined;
  calculatedVisaValues: number | undefined;
  closingMasterValue: number | undefined;
  calculatedMasterValues: number | undefined;
  closingMadaValue: number | undefined;
  calculatedMadaValues: number | undefined;
  closingMoneyTransferValue: number | undefined;
  calculatedMoneyTransferValues: number | undefined;
}

export class ShiftDetailsDTO implements IShiftDetailsDTO {
  shiftCashierId: number;
  personName: string | undefined;
  shift: ShiftDTO;
  bankName: string | undefined;
  totalPayments: number;
  totalRevenues: number;
  recievingBankDetails: RecievingBankDetailsDTO;
  deliveringBankDetails: DeliveringBankDetailsDTO;

  constructor(data?: IShiftDetailsDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.shiftCashierId = _data["shiftCashierId"];
      this.personName = _data["personName"];
      this.shift = _data["shift"]
        ? ShiftDTO.fromJS(_data["shift"])
        : <any>undefined;
      this.bankName = _data["bankName"];
      this.totalPayments = _data["totalPayments"];
      this.totalRevenues = _data["totalRevenues"];
      this.recievingBankDetails = _data["recievingBankDetails"]
        ? RecievingBankDetailsDTO.fromJS(_data["recievingBankDetails"])
        : <any>undefined;
      this.deliveringBankDetails = _data["deliveringBankDetails"]
        ? DeliveringBankDetailsDTO.fromJS(_data["deliveringBankDetails"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ShiftDetailsDTO {
    data = typeof data === "object" ? data : {};
    let result = new ShiftDetailsDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["shiftCashierId"] = this.shiftCashierId;
    data["personName"] = this.personName;
    data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
    data["bankName"] = this.bankName;
    data["totalPayments"] = this.totalPayments;
    data["totalRevenues"] = this.totalRevenues;
    data["recievingBankDetails"] = this.recievingBankDetails
      ? this.recievingBankDetails.toJSON()
      : <any>undefined;
    data["deliveringBankDetails"] = this.deliveringBankDetails
      ? this.deliveringBankDetails.toJSON()
      : <any>undefined;
    return data;
  }

  clone(): ShiftDetailsDTO {
    const json = this.toJSON();
    let result = new ShiftDetailsDTO();
    result.init(json);
    return result;
  }
}

export interface IShiftDetailsDTO {
  shiftCashierId: number;
  personName: string | undefined;
  shift: ShiftDTO;
  bankName: string | undefined;
  totalPayments: number;
  totalRevenues: number;
  recievingBankDetails: RecievingBankDetailsDTO;
  deliveringBankDetails: DeliveringBankDetailsDTO;
}

export class ShiftDetailsDTOListResultDto
  implements IShiftDetailsDTOListResultDto
{
  items: ShiftDetailsDTO[] | undefined;

  constructor(data?: IShiftDetailsDTOListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(ShiftDetailsDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ShiftDetailsDTOListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new ShiftDetailsDTOListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): ShiftDetailsDTOListResultDto {
    const json = this.toJSON();
    let result = new ShiftDetailsDTOListResultDto();
    result.init(json);
    return result;
  }
}

export interface IShiftDetailsDTOListResultDto {
  items: ShiftDetailsDTO[] | undefined;
}

export class ProductSummaryDTO implements IProductSummaryDTO {
  productMeasuringUnitId: number | undefined;
  totalQuantity: number | undefined;
  productName: string | undefined;
  measuringUnitName: string | undefined;
  pricePerUnit: number | undefined;

  constructor(data?: IProductSummaryDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productMeasuringUnitId = _data["productMeasuringUnitId"];
      this.totalQuantity = _data["totalQuantity"];
      this.productName = _data["productName"];
      this.measuringUnitName = _data["measuringUnitName"];
      this.pricePerUnit = _data["pricePerUnit"];
    }
  }

  static fromJS(data: any): ProductSummaryDTO {
    data = typeof data === "object" ? data : {};
    let result = new ProductSummaryDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["productMeasuringUnitId"] = this.productMeasuringUnitId;
    data["totalQuantity"] = this.totalQuantity;
    data["productName"] = this.productName;
    data["measuringUnitName"] = this.measuringUnitName;
    data["pricePerUnit"] = this.pricePerUnit;
    return data;
  }

  clone(): ProductSummaryDTO {
    const json = this.toJSON();
    let result = new ProductSummaryDTO();
    result.init(json);
    return result;
  }
}

export interface IProductSummaryDTO {
  productMeasuringUnitId: number | undefined;
  totalQuantity: number | undefined;
  productName: string | undefined;
  measuringUnitName: string | undefined;
  pricePerUnit: number | undefined;
}

export class ProductSummaryDTOListResultDto
  implements IProductSummaryDTOListResultDto
{
  items: ProductSummaryDTO[] | undefined;

  constructor(data?: IProductSummaryDTOListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(ProductSummaryDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ProductSummaryDTOListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new ProductSummaryDTOListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): ProductSummaryDTOListResultDto {
    const json = this.toJSON();
    let result = new ProductSummaryDTOListResultDto();
    result.init(json);
    return result;
  }
}

export interface IProductSummaryDTOListResultDto {
  items: ProductSummaryDTO[] | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
  tenancyName: string;
  name: string;
  adminEmailAddress: string;
  connectionString: string | undefined;
  isActive: boolean;

  constructor(data?: ICreateTenantDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data["tenancyName"];
      this.name = _data["name"];
      this.adminEmailAddress = _data["adminEmailAddress"];
      this.connectionString = _data["connectionString"];
      this.isActive = _data["isActive"];
    }
  }

  static fromJS(data: any): CreateTenantDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateTenantDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["tenancyName"] = this.tenancyName;
    data["name"] = this.name;
    data["adminEmailAddress"] = this.adminEmailAddress;
    data["connectionString"] = this.connectionString;
    data["isActive"] = this.isActive;
    return data;
  }

  clone(): CreateTenantDto {
    const json = this.toJSON();
    let result = new CreateTenantDto();
    result.init(json);
    return result;
  }
}

export interface ICreateTenantDto {
  tenancyName: string;
  name: string;
  adminEmailAddress: string;
  connectionString: string | undefined;
  isActive: boolean;
}

export class TenantDto implements ITenantDto {
  tenancyName: string;
  name: string;
  isActive: boolean;
  id: number;

  constructor(data?: ITenantDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data["tenancyName"];
      this.name = _data["name"];
      this.isActive = _data["isActive"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TenantDto {
    data = typeof data === "object" ? data : {};
    let result = new TenantDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["tenancyName"] = this.tenancyName;
    data["name"] = this.name;
    data["isActive"] = this.isActive;
    data["id"] = this.id;
    return data;
  }

  clone(): TenantDto {
    const json = this.toJSON();
    let result = new TenantDto();
    result.init(json);
    return result;
  }
}

export interface ITenantDto {
  tenancyName: string;
  name: string;
  isActive: boolean;
  id: number;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
  totalCount: number;
  items: TenantDto[] | undefined;

  constructor(data?: ITenantDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(TenantDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): TenantDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new TenantDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): TenantDtoPagedResultDto {
    const json = this.toJSON();
    let result = new TenantDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface ITenantDtoPagedResultDto {
  totalCount: number;
  items: TenantDto[] | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
  userNameOrEmailAddress: string;
  password: string;
  rememberClient: boolean;

  constructor(data?: IAuthenticateModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
      this.password = _data["password"];
      this.rememberClient = _data["rememberClient"];
    }
  }

  static fromJS(data: any): AuthenticateModel {
    data = typeof data === "object" ? data : {};
    let result = new AuthenticateModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
    data["password"] = this.password;
    data["rememberClient"] = this.rememberClient;
    return data;
  }

  clone(): AuthenticateModel {
    const json = this.toJSON();
    let result = new AuthenticateModel();
    result.init(json);
    return result;
  }
}

export interface IAuthenticateModel {
  userNameOrEmailAddress: string;
  password: string;
  rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
  userId: number;

  constructor(data?: IAuthenticateResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data["accessToken"];
      this.encryptedAccessToken = _data["encryptedAccessToken"];
      this.expireInSeconds = _data["expireInSeconds"];
      this.userId = _data["userId"];
    }
  }

  static fromJS(data: any): AuthenticateResultModel {
    data = typeof data === "object" ? data : {};
    let result = new AuthenticateResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["accessToken"] = this.accessToken;
    data["encryptedAccessToken"] = this.encryptedAccessToken;
    data["expireInSeconds"] = this.expireInSeconds;
    data["userId"] = this.userId;
    return data;
  }

  clone(): AuthenticateResultModel {
    const json = this.toJSON();
    let result = new AuthenticateResultModel();
    result.init(json);
    return result;
  }
}

export interface IAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
  userId: number;
}

export class ExternalLoginProviderInfoModel
  implements IExternalLoginProviderInfoModel
{
  name: string | undefined;
  clientId: string | undefined;

  constructor(data?: IExternalLoginProviderInfoModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.clientId = _data["clientId"];
    }
  }

  static fromJS(data: any): ExternalLoginProviderInfoModel {
    data = typeof data === "object" ? data : {};
    let result = new ExternalLoginProviderInfoModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["clientId"] = this.clientId;
    return data;
  }

  clone(): ExternalLoginProviderInfoModel {
    const json = this.toJSON();
    let result = new ExternalLoginProviderInfoModel();
    result.init(json);
    return result;
  }
}

export interface IExternalLoginProviderInfoModel {
  name: string | undefined;
  clientId: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
  authProvider: string;
  providerKey: string;
  providerAccessCode: string;

  constructor(data?: IExternalAuthenticateModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.authProvider = _data["authProvider"];
      this.providerKey = _data["providerKey"];
      this.providerAccessCode = _data["providerAccessCode"];
    }
  }

  static fromJS(data: any): ExternalAuthenticateModel {
    data = typeof data === "object" ? data : {};
    let result = new ExternalAuthenticateModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["authProvider"] = this.authProvider;
    data["providerKey"] = this.providerKey;
    data["providerAccessCode"] = this.providerAccessCode;
    return data;
  }

  clone(): ExternalAuthenticateModel {
    const json = this.toJSON();
    let result = new ExternalAuthenticateModel();
    result.init(json);
    return result;
  }
}

export interface IExternalAuthenticateModel {
  authProvider: string;
  providerKey: string;
  providerAccessCode: string;
}

export class ExternalAuthenticateResultModel
  implements IExternalAuthenticateResultModel
{
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
  waitingForActivation: boolean;

  constructor(data?: IExternalAuthenticateResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data["accessToken"];
      this.encryptedAccessToken = _data["encryptedAccessToken"];
      this.expireInSeconds = _data["expireInSeconds"];
      this.waitingForActivation = _data["waitingForActivation"];
    }
  }

  static fromJS(data: any): ExternalAuthenticateResultModel {
    data = typeof data === "object" ? data : {};
    let result = new ExternalAuthenticateResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["accessToken"] = this.accessToken;
    data["encryptedAccessToken"] = this.encryptedAccessToken;
    data["expireInSeconds"] = this.expireInSeconds;
    data["waitingForActivation"] = this.waitingForActivation;
    return data;
  }

  clone(): ExternalAuthenticateResultModel {
    const json = this.toJSON();
    let result = new ExternalAuthenticateResultModel();
    result.init(json);
    return result;
  }
}

export interface IExternalAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
  waitingForActivation: boolean;
}

export class UserDto implements IUserDto {
  userName: string;
  name: string;
  surname: string;
  emailAddress: string;
  isActive: boolean;
  fullName: string | undefined;
  lastLoginTime: moment.Moment | undefined;
  creationTime: moment.Moment;
  roleNames: string[] | undefined;
  id: number;

  constructor(data?: IUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName = _data["userName"];
      this.name = _data["name"];
      this.surname = _data["surname"];
      this.emailAddress = _data["emailAddress"];
      this.isActive = _data["isActive"];
      this.fullName = _data["fullName"];
      this.lastLoginTime = _data["lastLoginTime"]
        ? moment(_data["lastLoginTime"].toString())
        : <any>undefined;
      this.creationTime = _data["creationTime"]
        ? moment(_data["creationTime"].toString())
        : <any>undefined;
      if (Array.isArray(_data["roleNames"])) {
        this.roleNames = [] as any;
        for (let item of _data["roleNames"]) this.roleNames.push(item);
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): UserDto {
    data = typeof data === "object" ? data : {};
    let result = new UserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userName"] = this.userName;
    data["name"] = this.name;
    data["surname"] = this.surname;
    data["emailAddress"] = this.emailAddress;
    data["isActive"] = this.isActive;
    data["fullName"] = this.fullName;
    data["lastLoginTime"] = this.lastLoginTime
      ? this.lastLoginTime.toISOString()
      : <any>undefined;
    data["creationTime"] = this.creationTime
      ? this.creationTime.toISOString()
      : <any>undefined;
    if (Array.isArray(this.roleNames)) {
      data["roleNames"] = [];
      for (let item of this.roleNames) data["roleNames"].push(item);
    }
    data["id"] = this.id;
    return data;
  }

  clone(): UserDto {
    const json = this.toJSON();
    let result = new UserDto();
    result.init(json);
    return result;
  }
}

export interface IUserDto {
  userName: string;
  name: string;
  surname: string;
  emailAddress: string;
  isActive: boolean;
  fullName: string | undefined;
  lastLoginTime: moment.Moment | undefined;
  creationTime: moment.Moment;
  roleNames: string[] | undefined;
  id: number;
}

export class UserDtoListResultDto implements IUserDtoListResultDto {
  items: UserDto[] | undefined;

  constructor(data?: IUserDtoListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items.push(UserDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UserDtoListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new UserDtoListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): UserDtoListResultDto {
    const json = this.toJSON();
    let result = new UserDtoListResultDto();
    result.init(json);
    return result;
  }
}

export interface IUserDtoListResultDto {
  items: UserDto[] | undefined;
}

export class CreateUserDto implements ICreateUserDto {
  userName: string;
  name: string;
  surname: string;
  emailAddress: string;
  isActive: boolean;
  roleNames: string[] | undefined;
  password: string;

  constructor(data?: ICreateUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName = _data["userName"];
      this.name = _data["name"];
      this.surname = _data["surname"];
      this.emailAddress = _data["emailAddress"];
      this.isActive = _data["isActive"];
      if (Array.isArray(_data["roleNames"])) {
        this.roleNames = [] as any;
        for (let item of _data["roleNames"]) this.roleNames.push(item);
      }
      this.password = _data["password"];
    }
  }

  static fromJS(data: any): CreateUserDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userName"] = this.userName;
    data["name"] = this.name;
    data["surname"] = this.surname;
    data["emailAddress"] = this.emailAddress;
    data["isActive"] = this.isActive;
    if (Array.isArray(this.roleNames)) {
      data["roleNames"] = [];
      for (let item of this.roleNames) data["roleNames"].push(item);
    }
    data["password"] = this.password;
    return data;
  }

  clone(): CreateUserDto {
    const json = this.toJSON();
    let result = new CreateUserDto();
    result.init(json);
    return result;
  }
}

export interface ICreateUserDto {
  userName: string;
  name: string;
  surname: string;
  emailAddress: string;
  isActive: boolean;
  roleNames: string[] | undefined;
  password: string;
}

export class Int64EntityDto implements IInt64EntityDto {
  id: number;

  constructor(data?: IInt64EntityDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Int64EntityDto {
    data = typeof data === "object" ? data : {};
    let result = new Int64EntityDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    return data;
  }

  clone(): Int64EntityDto {
    const json = this.toJSON();
    let result = new Int64EntityDto();
    result.init(json);
    return result;
  }
}

export interface IInt64EntityDto {
  id: number;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
  items: RoleDto[] | undefined;

  constructor(data?: IRoleDtoListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items.push(RoleDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RoleDtoListResultDto {
    data = typeof data === "object" ? data : {};
    let result = new RoleDtoListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): RoleDtoListResultDto {
    const json = this.toJSON();
    let result = new RoleDtoListResultDto();
    result.init(json);
    return result;
  }
}

export interface IRoleDtoListResultDto {
  items: RoleDto[] | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
  languageName: string;

  constructor(data?: IChangeUserLanguageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.languageName = _data["languageName"];
    }
  }

  static fromJS(data: any): ChangeUserLanguageDto {
    data = typeof data === "object" ? data : {};
    let result = new ChangeUserLanguageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["languageName"] = this.languageName;
    return data;
  }

  clone(): ChangeUserLanguageDto {
    const json = this.toJSON();
    let result = new ChangeUserLanguageDto();
    result.init(json);
    return result;
  }
}

export interface IChangeUserLanguageDto {
  languageName: string;
}

export class ChangePasswordDto implements IChangePasswordDto {
  currentPassword: string;
  newPassword: string;

  constructor(data?: IChangePasswordDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currentPassword = _data["currentPassword"];
      this.newPassword = _data["newPassword"];
    }
  }

  static fromJS(data: any): ChangePasswordDto {
    data = typeof data === "object" ? data : {};
    let result = new ChangePasswordDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["currentPassword"] = this.currentPassword;
    data["newPassword"] = this.newPassword;
    return data;
  }

  clone(): ChangePasswordDto {
    const json = this.toJSON();
    let result = new ChangePasswordDto();
    result.init(json);
    return result;
  }
}

export interface IChangePasswordDto {
  currentPassword: string;
  newPassword: string;
}

export class ResetPasswordDto implements IResetPasswordDto {
  adminPassword: string;
  userId: number;
  newPassword: string;

  constructor(data?: IResetPasswordDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.adminPassword = _data["adminPassword"];
      this.userId = _data["userId"];
      this.newPassword = _data["newPassword"];
    }
  }

  static fromJS(data: any): ResetPasswordDto {
    data = typeof data === "object" ? data : {};
    let result = new ResetPasswordDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["adminPassword"] = this.adminPassword;
    data["userId"] = this.userId;
    data["newPassword"] = this.newPassword;
    return data;
  }

  clone(): ResetPasswordDto {
    const json = this.toJSON();
    let result = new ResetPasswordDto();
    result.init(json);
    return result;
  }
}

export interface IResetPasswordDto {
  adminPassword: string;
  userId: number;
  newPassword: string;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
  totalCount: number;
  items: UserDto[] | undefined;

  constructor(data?: IUserDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items.push(UserDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UserDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new UserDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): UserDtoPagedResultDto {
    const json = this.toJSON();
    let result = new UserDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface IUserDtoPagedResultDto {
  totalCount: number;
  items: UserDto[] | undefined;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else
    return _observableThrow(
      new ApiException(message, status, response, headers, null)
    );
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((<any>event.target).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
